export const restaurants = {
  type: "FeatureCollection",
  name: "restaurants",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435364,
        lng: 12.33665,
        name: "RioVenice",
        numreviews: 175,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10002247-Reviews-RioVenice-Venice_Veneto.html",
        percent_ital: 0.13142857,
        diversity_index_2: 0.35500515,
        diversity_index_3: -0.64499485,
        composite_ital_3: 3.0649147,
      },
      geometry: { type: "Point", coordinates: [12.33665, 45.43536] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.43961,
        lng: 12.331915,
        name: "Bar San Cassian",
        numreviews: 65,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10023063-Reviews-Bar_San_Cassian-Venice_Veneto.html",
        percent_ital: 0.030769231,
        diversity_index_2: 0.3482143,
        diversity_index_3: -0.65178573,
        composite_ital_3: 4.5361772,
      },
      geometry: { type: "Point", coordinates: [12.33192, 45.43961] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438446,
        lng: 12.340159,
        name: "Bat Bar Lounge & Terrace",
        numreviews: 41,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10053485-Reviews-Bat_Bar_Lounge_Terrace-Venice_Veneto.html",
        percent_ital: 0.073170729,
        diversity_index_2: 0.80296898,
        diversity_index_3: -0.19703102,
        composite_ital_3: 2.834399,
      },
      geometry: { type: "Point", coordinates: [12.34016, 45.43845] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434742,
        lng: 12.33742,
        name: "Ai Do Dai",
        numreviews: 36,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10092143-Reviews-Ai_Do_Dai-Venice_Veneto.html",
        percent_ital: 0.27777779,
        diversity_index_2: 0.55555558,
        diversity_index_3: -0.44444442,
        composite_ital_3: 1.8687204,
      },
      geometry: { type: "Point", coordinates: [12.33742, 45.43474] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436863,
        lng: 12.339758,
        name: "Ristorante Mondo Novo",
        numreviews: 584,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1010638-Reviews-Ristorante_Mondo_Novo-Venice_Veneto.html",
        percent_ital: 0.5188356,
        diversity_index_2: 0.29507789,
        diversity_index_3: -0.70492208,
        composite_ital_3: 1.8766842,
      },
      geometry: { type: "Point", coordinates: [12.33976, 45.43686] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.439251,
        lng: 12.32115,
        name: "Angolo Del Gusto",
        numreviews: 21,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10140274-Reviews-Angolo_Del_Gusto-Venice_Veneto.html",
        percent_ital: 0.42857143,
        diversity_index_2: 0.1025641,
        diversity_index_3: -0.8974359,
        composite_ital_3: 3.1245651,
      },
      geometry: { type: "Point", coordinates: [12.32115, 45.43925] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439625,
        lng: 12.337113,
        name: "Ai DiVini",
        numreviews: 111,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10146456-Reviews-Ai_DiVini-Venice_Veneto.html",
        percent_ital: 0.3963964,
        diversity_index_2: 0.36962247,
        diversity_index_3: -0.63037753,
        composite_ital_3: 1.9206138,
      },
      geometry: { type: "Point", coordinates: [12.33711, 45.43962] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.441429,
        lng: 12.32089,
        name: "Relax & Caffe",
        numreviews: 166,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10147384-Reviews-Relax_Caffe-Venice_Veneto.html",
        percent_ital: 0.48192772,
        diversity_index_2: 0.29928499,
        diversity_index_3: -0.70071501,
        composite_ital_3: 1.9363202,
      },
      geometry: { type: "Point", coordinates: [12.32089, 45.44143] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.428223,
        lng: 12.31811,
        name: "Hilton Molino Stucky Venice",
        numreviews: 125,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10147387-Reviews-Hilton_Molino_Stucky_Venice-Venice_Veneto.html",
        percent_ital: 0.12,
        diversity_index_2: 0.53120393,
        diversity_index_3: -0.46879607,
        composite_ital_3: 2.7528729,
      },
      geometry: { type: "Point", coordinates: [12.31811, 45.42822] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.434841,
        lng: 12.323794,
        name: "Skilla Bar",
        numreviews: 41,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10159115-Reviews-Skilla_Bar-Venice_Veneto.html",
        percent_ital: 0.41463414,
        diversity_index_2: 0.41230768,
        diversity_index_3: -0.58769232,
        composite_ital_3: 1.7663442,
      },
      geometry: { type: "Point", coordinates: [12.32379, 45.43484] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437252,
        lng: 12.328061,
        name: "Ristorante Rio Frari",
        numreviews: 88,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10237215-Reviews-Ristorante_Rio_Frari-Venice_Veneto.html",
        percent_ital: 0.10227273,
        diversity_index_2: 0.32278481,
        diversity_index_3: -0.67721522,
        composite_ital_3: 3.4108818,
      },
      geometry: { type: "Point", coordinates: [12.32806, 45.43725] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.432243,
        lng: 12.353806,
        name: "Hopera Coffee & Backery",
        numreviews: 126,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10247364-Reviews-Hopera_Coffee_Backery-Venice_Veneto.html",
        percent_ital: 0.50793654,
        diversity_index_2: 0.39733744,
        diversity_index_3: -0.60266256,
        composite_ital_3: 1.6003681,
      },
      geometry: { type: "Point", coordinates: [12.35381, 45.43224] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435646,
        lng: 12.345819,
        name: "Trattoria da Denis",
        numreviews: 315,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10262321-Reviews-Trattoria_da_Denis-Venice_Veneto.html",
        percent_ital: 0.26349208,
        diversity_index_2: 0.33260009,
        diversity_index_3: -0.66739988,
        composite_ital_3: 2.4345465,
      },
      geometry: { type: "Point", coordinates: [12.34582, 45.43565] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: null,
        lat: 45.437366,
        lng: 12.347262,
        name: "Al Canton Del Vin",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10270785-Reviews-Al_Canton_Del_Vin-Venice_Veneto.html",
        percent_ital: 0.5,
        diversity_index_2: 0.35714287,
        diversity_index_3: -0.64285713,
        composite_ital_3: 1.7227665,
      },
      geometry: { type: "Point", coordinates: [12.34726, 45.43737] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.440445,
        lng: 12.329644,
        name: "Boresso",
        numreviews: 67,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10275184-Reviews-Boresso-Venice_Veneto.html",
        percent_ital: 0.3283582,
        diversity_index_2: 0.48502415,
        diversity_index_3: -0.51497585,
        composite_ital_3: 1.8372067,
      },
      geometry: { type: "Point", coordinates: [12.32964, 45.44044] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.445919,
        lng: 12.327276,
        name: "Mezzopieno",
        numreviews: 41,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10303131-Reviews-Mezzopieno-Venice_Veneto.html",
        percent_ital: 0.43902439,
        diversity_index_2: 0.47463769,
        diversity_index_3: -0.52536231,
        composite_ital_3: 1.5684038,
      },
      geometry: { type: "Point", coordinates: [12.32728, 45.44592] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43095,
        lng: 12.320983,
        name: "Osteria Ca' del Vento",
        numreviews: 172,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10316227-Reviews-Osteria_Ca_del_Vento-Venice_Veneto.html",
        percent_ital: 0.41279069,
        diversity_index_2: 0.41168782,
        diversity_index_3: -0.58831215,
        composite_ital_3: 1.7723045,
      },
      geometry: { type: "Point", coordinates: [12.32098, 45.43095] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434067,
        lng: 12.335518,
        name: "Dragone D'oriente Srl",
        numreviews: 138,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10322464-Reviews-Dragone_D_oriente_Srl-Venice_Veneto.html",
        percent_ital: 0.12318841,
        diversity_index_2: 0.59815741,
        diversity_index_3: -0.40184259,
        composite_ital_3: 2.6079416,
      },
      geometry: { type: "Point", coordinates: [12.33552, 45.43407] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434998,
        lng: 12.341478,
        name: "Aciugheta",
        numreviews: 1316,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034553-Reviews-Aciugheta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.38003308,
        diversity_index_3: -0.61996692,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34148, 45.435] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441216,
        lng: 12.326646,
        name: "Antica Besseta",
        numreviews: 598,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034560-Reviews-Antica_Besseta-Venice_Veneto.html",
        percent_ital: 0.31939799,
        diversity_index_2: 0.56629497,
        diversity_index_3: -0.43370503,
        composite_ital_3: 1.7099576,
      },
      geometry: { type: "Point", coordinates: [12.32665, 45.44122] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.436863,
        lng: 12.321876,
        name: "Brodo Di Giuggiole",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034563-Reviews-Brodo_Di_Giuggiole-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32188, 45.43686] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.433083,
        lng: 12.337207,
        name: "Canova",
        numreviews: 169,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034565-Reviews-Canova-Venice_Veneto.html",
        percent_ital: 0.28402367,
        diversity_index_2: 0.43503591,
        diversity_index_3: -0.56496406,
        composite_ital_3: 2.0910244,
      },
      geometry: { type: "Point", coordinates: [12.33721, 45.43308] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.438995,
        lng: 12.334031,
        name: "Cantina Do Mori",
        numreviews: 867,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034566-Reviews-Cantina_Do_Mori-Venice_Veneto.html",
        percent_ital: 0.40484428,
        diversity_index_2: 0.4391042,
        diversity_index_3: -0.5608958,
        composite_ital_3: 1.7272713,
      },
      geometry: { type: "Point", coordinates: [12.33403, 45.43899] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Italian",
        lat: 45.436981,
        lng: 12.346382,
        name: "Da Dante Alle Alpi",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034571-Reviews-Da_Dante_Alle_Alpi-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34638, 45.43698] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439224,
        lng: 12.333361,
        name: "Cantina Do Spade",
        numreviews: 921,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034679-Reviews-Cantina_Do_Spade-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.38976303,
        diversity_index_3: -0.610237,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33336, 45.43922] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438892,
        lng: 12.337473,
        name: "Il Milion",
        numreviews: 527,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034680-Reviews-Il_Milion-Venice_Veneto.html",
        percent_ital: 0.35673624,
        diversity_index_2: 0.35216492,
        diversity_index_3: -0.64783508,
        composite_ital_3: 2.0744143,
      },
      geometry: { type: "Point", coordinates: [12.33747, 45.43889] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440861,
        lng: 12.3285,
        name: "Osteria La Zucca",
        numreviews: 1540,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034681-Reviews-Osteria_La_Zucca-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.24356012,
        diversity_index_3: -0.75643986,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3285, 45.44086] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434448,
        lng: 12.336236,
        name: "Chat Qui Rit",
        numreviews: 906,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034682-Reviews-Chat_Qui_Rit-Venice_Veneto.html",
        percent_ital: 0.32891831,
        diversity_index_2: 0.35473093,
        diversity_index_3: -0.64526904,
        composite_ital_3: 2.1483417,
      },
      geometry: { type: "Point", coordinates: [12.33624, 45.43445] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.444134,
        lng: 12.32363,
        name: "Melograno",
        numreviews: 33,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034684-Reviews-Melograno-Venice_Veneto.html",
        percent_ital: 0.15151516,
        diversity_index_2: 0.44581282,
        diversity_index_3: -0.55418718,
        composite_ital_3: 2.6949258,
      },
      geometry: { type: "Point", coordinates: [12.32363, 45.44413] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438229,
        lng: 12.338566,
        name: "Osteria al Portego",
        numreviews: 1679,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034685-Reviews-Osteria_al_Portego-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.34296557,
        diversity_index_3: -0.6570344,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33857, 45.43823] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441391,
        lng: 12.334494,
        name: "Ca D'Oro alla Vedova",
        numreviews: 800,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034686-Reviews-Ca_D_Oro_alla_Vedova-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40717459,
        diversity_index_3: -0.59282541,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33449, 45.44139] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.42741,
        lng: 12.360879,
        name: "Osteria da Pampo",
        numreviews: 273,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034688-Reviews-Osteria_da_Pampo-Venice_Veneto.html",
        percent_ital: 0.48717949,
        diversity_index_2: 0.43022674,
        diversity_index_3: -0.56977326,
        composite_ital_3: 1.5625656,
      },
      geometry: { type: "Point", coordinates: [12.36088, 45.42741] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43177,
        lng: 12.327067,
        name: "Taverna San Trovaso",
        numreviews: 2373,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034690-Reviews-Taverna_San_Trovaso-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.36803758,
        diversity_index_3: -0.63196242,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32707, 45.43177] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434856,
        lng: 12.330704,
        name: "Sempione",
        numreviews: 606,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034691-Reviews-Sempione-Venice_Veneto.html",
        percent_ital: 0.2310231,
        diversity_index_2: 0.34548867,
        diversity_index_3: -0.65451133,
        composite_ital_3: 2.528033,
      },
      geometry: { type: "Point", coordinates: [12.3307, 45.43486] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.442238,
        lng: 12.339963,
        name: "Tiziano",
        numreviews: 76,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034692-Reviews-Tiziano-Venice_Veneto.html",
        percent_ital: 0.31578946,
        diversity_index_2: 0.2327044,
        diversity_index_3: -0.7672956,
        composite_ital_3: 2.6106658,
      },
      geometry: { type: "Point", coordinates: [12.33996, 45.44224] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.441078,
        lng: 12.337502,
        name: "Vecia Cavana",
        numreviews: 1178,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1034694-Reviews-Vecia_Cavana-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.51323283,
        diversity_index_3: -0.48676717,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3375, 45.44108] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.428982,
        lng: 12.32839,
        name: "Ristorante La Calcina",
        numreviews: 823,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1036436-Reviews-Ristorante_La_Calcina-Venice_Veneto.html",
        percent_ital: 0.19562575,
        diversity_index_2: 0.40245035,
        diversity_index_3: -0.59754968,
        composite_ital_3: 2.5417354,
      },
      geometry: { type: "Point", coordinates: [12.32839, 45.42898] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.443985,
        lng: 12.32652,
        name: "Pasticceria Pitteri",
        numreviews: 29,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10395799-Reviews-Pasticceria_Pitteri-Venice_Veneto.html",
        percent_ital: 0.41379312,
        diversity_index_2: 0.5163399,
        diversity_index_3: -0.4836601,
        composite_ital_3: 1.5433792,
      },
      geometry: { type: "Point", coordinates: [12.32652, 45.44398] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.424511,
        lng: 12.32656,
        name: "Food & Art Judecca",
        numreviews: 29,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10436225-Reviews-Food_Art_Judecca-Venice_Veneto.html",
        percent_ital: 0.37931034,
        diversity_index_2: 0.40522876,
        diversity_index_3: -0.59477127,
        composite_ital_3: 1.8727041,
      },
      geometry: { type: "Point", coordinates: [12.32656, 45.42451] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439812,
        lng: 12.340726,
        name: "Antica Osteria Ardenghi",
        numreviews: 243,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10447750-Reviews-Antica_Osteria_Ardenghi-Venice_Veneto.html",
        percent_ital: 0.56790125,
        diversity_index_2: 0.33680126,
        diversity_index_3: -0.66319871,
        composite_ital_3: 1.65407,
      },
      geometry: { type: "Point", coordinates: [12.34073, 45.43981] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.434307,
        lng: 12.325831,
        name: "Giorai",
        numreviews: 15,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10456082-Reviews-Giorai-Venice_Veneto.html",
        percent_ital: 0.60000001999999997,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.6094378,
      },
      geometry: { type: "Point", coordinates: [12.32583, 45.43431] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440479,
        lng: 12.32336,
        name: "Riolfo Sergio",
        numreviews: 15,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10486725-Reviews-Riolfo_Sergio-Venice_Veneto.html",
        percent_ital: 0.06666667,
        diversity_index_2: 0.18681319,
        diversity_index_3: -0.81318682,
        composite_ital_3: 4.3856964,
      },
      geometry: { type: "Point", coordinates: [12.32336, 45.44048] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438599,
        lng: 12.32432,
        name: "Latteria2465",
        numreviews: 44,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10497475-Reviews-Latteria2465-Venice_Veneto.html",
        percent_ital: 0.31818181,
        diversity_index_2: 0.50806451,
        diversity_index_3: -0.49193549,
        composite_ital_3: 1.8222792,
      },
      geometry: { type: "Point", coordinates: [12.32432, 45.4386] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.444721,
        lng: 12.33167,
        name: "Il Remo d'Oro",
        numreviews: 46,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10501655-Reviews-Il_Remo_d_Oro-Venice_Veneto.html",
        percent_ital: 0.30434781,
        diversity_index_2: 0.59831935,
        diversity_index_3: -0.40168065,
        composite_ital_3: 1.7032148,
      },
      geometry: { type: "Point", coordinates: [12.33167, 45.44472] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435982,
        lng: 12.34257,
        name: "Al Vecio Canton",
        numreviews: 1198,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1051222-Reviews-Al_Vecio_Canton-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.36111975,
        diversity_index_3: -0.63888025,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34257, 45.43598] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434052,
        lng: 12.34465,
        name: "Riviera del Leon",
        numreviews: 220,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10516797-Reviews-Riviera_del_Leon-Venice_Veneto.html",
        percent_ital: 0.13636364,
        diversity_index_2: 0.46111876,
        diversity_index_3: -0.53888124,
        composite_ital_3: 2.7665298,
      },
      geometry: { type: "Point", coordinates: [12.34465, 45.43405] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.446388,
        lng: 12.328611,
        name: "L'Anice Stellato",
        numreviews: 1215,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1054172-Reviews-L_Anice_Stellato-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41808879,
        diversity_index_3: -0.58191121,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32861, 45.44639] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445705,
        lng: 12.328045,
        name: "Timon all'Antica Mola",
        numreviews: 120,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1056030-Reviews-Timon_all_Antica_Mola-Venice_Veneto.html",
        percent_ital: 0.59166664,
        diversity_index_2: 0.43102041,
        diversity_index_3: -0.56897962,
        composite_ital_3: 1.3664117,
      },
      geometry: { type: "Point", coordinates: [12.32804, 45.4457] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436081,
        lng: 12.342794,
        name: "Al Giardinetto da Severino",
        numreviews: 1308,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1056096-Reviews-Al_Giardinetto_da_Severino-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.4103362,
        diversity_index_3: -0.5896638,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34279, 45.43608] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.441299,
        lng: 12.336991,
        name: "La perla",
        numreviews: 225,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1057936-Reviews-La_perla-Venice_Veneto.html",
        percent_ital: 0.32888889,
        diversity_index_2: 0.35861713,
        diversity_index_3: -0.64138287,
        composite_ital_3: 2.1375353,
      },
      geometry: { type: "Point", coordinates: [12.33699, 45.4413] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434212,
        lng: 12.32581,
        name: "Al Casin dei Nobili",
        numreviews: 786,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1058223-Reviews-Al_Casin_dei_Nobili-Venice_Veneto.html",
        percent_ital: 0.37150127,
        diversity_index_2: 0.4679873,
        diversity_index_3: -0.5320127,
        composite_ital_3: 1.7495172,
      },
      geometry: { type: "Point", coordinates: [12.32581, 45.43421] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440746,
        lng: 12.336357,
        name: "Trattoria Casa Mia",
        numreviews: 612,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1058762-Reviews-Trattoria_Casa_Mia-Venice_Veneto.html",
        percent_ital: 0.30882353,
        diversity_index_2: 0.34539476,
        diversity_index_3: -0.65460527,
        composite_ital_3: 2.2380526,
      },
      geometry: { type: "Point", coordinates: [12.33636, 45.44075] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438259,
        lng: 12.332633,
        name: "Antico Panificio",
        numreviews: 909,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1058769-Reviews-Antico_Panificio-Venice_Veneto.html",
        percent_ital: 0.32673267,
        diversity_index_2: 0.37774661,
        diversity_index_3: -0.62225342,
        composite_ital_3: 2.0921445,
      },
      geometry: { type: "Point", coordinates: [12.33263, 45.43826] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439831,
        lng: 12.339801,
        name: "Osteria da Alberto",
        numreviews: 1176,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1059055-Reviews-Osteria_da_Alberto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33401707,
        diversity_index_3: -0.66598296,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3398, 45.43983] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443417,
        lng: 12.333222,
        name: "Osteria Giorgione",
        numreviews: 233,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1059167-Reviews-Osteria_Giorgione-Venice_Veneto.html",
        percent_ital: 0.31759655,
        diversity_index_2: 0.37608695,
        diversity_index_3: -0.62391305,
        composite_ital_3: 2.1249082,
      },
      geometry: { type: "Point", coordinates: [12.33322, 45.44342] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437744,
        lng: 12.338384,
        name: "Olandese Volante",
        numreviews: 547,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1059887-Reviews-Olandese_Volante-Venice_Veneto.html",
        percent_ital: 0.29433271,
        diversity_index_2: 0.34827605,
        diversity_index_3: -0.65172398,
        composite_ital_3: 2.2778044,
      },
      geometry: { type: "Point", coordinates: [12.33838, 45.43774] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.43523,
        lng: 12.337958,
        name: "Aldo Pasta",
        numreviews: 117,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10632857-Reviews-Aldo_Pasta-Venice_Veneto.html",
        percent_ital: 0.1965812,
        diversity_index_2: 0.31243002,
        diversity_index_3: -0.68756998,
        composite_ital_3: 2.7900543,
      },
      geometry: { type: "Point", coordinates: [12.33796, 45.43523] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435226,
        lng: 12.339414,
        name: "Caruti & Caruti Di Jacopo Caruti Sas",
        numreviews: 35,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10636354-Reviews-Caruti_Caruti_Di_Jacopo_Caruti_Sas-Venice_Veneto.html",
        percent_ital: 0.22857143,
        diversity_index_2: 0.49470899,
        diversity_index_3: -0.50529099,
        composite_ital_3: 2.179692,
      },
      geometry: { type: "Point", coordinates: [12.33941, 45.43523] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.430595,
        lng: 12.329977,
        name: "Al Vecio Forner",
        numreviews: 664,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1066500-Reviews-Al_Vecio_Forner-Venice_Veneto.html",
        percent_ital: 0.39608434,
        diversity_index_2: 0.34233937,
        diversity_index_3: -0.6576606,
        composite_ital_3: 1.9980808,
      },
      geometry: { type: "Point", coordinates: [12.32998, 45.43059] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434746,
        lng: 12.341826,
        name: "Ristorante Ae Rasse",
        numreviews: 245,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10667114-Reviews-Ristorante_Ae_Rasse-Venice_Veneto.html",
        percent_ital: 0.32244897,
        diversity_index_2: 0.33537617,
        diversity_index_3: -0.66462386,
        composite_ital_3: 2.2243128,
      },
      geometry: { type: "Point", coordinates: [12.34183, 45.43475] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439964,
        lng: 12.321718,
        name: "Ostaria al Vecio Pozzo",
        numreviews: 1269,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1068013-Reviews-Ostaria_al_Vecio_Pozzo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40098336,
        diversity_index_3: -0.59901667,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32172, 45.43996] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434891,
        lng: 12.340745,
        name: "Osteria Calle 21",
        numreviews: 402,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10685913-Reviews-Osteria_Calle_21-Venice_Veneto.html",
        percent_ital: 0.2238806,
        diversity_index_2: 0.36766759,
        diversity_index_3: -0.63233244,
        composite_ital_3: 2.4972184,
      },
      geometry: { type: "Point", coordinates: [12.34075, 45.43489] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435493,
        lng: 12.32259,
        name: "Osteria da Baba",
        numreviews: 129,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10687917-Reviews-Osteria_da_Baba-Venice_Veneto.html",
        percent_ital: 0.4728682,
        diversity_index_2: 0.32608697,
        diversity_index_3: -0.673913,
        composite_ital_3: 1.8695297,
      },
      geometry: { type: "Point", coordinates: [12.32259, 45.43549] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445541,
        lng: 12.328412,
        name: "Al Timon",
        numreviews: 1474,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1069463-Reviews-Al_Timon-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.45078006,
        diversity_index_3: -0.54921997,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32841, 45.44554] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43478,
        lng: 12.33346,
        name: "Osteria ai Assassini",
        numreviews: 561,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1070893-Reviews-Osteria_ai_Assassini-Venice_Veneto.html",
        percent_ital: 0.52941179,
        diversity_index_2: 0.40823969,
        diversity_index_3: -0.59176028,
        composite_ital_3: 1.5318896,
      },
      geometry: { type: "Point", coordinates: [12.33346, 45.43478] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.445354,
        lng: 12.329187,
        name: "Birre Da Tutto Il Mondo O Quasi",
        numreviews: 25,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10723790-Reviews-Birre_Da_Tutto_Il_Mondo_O_Quasi-Venice_Veneto.html",
        percent_ital: 0.16,
        diversity_index_2: 0.64761907,
        diversity_index_3: -0.35238093,
        composite_ital_3: 2.2670341,
      },
      geometry: { type: "Point", coordinates: [12.32919, 45.44535] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.430229,
        lng: 12.323283,
        name: "el chioschetto",
        numreviews: 62,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1073097-Reviews-El_chioschetto-Venice_Veneto.html",
        percent_ital: 0.51612902,
        diversity_index_2: 0.39784947,
        diversity_index_3: -0.60215056,
        composite_ital_3: 1.5830801,
      },
      geometry: { type: "Point", coordinates: [12.32328, 45.43023] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.446388,
        lng: 12.326209,
        name: "Pizza Osteria dei Sapori",
        numreviews: 252,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10758878-Reviews-Pizza_Osteria_dei_Sapori-Venice_Veneto.html",
        percent_ital: 0.47222221,
        diversity_index_2: 0.34549475,
        diversity_index_3: -0.65450525,
        composite_ital_3: 1.8130834,
      },
      geometry: { type: "Point", coordinates: [12.32621, 45.44639] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.443745,
        lng: 12.327361,
        name: "Rizzo Pane",
        numreviews: 100,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10763046-Reviews-Rizzo_Pane-Venice_Veneto.html",
        percent_ital: 0.31999999000000001,
        diversity_index_2: 0.32054561,
        diversity_index_3: -0.67945439,
        composite_ital_3: 2.2771649,
      },
      geometry: { type: "Point", coordinates: [12.32736, 45.44374] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.441933,
        lng: 12.32163,
        name: "Mirai",
        numreviews: 235,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1076718-Reviews-Mirai-Venice_Veneto.html",
        percent_ital: 0.75744683,
        diversity_index_2: 0.44971752,
        diversity_index_3: -0.55028248,
        composite_ital_3: 1.0769376,
      },
      geometry: { type: "Point", coordinates: [12.32163, 45.44193] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435268,
        lng: 12.34006,
        name: "Restaurant Pizza Da Celio",
        numreviews: 271,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1079721-Reviews-Restaurant_Pizza_Da_Celio-Venice_Veneto.html",
        percent_ital: 0.29889297,
        diversity_index_2: 0.34974912,
        diversity_index_3: -0.65025091,
        composite_ital_3: 2.258209,
      },
      geometry: { type: "Point", coordinates: [12.34006, 45.43527] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.43401,
        lng: 12.335322,
        name: "Caffe Centrale",
        numreviews: 907,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1079840-Reviews-Caffe_Centrale-Venice_Veneto.html",
        percent_ital: 0.36273429,
        diversity_index_2: 0.40178895,
        diversity_index_3: -0.59821105,
        composite_ital_3: 1.9259131,
      },
      geometry: { type: "Point", coordinates: [12.33532, 45.43401] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.442223,
        lng: 12.323334,
        name: "Pizzeria Ae Oche S. Lucia",
        numreviews: 776,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1082150-Reviews-Pizzeria_Ae_Oche_S_Lucia-Venice_Veneto.html",
        percent_ital: 0.65335053,
        diversity_index_2: 0.25482866,
        diversity_index_3: -0.74517131,
        composite_ital_3: 1.7928053,
      },
      geometry: { type: "Point", coordinates: [12.32333, 45.44222] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437931,
        lng: 12.333792,
        name: "Al Paradiso",
        numreviews: 935,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087239-Reviews-Al_Paradiso-Venice_Veneto.html",
        percent_ital: 0.25240642,
        diversity_index_2: 0.45755443,
        diversity_index_3: -0.54244554,
        composite_ital_3: 2.1585741,
      },
      geometry: { type: "Point", coordinates: [12.33379, 45.43793] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.433857,
        lng: 12.333468,
        name: "Taverna La Fenice",
        numreviews: 791,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087276-Reviews-Taverna_La_Fenice-Venice_Veneto.html",
        percent_ital: 0.36536029,
        diversity_index_2: 0.37953719,
        diversity_index_3: -0.62046278,
        composite_ital_3: 1.975674,
      },
      geometry: { type: "Point", coordinates: [12.33347, 45.43386] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.426296,
        lng: 12.326502,
        name: "La Palanca",
        numreviews: 1212,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087324-Reviews-La_Palanca-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.28028736,
        diversity_index_3: -0.71971262,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3265, 45.4263] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.434444,
        lng: 12.338056,
        name: "Ristorante Quadri",
        numreviews: 997,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087336-Reviews-Ristorante_Quadri-Venice_Veneto.html",
        percent_ital: 0.42728186,
        diversity_index_2: 0.38986599,
        diversity_index_3: -0.61013401,
        composite_ital_3: 1.7922636,
      },
      geometry: { type: "Point", coordinates: [12.33806, 45.43444] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.430763,
        lng: 12.322053,
        name: "Riviera",
        numreviews: 1307,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087350-Reviews-Riviera-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33379805,
        diversity_index_3: -0.66620195,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32205, 45.43076] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.438648,
        lng: 12.331095,
        name: "Antiche Carampane",
        numreviews: 1511,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087359-Reviews-Antiche_Carampane-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.47290793,
        diversity_index_3: -0.5270921,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33109, 45.43865] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.430351,
        lng: 12.33077,
        name: "Ai Gondolieri",
        numreviews: 533,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087364-Reviews-Ai_Gondolieri-Venice_Veneto.html",
        percent_ital: 0.19512194,
        diversity_index_2: 0.42388174,
        diversity_index_3: -0.57611823,
        composite_ital_3: 2.4924314,
      },
      geometry: { type: "Point", coordinates: [12.33077, 45.43035] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43478,
        lng: 12.33299,
        name: "Vini da Arturo",
        numreviews: 228,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087367-Reviews-Vini_da_Arturo-Venice_Veneto.html",
        percent_ital: 0.20614035,
        diversity_index_2: 0.57725334,
        diversity_index_3: -0.42274666,
        composite_ital_3: 2.1286721,
      },
      geometry: { type: "Point", coordinates: [12.33299, 45.43478] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.429451,
        lng: 12.334685,
        name: "Lineadombra",
        numreviews: 841,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1087392-Reviews-Lineadombra-Venice_Veneto.html",
        percent_ital: 0.27110583,
        diversity_index_2: 0.4442375,
        diversity_index_3: -0.55576253,
        composite_ital_3: 2.116642,
      },
      geometry: { type: "Point", coordinates: [12.33469, 45.42945] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434097,
        lng: 12.344599,
        name: "Restaurant Prete Rosso",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10874712-Reviews-Restaurant_Prete_Rosso-Venice_Veneto.html",
        percent_ital: 0.22222222,
        diversity_index_2: 0.39285713,
        diversity_index_3: -0.60714287,
        composite_ital_3: 2.4383867,
      },
      geometry: { type: "Point", coordinates: [12.3446, 45.4341] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436035,
        lng: 12.325523,
        name: "Joker's Cocktails",
        numreviews: 137,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088031-Reviews-Joker_s_Cocktails-Venice_Veneto.html",
        percent_ital: 0.42335767,
        diversity_index_2: 0.44620255,
        diversity_index_3: -0.55379748,
        composite_ital_3: 1.6665202,
      },
      geometry: { type: "Point", coordinates: [12.32552, 45.43603] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440292,
        lng: 12.328012,
        name: "Al Prosecco",
        numreviews: 173,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088032-Reviews-Al_Prosecco-Venice_Veneto.html",
        percent_ital: 0.18497109,
        diversity_index_2: 0.48876235,
        diversity_index_3: -0.51123762,
        composite_ital_3: 2.4034345,
      },
      geometry: { type: "Point", coordinates: [12.32801, 45.44029] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439693,
        lng: 12.333517,
        name: "Antica Trattoria Poste Vecie",
        numreviews: 642,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088037-Reviews-Antica_Trattoria_Poste_Vecie-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.37401646,
        diversity_index_3: -0.62598354,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33352, 45.43969] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.43454,
        lng: 12.341806,
        name: "Birreria al Vecio Penasa",
        numreviews: 249,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088044-Reviews-Birreria_al_Vecio_Penasa-Venice_Veneto.html",
        percent_ital: 0.48995984,
        diversity_index_2: 0.31625485,
        diversity_index_3: -0.68374515,
        composite_ital_3: 1.8646387,
      },
      geometry: { type: "Point", coordinates: [12.34181, 45.43454] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444565,
        lng: 12.324124,
        name: "Trattoria Alla Fontana",
        numreviews: 632,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088045-Reviews-Trattoria_Alla_Fontana-Venice_Veneto.html",
        percent_ital: 0.28639239,
        diversity_index_2: 0.3931182,
        diversity_index_3: -0.6068818,
        composite_ital_3: 2.1840374,
      },
      geometry: { type: "Point", coordinates: [12.32412, 45.44456] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.434975,
        lng: 12.342598,
        name: "Bacaro Risorto",
        numreviews: 720,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088055-Reviews-Bacaro_Risorto-Venice_Veneto.html",
        percent_ital: 0.55833334,
        diversity_index_2: 0.39757428,
        diversity_index_3: -0.60242569,
        composite_ital_3: 1.5051726,
      },
      geometry: { type: "Point", coordinates: [12.3426, 45.43498] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.43663,
        lng: 12.328128,
        name: "Bar Ai Nomboli",
        numreviews: 136,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088057-Reviews-Bar_Ai_Nomboli-Venice_Veneto.html",
        percent_ital: 0.44852942,
        diversity_index_2: 0.3614035,
        diversity_index_3: -0.63859653,
        composite_ital_3: 1.8195412,
      },
      geometry: { type: "Point", coordinates: [12.32813, 45.43663] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.440472,
        lng: 12.339909,
        name: "Ostaria Boccadoro",
        numreviews: 579,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088058-Reviews-Ostaria_Boccadoro-Venice_Veneto.html",
        percent_ital: 0.16925734,
        diversity_index_2: 0.41610453,
        diversity_index_3: -0.58389544,
        composite_ital_3: 2.6531539,
      },
      geometry: { type: "Point", coordinates: [12.33991, 45.44047] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.436985,
        lng: 12.3266,
        name: "Caffe dei Frari O Toppo",
        numreviews: 238,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088061-Reviews-Caffe_dei_Frari_O_Toppo-Venice_Veneto.html",
        percent_ital: 0.29831934,
        diversity_index_2: 0.36975205,
        diversity_index_3: -0.63024795,
        composite_ital_3: 2.2045133,
      },
      geometry: { type: "Point", coordinates: [12.3266, 45.43698] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434578,
        lng: 12.325921,
        name: "Osteria Ai do Farai",
        numreviews: 631,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088070-Reviews-Osteria_Ai_do_Farai-Venice_Veneto.html",
        percent_ital: 0.46434233,
        diversity_index_2: 0.34859991,
        diversity_index_3: -0.65140009,
        composite_ital_3: 1.8209636,
      },
      geometry: { type: "Point", coordinates: [12.32592, 45.43458] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440285,
        lng: 12.32801,
        name: "Il Refolo",
        numreviews: 597,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088079-Reviews-Il_Refolo-Venice_Veneto.html",
        percent_ital: 0.18592964,
        diversity_index_2: 0.49499649,
        diversity_index_3: -0.50500351,
        composite_ital_3: 2.3855915,
      },
      geometry: { type: "Point", coordinates: [12.32801, 45.44029] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.442631,
        lng: 12.324178,
        name: "La Lista Bistro",
        numreviews: 695,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088086-Reviews-La_Lista_Bistro-Venice_Veneto.html",
        percent_ital: 0.44028777,
        diversity_index_2: 0.31282824,
        diversity_index_3: -0.68717176,
        composite_ital_3: 1.9824277,
      },
      geometry: { type: "Point", coordinates: [12.32418, 45.44263] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438725,
        lng: 12.335652,
        name: "Naranzaria",
        numreviews: 436,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088087-Reviews-Naranzaria-Venice_Veneto.html",
        percent_ital: 0.36009175,
        diversity_index_2: 0.35281795,
        diversity_index_3: -0.64718205,
        composite_ital_3: 2.0631995,
      },
      geometry: { type: "Point", coordinates: [12.33565, 45.43872] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436451,
        lng: 12.323205,
        name: "Osteria Ae Cravate",
        numreviews: 1065,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088090-Reviews-Osteria_Ae_Cravate-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.4442105,
        diversity_index_3: -0.55578947,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3232, 45.43645] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432896,
        lng: 12.322596,
        name: "Osteria ai Camini",
        numreviews: 449,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088093-Reviews-Osteria_ai_Camini-Venice_Veneto.html",
        percent_ital: 0.56347442,
        diversity_index_2: 0.33758909,
        diversity_index_3: -0.66241091,
        composite_ital_3: 1.6595591,
      },
      geometry: { type: "Point", coordinates: [12.3226, 45.4329] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434322,
        lng: 12.32988,
        name: "Osteria al Bacareto",
        numreviews: 574,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088097-Reviews-Osteria_al_Bacareto-Venice_Veneto.html",
        percent_ital: 0.32752612,
        diversity_index_2: 0.40533486,
        diversity_index_3: -0.59466517,
        composite_ital_3: 2.0192292,
      },
      geometry: { type: "Point", coordinates: [12.32988, 45.43432] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438454,
        lng: 12.334306,
        name: "Osteria Al Diavolo E L'acquasanta",
        numreviews: 868,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088098-Reviews-Osteria_Al_Diavolo_E_L_acquasanta-Venice_Veneto.html",
        percent_ital: 0.609447,
        diversity_index_2: 0.30475846,
        diversity_index_3: -0.69524157,
        composite_ital_3: 1.683439,
      },
      geometry: { type: "Point", coordinates: [12.33431, 45.43845] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438297,
        lng: 12.347651,
        name: "Ale Do Marie",
        numreviews: 172,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088100-Reviews-Ale_Do_Marie-Venice_Veneto.html",
        percent_ital: 0.58139533,
        diversity_index_2: 0.37202469,
        diversity_index_3: -0.62797534,
        composite_ital_3: 1.5311195,
      },
      geometry: { type: "Point", coordinates: [12.34765, 45.4383] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.440197,
        lng: 12.330191,
        name: "Osteria Alla Ciurma",
        numreviews: 1629,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088103-Reviews-Osteria_Alla_Ciurma-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.3136327,
        diversity_index_3: -0.68636727,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33019, 45.4402] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442059,
        lng: 12.34011,
        name: "Osteria Alla Frasca",
        numreviews: 633,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088107-Reviews-Osteria_Alla_Frasca-Venice_Veneto.html",
        percent_ital: 0.42180094,
        diversity_index_2: 0.40878952,
        diversity_index_3: -0.59121048,
        composite_ital_3: 1.7577766,
      },
      geometry: { type: "Point", coordinates: [12.34011, 45.44206] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432091,
        lng: 12.319243,
        name: "Trattoria Anzolo Raffaele",
        numreviews: 778,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088117-Reviews-Trattoria_Anzolo_Raffaele-Venice_Veneto.html",
        percent_ital: 0.34704369,
        diversity_index_2: 0.4818362,
        diversity_index_3: -0.5181638,
        composite_ital_3: 1.7884557,
      },
      geometry: { type: "Point", coordinates: [12.31924, 45.43209] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43277,
        lng: 12.324577,
        name: "Ristorante La Bitta",
        numreviews: 887,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088122-Reviews-Ristorante_La_Bitta-Venice_Veneto.html",
        percent_ital: 0.33370912,
        diversity_index_2: 0.5390982,
        diversity_index_3: -0.4609018,
        composite_ital_3: 1.7153431,
      },
      geometry: { type: "Point", coordinates: [12.32458, 45.43277] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432888,
        lng: 12.324812,
        name: "Ristoteca Oniga",
        numreviews: 1289,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088123-Reviews-Ristoteca_Oniga-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.42416105,
        diversity_index_3: -0.57583892,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32481, 45.43289] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436668,
        lng: 12.328661,
        name: "Trattoria Da Ignazio",
        numreviews: 450,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088131-Reviews-Trattoria_Da_Ignazio-Venice_Veneto.html",
        percent_ital: 0.37777779,
        diversity_index_2: 0.42898968,
        diversity_index_3: -0.57101035,
        composite_ital_3: 1.8197715,
      },
      geometry: { type: "Point", coordinates: [12.32866, 45.43667] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435719,
        lng: 12.345126,
        name: "Trattoria Da Remigio",
        numreviews: 890,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088136-Reviews-Trattoria_Da_Remigio-Venice_Veneto.html",
        percent_ital: 0.60674155,
        diversity_index_2: 0.46899784,
        diversity_index_3: -0.53100216,
        composite_ital_3: 1.2568095,
      },
      geometry: { type: "Point", coordinates: [12.34513, 45.43572] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432159,
        lng: 12.353077,
        name: "Ristorante Giorgione",
        numreviews: 480,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088142-Reviews-Ristorante_Giorgione-Venice_Veneto.html",
        percent_ital: 0.38541666,
        diversity_index_2: 0.36354598,
        diversity_index_3: -0.63645399,
        composite_ital_3: 1.9652798,
      },
      geometry: { type: "Point", coordinates: [12.35308, 45.43216] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.430977,
        lng: 12.320848,
        name: "Trattoria San Basilio",
        numreviews: 171,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088143-Reviews-Trattoria_San_Basilio-Venice_Veneto.html",
        percent_ital: 0.22222222,
        diversity_index_2: 0.43003029,
        diversity_index_3: -0.56996971,
        composite_ital_3: 2.3479769,
      },
      geometry: { type: "Point", coordinates: [12.32085, 45.43098] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.441032,
        lng: 12.330187,
        name: "Vecio Fritolin",
        numreviews: 1081,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088145-Reviews-Vecio_Fritolin-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.39766219,
        diversity_index_3: -0.60233784,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33019, 45.44103] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433338,
        lng: 12.334739,
        name: "Vino Vino",
        numreviews: 919,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1088150-Reviews-Vino_Vino-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.27286035,
        diversity_index_3: -0.72713965,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33474, 45.43334] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.443169,
        lng: 12.340305,
        name: "Pizzeria Gelateria Al Giu",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10886304-Reviews-Pizzeria_Gelateria_Al_Giu-Venice_Veneto.html",
        percent_ital: 0.89999998000000003,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.10536055,
      },
      geometry: { type: "Point", coordinates: [12.34031, 45.44317] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432415,
        lng: 12.353388,
        name: "Nevodi",
        numreviews: 1048,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d10926020-Reviews-Nevodi-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.39657471,
        diversity_index_3: -0.60342526,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.35339, 45.43241] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439316,
        lng: 12.332761,
        name: "Osteria al Garanghelo",
        numreviews: 569,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1094177-Reviews-Osteria_al_Garanghelo-Venice_Veneto.html",
        percent_ital: 0.43585238,
        diversity_index_2: 0.38074762,
        diversity_index_3: -0.61925238,
        composite_ital_3: 1.7960702,
      },
      geometry: { type: "Point", coordinates: [12.33276, 45.43932] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434013,
        lng: 12.336331,
        name: "Osteria Enoteca San Marco",
        numreviews: 1448,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1096549-Reviews-Osteria_Enoteca_San_Marco-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.42439851,
        diversity_index_3: -0.57560146,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33633, 45.43401] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43396,
        lng: 12.33026,
        name: "Ostaria alle Botteghe",
        numreviews: 280,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1098088-Reviews-Ostaria_alle_Botteghe-Venice_Veneto.html",
        percent_ital: 0.23928571,
        diversity_index_2: 0.37904802,
        diversity_index_3: -0.62095201,
        composite_ital_3: 2.4001894,
      },
      geometry: { type: "Point", coordinates: [12.33026, 45.43396] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436771,
        lng: 12.33439,
        name: "Ristorante Omnibus",
        numreviews: 344,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1104086-Reviews-Ristorante_Omnibus-Venice_Veneto.html",
        percent_ital: 0.17732558,
        diversity_index_2: 0.42569804,
        diversity_index_3: -0.57430196,
        composite_ital_3: 2.5837929,
      },
      geometry: { type: "Point", coordinates: [12.33439, 45.43677] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437218,
        lng: 12.340598,
        name: "Alburchiello Ristorante",
        numreviews: 38,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11045530-Reviews-Alburchiello_Ristorante-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.32859176,
        diversity_index_3: -0.67140824,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3406, 45.43722] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436951,
        lng: 12.331223,
        name: "Osteria Vivaldi",
        numreviews: 289,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1125964-Reviews-Osteria_Vivaldi-Venice_Veneto.html",
        percent_ital: 0.30795848,
        diversity_index_2: 0.33431852,
        diversity_index_3: -0.66568148,
        composite_ital_3: 2.2734513,
      },
      geometry: { type: "Point", coordinates: [12.33122, 45.43695] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438679,
        lng: 12.34363,
        name: "Trattoria Bandierette",
        numreviews: 285,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1126816-Reviews-Trattoria_Bandierette-Venice_Veneto.html",
        percent_ital: 0.58947366,
        diversity_index_2: 0.36157024,
        diversity_index_3: -0.63842976,
        composite_ital_3: 1.5458242,
      },
      geometry: { type: "Point", coordinates: [12.34363, 45.43868] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434021,
        lng: 12.335362,
        name: "Osteria da Carla",
        numreviews: 891,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1132517-Reviews-Osteria_da_Carla-Venice_Veneto.html",
        percent_ital: 0.43209878,
        diversity_index_2: 0.29793769,
        diversity_index_3: -0.70206231,
        composite_ital_3: 2.0499721,
      },
      geometry: { type: "Point", coordinates: [12.33536, 45.43402] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440861,
        lng: 12.33671,
        name: "Trattoria da Bepi Gia 54",
        numreviews: 793,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1136726-Reviews-Trattoria_da_Bepi_Gia_54-Venice_Veneto.html",
        percent_ital: 0.47919294,
        diversity_index_2: 0.47202131,
        diversity_index_3: -0.52797866,
        composite_ital_3: 1.4863831,
      },
      geometry: { type: "Point", coordinates: [12.33671, 45.44086] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.441303,
        lng: 12.329897,
        name: "The Glam Restaurant",
        numreviews: 168,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11444604-Reviews-The_Glam_Restaurant-Venice_Veneto.html",
        percent_ital: 0.45238096,
        diversity_index_2: 0.42870501,
        diversity_index_3: -0.57129502,
        composite_ital_3: 1.6402168,
      },
      geometry: { type: "Point", coordinates: [12.3299, 45.4413] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.430698,
        lng: 12.329119,
        name: "Bar Da Gino",
        numreviews: 600,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1144633-Reviews-Bar_Da_Gino-Venice_Veneto.html",
        percent_ital: 0.20333333,
        diversity_index_2: 0.37240124,
        diversity_index_3: -0.62759876,
        composite_ital_3: 2.5806921,
      },
      geometry: { type: "Point", coordinates: [12.32912, 45.4307] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435253,
        lng: 12.342645,
        name: "Trattoria da Nino",
        numreviews: 517,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1146901-Reviews-Trattoria_da_Nino-Venice_Veneto.html",
        percent_ital: 0.23210831,
        diversity_index_2: 0.40666994,
        diversity_index_3: -0.59333003,
        composite_ital_3: 2.3603046,
      },
      geometry: { type: "Point", coordinates: [12.34264, 45.43525] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435608,
        lng: 12.336328,
        name: "Ristorante La Terrazza",
        numreviews: 404,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1148855-Reviews-Ristorante_La_Terrazza-Venice_Veneto.html",
        percent_ital: 0.22029702,
        diversity_index_2: 0.38264185,
        diversity_index_3: -0.61735815,
        composite_ital_3: 2.4734344,
      },
      geometry: { type: "Point", coordinates: [12.33633, 45.43561] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439014,
        lng: 12.341502,
        name: "Snack Bar Colleoni",
        numreviews: 42,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11548751-Reviews-Snack_Bar_Colleoni-Venice_Veneto.html",
        percent_ital: 0.5,
        diversity_index_2: 0.39393941,
        diversity_index_3: -0.60606062,
        composite_ital_3: 1.6247053,
      },
      geometry: { type: "Point", coordinates: [12.3415, 45.43901] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439011,
        lng: 12.337438,
        name: "Bacaro Osteria Barababao",
        numreviews: 697,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1155570-Reviews-Bacaro_Osteria_Barababao-Venice_Veneto.html",
        percent_ital: 0.37302727,
        diversity_index_2: 0.38027626,
        diversity_index_3: -0.61972374,
        composite_ital_3: 1.9529611,
      },
      geometry: { type: "Point", coordinates: [12.33744, 45.43901] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441917,
        lng: 12.321032,
        name: "Trattoria Povoledo",
        numreviews: 1313,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1159180-Reviews-Trattoria_Povoledo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41304457,
        diversity_index_3: -0.58695543,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32103, 45.44192] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445122,
        lng: 12.33065,
        name: "A La Vecia Papussa",
        numreviews: 70,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11621060-Reviews-A_La_Vecia_Papussa-Venice_Veneto.html",
        percent_ital: 0.45714286,
        diversity_index_2: 0.37921727,
        diversity_index_3: -0.62078273,
        composite_ital_3: 1.7524054,
      },
      geometry: { type: "Point", coordinates: [12.33065, 45.44512] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432858,
        lng: 12.32454,
        name: "Osteria ai 4 Feri",
        numreviews: 875,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1171801-Reviews-Osteria_ai_4_Feri-Venice_Veneto.html",
        percent_ital: 0.60342854,
        diversity_index_2: 0.3402788,
        diversity_index_3: -0.6597212,
        composite_ital_3: 1.5831176,
      },
      geometry: { type: "Point", coordinates: [12.32454, 45.43286] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434116,
        lng: 12.343076,
        name: "Caffe Internazionale",
        numreviews: 97,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11719001-Reviews-Caffe_Internazionale-Venice_Veneto.html",
        percent_ital: 0.10309278,
        diversity_index_2: 0.36206895,
        diversity_index_3: -0.63793105,
        composite_ital_3: 3.2880464,
      },
      geometry: { type: "Point", coordinates: [12.34308, 45.43412] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439152,
        lng: 12.333545,
        name: "Antica Torre",
        numreviews: 299,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1172816-Reviews-Antica_Torre-Venice_Veneto.html",
        percent_ital: 0.47826087,
        diversity_index_2: 0.250617,
        diversity_index_3: -0.74938297,
        composite_ital_3: 2.1214283,
      },
      geometry: { type: "Point", coordinates: [12.33355, 45.43915] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.433567,
        lng: 12.336423,
        name: "Il Calice",
        numreviews: 95,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11750630-Reviews-Il_Calice-Venice_Veneto.html",
        percent_ital: 0.21052632,
        diversity_index_2: 0.40225562,
        diversity_index_3: -0.59774435,
        composite_ital_3: 2.4688122,
      },
      geometry: { type: "Point", coordinates: [12.33642, 45.43357] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438179,
        lng: 12.326892,
        name: "Brillo Parlante",
        numreviews: 27,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11778522-Reviews-Brillo_Parlante-Venice_Veneto.html",
        percent_ital: 0.44444445,
        diversity_index_2: 0.63809526,
        diversity_index_3: -0.36190474,
        composite_ital_3: 1.2601979,
      },
      geometry: { type: "Point", coordinates: [12.32689, 45.43818] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.44614,
        lng: 12.326218,
        name: "Fiumefreddo Bio",
        numreviews: 126,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11778752-Reviews-Fiumefreddo_Bio-Venice_Veneto.html",
        percent_ital: 0.1984127,
        diversity_index_2: 0.43758494,
        diversity_index_3: -0.56241506,
        composite_ital_3: 2.4438906,
      },
      geometry: { type: "Point", coordinates: [12.32622, 45.44614] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.42609,
        lng: 12.327569,
        name: "Pizzeria La Foca",
        numreviews: 31,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11793203-Reviews-Pizzeria_La_Foca-Venice_Veneto.html",
        percent_ital: 0.32258064,
        diversity_index_2: 0.36796537,
        diversity_index_3: -0.63203466,
        composite_ital_3: 2.1311686,
      },
      geometry: { type: "Point", coordinates: [12.32757, 45.42609] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435631,
        lng: 12.338672,
        name: "Pizzeria da Toto",
        numreviews: 247,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11795965-Reviews-Pizzeria_da_Toto-Venice_Veneto.html",
        percent_ital: 0.23076923,
        diversity_index_2: 0.35794473,
        diversity_index_3: -0.64205527,
        composite_ital_3: 2.4937139,
      },
      geometry: { type: "Point", coordinates: [12.33867, 45.43563] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436417,
        lng: 12.339559,
        name: "Pizzeria Birreria Barbanera",
        numreviews: 667,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1179698-Reviews-Pizzeria_Birreria_Barbanera-Venice_Veneto.html",
        percent_ital: 0.41379312,
        diversity_index_2: 0.31572703,
        diversity_index_3: -0.684273,
        composite_ital_3: 2.0352664,
      },
      geometry: { type: "Point", coordinates: [12.33956, 45.43642] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.426079,
        lng: 12.327462,
        name: "Pizzeria La Foca",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11800542-Reviews-Pizzeria_La_Foca-Venice_Veneto.html",
        percent_ital: 0.85714287,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.2527629,
      },
      geometry: { type: "Point", coordinates: [12.32746, 45.42608] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43972,
        lng: 12.337083,
        name: "Ristorante Al Corner",
        numreviews: 730,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11828245-Reviews-Ristorante_Al_Corner-Venice_Veneto.html",
        percent_ital: 0.40684932,
        diversity_index_2: 0.35706341,
        diversity_index_3: -0.64293659,
        composite_ital_3: 1.9291543,
      },
      geometry: { type: "Point", coordinates: [12.33708, 45.43972] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.429192,
        lng: 12.327593,
        name: "Ristorante Pizzeria Alle Zattere",
        numreviews: 304,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1184152-Reviews-Ristorante_Pizzeria_Alle_Zattere-Venice_Veneto.html",
        percent_ital: 0.15789473,
        diversity_index_2: 0.33888337,
        diversity_index_3: -0.6611166,
        composite_ital_3: 2.9279261,
      },
      geometry: { type: "Point", coordinates: [12.32759, 45.42919] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433697,
        lng: 12.331,
        name: "Bar All'Angolo",
        numreviews: 141,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11845358-Reviews-Bar_All_Angolo-Venice_Veneto.html",
        percent_ital: 0.70921987,
        diversity_index_2: 0.31939605,
        diversity_index_3: -0.68060398,
        composite_ital_3: 1.4849131,
      },
      geometry: { type: "Point", coordinates: [12.331, 45.4337] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.4454,
        lng: 12.321711,
        name: "Laguna Libre",
        numreviews: 301,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11857221-Reviews-Laguna_Libre-Venice_Veneto.html",
        percent_ital: 0.39867109,
        diversity_index_2: 0.35565594,
        diversity_index_3: -0.64434409,
        composite_ital_3: 1.95341,
      },
      geometry: { type: "Point", coordinates: [12.32171, 45.4454] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432613,
        lng: 12.324046,
        name: "Africa Experience",
        numreviews: 203,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11865125-Reviews-Africa_Experience-Venice_Veneto.html",
        percent_ital: 0.62561578,
        diversity_index_2: 0.468216,
        diversity_index_3: -0.531784,
        composite_ital_3: 1.2278444,
      },
      geometry: { type: "Point", coordinates: [12.32405, 45.43261] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.443481,
        lng: 12.339743,
        name: "Algiubagio",
        numreviews: 1614,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1187084-Reviews-Algiubagio-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.51682436,
        diversity_index_3: -0.48317564,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33974, 45.44348] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441944,
        lng: 12.321944,
        name: "Al Fontego dei Pescatori",
        numreviews: 597,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1191355-Reviews-Al_Fontego_dei_Pescatori-Venice_Veneto.html",
        percent_ital: 0.43383583,
        diversity_index_2: 0.42099363,
        diversity_index_3: -0.57900637,
        composite_ital_3: 1.7002267,
      },
      geometry: { type: "Point", coordinates: [12.32194, 45.44194] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440548,
        lng: 12.327803,
        name: "Taverna Capitan Uncino",
        numreviews: 661,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1192943-Reviews-Taverna_Capitan_Uncino-Venice_Veneto.html",
        percent_ital: 0.53403932,
        diversity_index_2: 0.38980651,
        diversity_index_3: -0.61019349,
        composite_ital_3: 1.5693905,
      },
      geometry: { type: "Point", coordinates: [12.3278, 45.44055] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.438267,
        lng: 12.336652,
        name: "Amo",
        numreviews: 283,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11930905-Reviews-Amo-Venice_Veneto.html",
        percent_ital: 0.52650177,
        diversity_index_2: 0.34749454,
        diversity_index_3: -0.65250546,
        composite_ital_3: 1.698507,
      },
      geometry: { type: "Point", coordinates: [12.33665, 45.43827] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435013,
        lng: 12.341413,
        name: "Ristorante Il Pesciolino d'Oro",
        numreviews: 210,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11932858-Reviews-Ristorante_Il_Pesciolino_d_Oro-Venice_Veneto.html",
        percent_ital: 0.28095239,
        diversity_index_2: 0.33609271,
        diversity_index_3: -0.66390729,
        composite_ital_3: 2.3599384,
      },
      geometry: { type: "Point", coordinates: [12.34141, 45.43501] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.437126,
        lng: 12.335153,
        name: "Bar Aperol",
        numreviews: 33,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11932867-Reviews-Bar_Aperol-Venice_Veneto.html",
        percent_ital: 0.24242425,
        diversity_index_2: 0.39076924,
        diversity_index_3: -0.60923076,
        composite_ital_3: 2.356704,
      },
      geometry: { type: "Point", coordinates: [12.33515, 45.43713] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437057,
        lng: 12.338887,
        name: "Osteria Ae Sconte",
        numreviews: 1912,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1197936-Reviews-Osteria_Ae_Sconte-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.37676227,
        diversity_index_3: -0.62323773,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33889, 45.43706] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.43642,
        lng: 12.342207,
        name: "Un Pasto Ovunque Cibo E Bevande Da Asporto",
        numreviews: 21,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11980138-Reviews-Un_Pasto_Ovunque_Cibo_E_Bevande_Da_Asporto-Venice_Veneto.html",
        percent_ital: 0.23809524,
        diversity_index_2: 0.20588236,
        diversity_index_3: -0.79411763,
        composite_ital_3: 3.0155349,
      },
      geometry: { type: "Point", coordinates: [12.34221, 45.43642] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43821,
        lng: 12.33204,
        name: "Ristorazione S Aponal Sas",
        numreviews: 12,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11980298-Reviews-Ristorazione_S_Aponal_Sas-Venice_Veneto.html",
        percent_ital: 0.75,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.3862944,
      },
      geometry: { type: "Point", coordinates: [12.33204, 45.43821] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442528,
        lng: 12.32408,
        name: "Orient Express",
        numreviews: 93,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d11992765-Reviews-Orient_Express-Venice_Veneto.html",
        percent_ital: 0.13978495,
        diversity_index_2: 0.31666666,
        diversity_index_3: -0.68333334,
        composite_ital_3: 3.1175556,
      },
      geometry: { type: "Point", coordinates: [12.32408, 45.44253] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.445545,
        lng: 12.321243,
        name: "Very Good - Pizzeria Bigoleria Gnoccheria",
        numreviews: 209,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12028843-Reviews-Very_Good_Pizzeria_Bigoleria_Gnoccheria-Venice_Veneto.html",
        percent_ital: 0.2583732,
        diversity_index_2: 0.29851118,
        diversity_index_3: -0.70148885,
        composite_ital_3: 2.5622981,
      },
      geometry: { type: "Point", coordinates: [12.32124, 45.44555] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.43539,
        lng: 12.341652,
        name: "Pasticceria Canonica",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12031283-Reviews-Pasticceria_Canonica-Venice_Veneto.html",
        percent_ital: 0.375,
        diversity_index_2: 0.13333334,
        diversity_index_3: -0.86666667,
        composite_ital_3: 2.9957321,
      },
      geometry: { type: "Point", coordinates: [12.34165, 45.43539] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437401,
        lng: 12.334352,
        name: "Trattoria Da Bruno",
        numreviews: 807,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12051350-Reviews-Trattoria_Da_Bruno-Venice_Veneto.html",
        percent_ital: 0.57249069,
        diversity_index_2: 0.32709938,
        diversity_index_3: -0.67290062,
        composite_ital_3: 1.6752501,
      },
      geometry: { type: "Point", coordinates: [12.33435, 45.4374] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.439865,
        lng: 12.334897,
        name: "Chips Amsterdam",
        numreviews: 45,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12068184-Reviews-Chips_Amsterdam-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.521164,
        diversity_index_3: -0.478836,
        composite_ital_3: 1.5679812,
      },
      geometry: { type: "Point", coordinates: [12.3349, 45.43986] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.438416,
        lng: 12.326432,
        name: "Al Cafetier",
        numreviews: 45,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12071627-Reviews-Al_Cafetier-Venice_Veneto.html",
        percent_ital: 0.15555556,
        diversity_index_2: 0.42105263,
        diversity_index_3: -0.57894737,
        composite_ital_3: 2.7257497,
      },
      geometry: { type: "Point", coordinates: [12.32643, 45.43842] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434017,
        lng: 12.330058,
        name: "Osteria Doge Morosini",
        numreviews: 571,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1210694-Reviews-Osteria_Doge_Morosini-Venice_Veneto.html",
        percent_ital: 0.30647987,
        diversity_index_2: 0.40339541,
        diversity_index_3: -0.59660459,
        composite_ital_3: 2.0904412,
      },
      geometry: { type: "Point", coordinates: [12.33006, 45.43402] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432419,
        lng: 12.322948,
        name: "Pizzeria Ristorante Al Profeta",
        numreviews: 1262,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1212253-Reviews-Pizzeria_Ristorante_Al_Profeta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33505884,
        diversity_index_3: -0.66494119,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32295, 45.43242] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435696,
        lng: 12.342283,
        name: "Ristorante Antica Sacrestia",
        numreviews: 1787,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1213210-Reviews-Ristorante_Antica_Sacrestia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.34697592,
        diversity_index_3: -0.65302408,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34228, 45.4357] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.439064,
        lng: 12.337116,
        name: "Zone 324",
        numreviews: 51,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12142889-Reviews-Zone_324-Venice_Veneto.html",
        percent_ital: 0.23529412,
        diversity_index_2: 0.35243902,
        diversity_index_3: -0.64756095,
        composite_ital_3: 2.4897966,
      },
      geometry: { type: "Point", coordinates: [12.33712, 45.43906] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43708,
        lng: 12.321333,
        name: "Trattoria la Rosa dei Venti",
        numreviews: 668,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1214689-Reviews-Trattoria_la_Rosa_dei_Venti-Venice_Veneto.html",
        percent_ital: 0.34281439,
        diversity_index_2: 0.41855466,
        diversity_index_3: -0.58144534,
        composite_ital_3: 1.9415139,
      },
      geometry: { type: "Point", coordinates: [12.32133, 45.43708] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.439922,
        lng: 12.336283,
        name: "Al Leon Bianco",
        numreviews: 55,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12157708-Reviews-Al_Leon_Bianco-Venice_Veneto.html",
        percent_ital: 0.25454545,
        diversity_index_2: 0.28687572,
        diversity_index_3: -0.71312428,
        composite_ital_3: 2.616982,
      },
      geometry: { type: "Point", coordinates: [12.33628, 45.43992] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435669,
        lng: 12.33637,
        name: "Nuova Valigia",
        numreviews: 194,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12170602-Reviews-Nuova_Valigia-Venice_Veneto.html",
        percent_ital: 0.13917525,
        diversity_index_2: 0.28212172,
        diversity_index_3: -0.71787828,
        composite_ital_3: 3.237438,
      },
      geometry: { type: "Point", coordinates: [12.33637, 45.43567] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432999,
        lng: 12.313599,
        name: "La Tecia Vegana",
        numreviews: 300,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12182668-Reviews-La_Tecia_Vegana-Venice_Veneto.html",
        percent_ital: 0.52999997,
        diversity_index_2: 0.64493251,
        diversity_index_3: -0.35506749,
        composite_ital_3: 1.0734879,
      },
      geometry: { type: "Point", coordinates: [12.3136, 45.433] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43536,
        lng: 12.346752,
        name: "La Speziale",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12185383-Reviews-La_Speziale-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34675, 45.43536] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434296,
        lng: 12.325829,
        name: "Caconero Caffe Bistrot",
        numreviews: 24,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12215119-Reviews-Caconero_Caffe_Bistrot-Venice_Veneto.html",
        percent_ital: 0.875,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.2321436,
      },
      geometry: { type: "Point", coordinates: [12.32583, 45.4343] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433311,
        lng: 12.330975,
        name: "Ristorante San Stefano",
        numreviews: 966,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1222111-Reviews-Ristorante_San_Stefano-Venice_Veneto.html",
        percent_ital: 0.27122152,
        diversity_index_2: 0.40742341,
        diversity_index_3: -0.59257662,
        composite_ital_3: 2.2027216,
      },
      geometry: { type: "Point", coordinates: [12.33098, 45.43331] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433247,
        lng: 12.330464,
        name: "Ristorante Il Caffe",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1222120-Reviews-Ristorante_Il_Caffe-Venice_Veneto.html",
        percent_ital: 0.15384616,
        diversity_index_2: 0.16666667,
        diversity_index_3: -0.83333331,
        composite_ital_3: 3.6635616,
      },
      geometry: { type: "Point", coordinates: [12.33046, 45.43325] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436893,
        lng: 12.347923,
        name: "Osteria Ale Do Marie",
        numreviews: 29,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12253930-Reviews-Osteria_Ale_Do_Marie-Venice_Veneto.html",
        percent_ital: 0.27586207,
        diversity_index_2: 0.33809525,
        diversity_index_3: -0.66190475,
        composite_ital_3: 2.3722818,
      },
      geometry: { type: "Point", coordinates: [12.34792, 45.43689] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.430027,
        lng: 12.332879,
        name: "Ristorante Messner",
        numreviews: 668,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1226795-Reviews-Ristorante_Messner-Venice_Veneto.html",
        percent_ital: 0.27994013,
        diversity_index_2: 0.34297511,
        diversity_index_3: -0.65702486,
        composite_ital_3: 2.343277,
      },
      geometry: { type: "Point", coordinates: [12.33288, 45.43003] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440468,
        lng: 12.335615,
        name: "Osteria Al Vecio Bragosso",
        numreviews: 1448,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1230518-Reviews-Osteria_Al_Vecio_Bragosso-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41950777,
        diversity_index_3: -0.58049226,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33562, 45.44047] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.436417,
        lng: 12.342192,
        name: "Morbidocroccante",
        numreviews: 20,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12312054-Reviews-Morbidocroccante-Venice_Veneto.html",
        percent_ital: 0.34999998999999998,
        diversity_index_2: 0.58974361,
        diversity_index_3: -0.41025639,
        composite_ital_3: 1.5778896,
      },
      geometry: { type: "Point", coordinates: [12.34219, 45.43642] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.44215,
        lng: 12.321486,
        name: "Kome Sushi Asian Food",
        numreviews: 116,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12321978-Reviews-Kome_Sushi_Asian_Food-Venice_Veneto.html",
        percent_ital: 0.74137932,
        diversity_index_2: 0.47782257,
        diversity_index_3: -0.52217746,
        composite_ital_3: 1.0377587,
      },
      geometry: { type: "Point", coordinates: [12.32149, 45.44215] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "Cafe",
        lat: 45.437435,
        lng: 12.341243,
        name: "All'Orologio",
        numreviews: 18,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12322606-Reviews-All_Orologio-Venice_Veneto.html",
        percent_ital: 0.055555556,
        diversity_index_2: 0.20588236,
        diversity_index_3: -0.79411763,
        composite_ital_3: 4.4708223,
      },
      geometry: { type: "Point", coordinates: [12.34124, 45.43744] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.42672,
        lng: 12.32492,
        name: "Pizzeria Ae Botti",
        numreviews: 120,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12338583-Reviews-Pizzeria_Ae_Botti-Venice_Veneto.html",
        percent_ital: 0.375,
        diversity_index_2: 0.4649123,
        diversity_index_3: -0.5350877,
        composite_ital_3: 1.7467358,
      },
      geometry: { type: "Point", coordinates: [12.32492, 45.42672] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.444138,
        lng: 12.32652,
        name: "Pasticceria Martini",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12339510-Reviews-Pasticceria_Martini-Venice_Veneto.html",
        percent_ital: 0.76923078,
        diversity_index_2: 0.23809524,
        diversity_index_3: -0.76190478,
        composite_ital_3: 1.6974487,
      },
      geometry: { type: "Point", coordinates: [12.32652, 45.44414] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43853,
        lng: 12.34168,
        name: "6342 Alla Corte",
        numreviews: 474,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12342787-Reviews-6342_Alla_Corte-Venice_Veneto.html",
        percent_ital: 0.29535866,
        diversity_index_2: 0.32540867,
        diversity_index_3: -0.6745913,
        composite_ital_3: 2.3422384,
      },
      geometry: { type: "Point", coordinates: [12.34168, 45.43853] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.439644,
        lng: 12.330624,
        name: "Easy Bar",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12345728-Reviews-Easy_Bar-Venice_Veneto.html",
        percent_ital: 0.2,
        diversity_index_2: 0.44444445,
        diversity_index_3: -0.55555558,
        composite_ital_3: 2.4203682,
      },
      geometry: { type: "Point", coordinates: [12.33062, 45.43964] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: null,
        lat: 45.440411,
        lng: 12.336077,
        name: "Elettra Di Ruggero Gorghetto & C. S.a.s.",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12373447-Reviews-Elettra_Di_Ruggero_Gorghetto_C_S_a_s-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33608, 45.44041] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.443378,
        lng: 12.32494,
        name: "Bar Laguna Snc",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12384386-Reviews-Bar_Laguna_Snc-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.5,
        diversity_index_3: -0.5,
        composite_ital_3: 1.6094379,
      },
      geometry: { type: "Point", coordinates: [12.32494, 45.44338] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434666,
        lng: 12.332396,
        name: "Acquapazza",
        numreviews: 63,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12392095-Reviews-Acquapazza-Venice_Veneto.html",
        percent_ital: 0.31746033,
        diversity_index_2: 0.35858586,
        diversity_index_3: -0.64141417,
        composite_ital_3: 2.1729896,
      },
      geometry: { type: "Point", coordinates: [12.3324, 45.43467] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43972,
        lng: 12.34046,
        name: "C & B Spaghetti",
        numreviews: 25,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12418747-Reviews-C_B_Spaghetti-Venice_Veneto.html",
        percent_ital: 0.039999999000000001,
        diversity_index_2: 0.35507247,
        diversity_index_3: -0.6449275,
        composite_ital_3: 4.2543092,
      },
      geometry: { type: "Point", coordinates: [12.34046, 45.43972] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.439198,
        lng: 12.320991,
        name: "Bar Da Nico",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12446943-Reviews-Bar_Da_Nico-Venice_Veneto.html",
        percent_ital: 0.25,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 2.4849067,
      },
      geometry: { type: "Point", coordinates: [12.32099, 45.4392] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.433903,
        lng: 12.34216,
        name: "Danieli Bistro",
        numreviews: 74,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12447597-Reviews-Danieli_Bistro-Venice_Veneto.html",
        percent_ital: 0.2972973,
        diversity_index_2: 0.32285115,
        diversity_index_3: -0.67714882,
        composite_ital_3: 2.3435864,
      },
      geometry: { type: "Point", coordinates: [12.34216, 45.4339] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.438862,
        lng: 12.32129,
        name: "Zanze XVI",
        numreviews: 337,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12453577-Reviews-Zanze_XVI-Venice_Veneto.html",
        percent_ital: 0.57270032,
        diversity_index_2: 0.38242796,
        diversity_index_3: -0.61757207,
        composite_ital_3: 1.5186077,
      },
      geometry: { type: "Point", coordinates: [12.32129, 45.43886] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438595,
        lng: 12.33478,
        name: "Camoma Veggie Take Away",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12505387-Reviews-Camoma_Veggie_Take_Away-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33478, 45.43859] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.434437,
        lng: 12.346397,
        name: "Baraondacafe3725",
        numreviews: 30,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12535430-Reviews-Baraondacafe3725-Venice_Veneto.html",
        percent_ital: 0.2,
        diversity_index_2: 0.37318841,
        diversity_index_3: -0.62681162,
        composite_ital_3: 2.5951097,
      },
      geometry: { type: "Point", coordinates: [12.3464, 45.43444] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.443153,
        lng: 12.338754,
        name: "Combo",
        numreviews: 43,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12597135-Reviews-Combo-Venice_Veneto.html",
        percent_ital: 0.46511629,
        diversity_index_2: 0.36231884,
        diversity_index_3: -0.63768113,
        composite_ital_3: 1.7806985,
      },
      geometry: { type: "Point", coordinates: [12.33875, 45.44315] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439201,
        lng: 12.320954,
        name: "Antica Osteria Al Leone Alato",
        numreviews: 277,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12614462-Reviews-Antica_Osteria_Al_Leone_Alato-Venice_Veneto.html",
        percent_ital: 0.23465703,
        diversity_index_2: 0.39813083,
        diversity_index_3: -0.60186917,
        composite_ital_3: 2.3706048,
      },
      geometry: { type: "Point", coordinates: [12.32095, 45.4392] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.432812,
        lng: 12.317462,
        name: "Bar Vintiotto",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12618026-Reviews-Bar_Vintiotto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.31746, 45.43281] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435635,
        lng: 12.333465,
        name: "Kofler",
        numreviews: 252,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12626537-Reviews-Kofler-Venice_Veneto.html",
        percent_ital: 0.77380955,
        diversity_index_2: 0.2992402,
        diversity_index_3: -0.70075977,
        composite_ital_3: 1.4629382,
      },
      geometry: { type: "Point", coordinates: [12.33347, 45.43563] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.440987,
        lng: 12.334893,
        name: "Queen's Chips",
        numreviews: 37,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12643934-Reviews-Queen_s_Chips-Venice_Veneto.html",
        percent_ital: 0.27027026,
        diversity_index_2: 0.42328042,
        diversity_index_3: -0.57671958,
        composite_ital_3: 2.1680532,
      },
      geometry: { type: "Point", coordinates: [12.33489, 45.44099] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44381,
        lng: 12.326198,
        name: "Trattoria Il Poggio Pizzeria",
        numreviews: 54,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12657524-Reviews-Trattoria_Il_Poggio_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.24074075,
        diversity_index_2: 0.52380955,
        diversity_index_3: -0.47619045,
        composite_ital_3: 2.0706618,
      },
      geometry: { type: "Point", coordinates: [12.3262, 45.44381] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435921,
        lng: 12.326406,
        name: "Osteria Al Vecio Forno",
        numreviews: 364,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12671112-Reviews-Osteria_Al_Vecio_Forno-Venice_Veneto.html",
        percent_ital: 0.40109891,
        diversity_index_2: 0.41374013,
        diversity_index_3: -0.58625984,
        composite_ital_3: 1.7960644,
      },
      geometry: { type: "Point", coordinates: [12.32641, 45.43592] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438515,
        lng: 12.345233,
        name: "Ostaria Santa Giustina",
        numreviews: 109,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12682019-Reviews-Ostaria_Santa_Giustina-Venice_Veneto.html",
        percent_ital: 0.36697248,
        diversity_index_2: 0.33568075,
        diversity_index_3: -0.66431928,
        composite_ital_3: 2.094063,
      },
      geometry: { type: "Point", coordinates: [12.34523, 45.43852] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439182,
        lng: 12.334858,
        name: "Bussola Cocktail Lab",
        numreviews: 89,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12700454-Reviews-Bussola_Cocktail_Lab-Venice_Veneto.html",
        percent_ital: 0.22471911,
        diversity_index_2: 0.33291924,
        diversity_index_3: -0.66708076,
        composite_ital_3: 2.5927594,
      },
      geometry: { type: "Point", coordinates: [12.33486, 45.43918] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.440678,
        lng: 12.329076,
        name: "PizzOne",
        numreviews: 22,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12710214-Reviews-PizzOne-Venice_Veneto.html",
        percent_ital: 0.27272728,
        diversity_index_2: 0.4852941,
        diversity_index_3: -0.5147059,
        composite_ital_3: 2.0222831,
      },
      geometry: { type: "Point", coordinates: [12.32908, 45.44068] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.432583,
        lng: 12.323923,
        name: "Officina San Barnaba",
        numreviews: 89,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12712979-Reviews-Officina_San_Barnaba-Venice_Veneto.html",
        percent_ital: 0.32584271,
        diversity_index_2: 0.31256831,
        diversity_index_3: -0.68743169,
        composite_ital_3: 2.2842727,
      },
      geometry: { type: "Point", coordinates: [12.32392, 45.43258] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.439274,
        lng: 12.333915,
        name: "Mr. Pasta",
        numreviews: 32,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12714086-Reviews-Mr_Pasta-Venice_Veneto.html",
        percent_ital: 0.15625,
        diversity_index_2: 0.51322752,
        diversity_index_3: -0.48677248,
        composite_ital_3: 2.523334,
      },
      geometry: { type: "Point", coordinates: [12.33391, 45.43927] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.445332,
        lng: 12.329279,
        name: "Ae Bricoe",
        numreviews: 98,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12724021-Reviews-Ae_Bricoe-Venice_Veneto.html",
        percent_ital: 0.64285713,
        diversity_index_2: 0.75525528,
        diversity_index_3: -0.24474472,
        composite_ital_3: 0.72253221,
      },
      geometry: { type: "Point", coordinates: [12.32928, 45.44533] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432789,
        lng: 12.317232,
        name: "Osteria Bakan",
        numreviews: 87,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12728849-Reviews-Osteria_Bakan-Venice_Veneto.html",
        percent_ital: 0.64367819,
        diversity_index_2: 0.42803031,
        diversity_index_3: -0.57196969,
        composite_ital_3: 1.2891177,
      },
      geometry: { type: "Point", coordinates: [12.31723, 45.43279] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.43679,
        lng: 12.32675,
        name: "Snack Bar All'angolo",
        numreviews: 26,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12789970-Reviews-Snack_Bar_All_angolo-Venice_Veneto.html",
        percent_ital: 0.46153846,
        diversity_index_2: 0.26666668,
        diversity_index_3: -0.73333335,
        composite_ital_3: 2.0949457,
      },
      geometry: { type: "Point", coordinates: [12.32675, 45.43679] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437893,
        lng: 12.335136,
        name: "Cafe Saraceno",
        numreviews: 156,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12794956-Reviews-Cafe_Saraceno-Venice_Veneto.html",
        percent_ital: 0.070512824,
        diversity_index_2: 0.32252353,
        diversity_index_3: -0.67747647,
        composite_ital_3: 3.7835398,
      },
      geometry: { type: "Point", coordinates: [12.33514, 45.43789] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.435692,
        lng: 12.326225,
        name: "Bacaro 22 vintido'",
        numreviews: 346,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12828784-Reviews-Bacaro_22_vintido-Venice_Veneto.html",
        percent_ital: 0.23121387,
        diversity_index_2: 0.30574822,
        diversity_index_3: -0.69425178,
        composite_ital_3: 2.6494055,
      },
      geometry: { type: "Point", coordinates: [12.32623, 45.43569] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444023,
        lng: 12.326538,
        name: "Maciao",
        numreviews: 45,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12851704-Reviews-Maciao-Venice_Veneto.html",
        percent_ital: 0.80000000999999998,
        diversity_index_2: 0.36363637,
        diversity_index_3: -0.63636363,
        composite_ital_3: 1.2347444,
      },
      geometry: { type: "Point", coordinates: [12.32654, 45.44402] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "Pizza",
        lat: 45.444374,
        lng: 12.323922,
        name: "Pizzeria Al Faraone",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12858223-Reviews-Pizzeria_Al_Faraone-Venice_Veneto.html",
        percent_ital: 0.22222222,
        diversity_index_2: 0.52380955,
        diversity_index_3: -0.47619045,
        composite_ital_3: 2.1507044,
      },
      geometry: { type: "Point", coordinates: [12.32392, 45.44437] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.439548,
        lng: 12.334601,
        name: "Hostaria da Noni",
        numreviews: 35,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12868591-Reviews-Hostaria_da_Noni-Venice_Veneto.html",
        percent_ital: 0.45714286,
        diversity_index_2: 0.2736842,
        diversity_index_3: -0.7263158,
        composite_ital_3: 2.0785396,
      },
      geometry: { type: "Point", coordinates: [12.3346, 45.43955] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.434952,
        lng: 12.346945,
        name: "Osteria Alla Rampa",
        numreviews: 19,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12882871-Reviews-Osteria_Alla_Rampa-Venice_Veneto.html",
        percent_ital: 0.57894737,
        diversity_index_2: 0.30555555,
        diversity_index_3: -0.69444442,
        composite_ital_3: 1.7321674,
      },
      geometry: { type: "Point", coordinates: [12.34694, 45.43495] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44558,
        lng: 12.321591,
        name: "Agli Archi",
        numreviews: 145,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12883160-Reviews-Agli_Archi-Venice_Veneto.html",
        percent_ital: 0.14482759,
        diversity_index_2: 0.27083871,
        diversity_index_3: -0.72916126,
        composite_ital_3: 3.2384431,
      },
      geometry: { type: "Point", coordinates: [12.32159, 45.44558] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439442,
        lng: 12.334214,
        name: "Ai dogi",
        numreviews: 74,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12912127-Reviews-Ai_dogi-Venice_Veneto.html",
        percent_ital: 0.25675675,
        diversity_index_2: 0.3577922,
        diversity_index_3: -0.6422078,
        composite_ital_3: 2.387429,
      },
      geometry: { type: "Point", coordinates: [12.33421, 45.43944] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432381,
        lng: 12.355502,
        name: "Osteria Da Valentino",
        numreviews: 38,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12921703-Reviews-Osteria_Da_Valentino-Venice_Veneto.html",
        percent_ital: 0.34210527,
        diversity_index_2: 0.36182335,
        diversity_index_3: -0.63817668,
        composite_ital_3: 2.089236,
      },
      geometry: { type: "Point", coordinates: [12.3555, 45.43238] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.439125,
        lng: 12.334225,
        name: "Farini",
        numreviews: 120,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d12934491-Reviews-Farini-Venice_Veneto.html",
        percent_ital: 0.22499999,
        diversity_index_2: 0.25394645,
        diversity_index_3: -0.74605358,
        composite_ital_3: 2.8622868,
      },
      geometry: { type: "Point", coordinates: [12.33422, 45.43912] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: null,
        lat: 45.434696,
        lng: 12.346394,
        name: "Bar Terrazza Al Sole",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13006811-Reviews-Bar_Terrazza_Al_Sole-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34639, 45.4347] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436066,
        lng: 12.338387,
        name: "Al Conte Pescaor",
        numreviews: 1143,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1308412-Reviews-Al_Conte_Pescaor-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.38480678,
        diversity_index_3: -0.61519325,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33839, 45.43607] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "Italian",
        lat: 45.435986,
        lng: 12.340082,
        name: "Ristorante Stefano",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13114824-Reviews-Ristorante_Stefano-Venice_Veneto.html",
        percent_ital: 0.42857143,
        diversity_index_2: 0.40000001000000002,
        diversity_index_3: -0.60000001999999997,
        composite_ital_3: 1.7635885,
      },
      geometry: { type: "Point", coordinates: [12.34008, 45.43599] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434002,
        lng: 12.349365,
        name: "Ostaria al Forno",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13114830-Reviews-Ostaria_al_Forno-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.25,
        diversity_index_3: -0.75,
        composite_ital_3: 2.3025851,
      },
      geometry: { type: "Point", coordinates: [12.34937, 45.434] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.431572,
        lng: 12.324764,
        name: "Antica Locanda Montin",
        numreviews: 49,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13114901-Reviews-Antica_Locanda_Montin-Venice_Veneto.html",
        percent_ital: 0.24489796,
        diversity_index_2: 0.36984354,
        diversity_index_3: -0.63015646,
        composite_ital_3: 2.4015889,
      },
      geometry: { type: "Point", coordinates: [12.32476, 45.43157] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.441338,
        lng: 12.321211,
        name: "Rossopomodoro Venezia Santa Lucia",
        numreviews: 175,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13138368-Reviews-Rossopomodoro_Venezia_Santa_Lucia-Venice_Veneto.html",
        percent_ital: 0.63428569,
        diversity_index_2: 0.23654455,
        diversity_index_3: -0.76345545,
        composite_ital_3: 1.8968745,
      },
      geometry: { type: "Point", coordinates: [12.32121, 45.44134] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432301,
        lng: 12.352516,
        name: "Salvmeria",
        numreviews: 98,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13142958-Reviews-Salvmeria-Venice_Veneto.html",
        percent_ital: 0.5714286,
        diversity_index_2: 0.36464646,
        diversity_index_3: -0.63535357,
        composite_ital_3: 1.5684427,
      },
      geometry: { type: "Point", coordinates: [12.35252, 45.4323] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434971,
        lng: 12.32167,
        name: "Ristorante Bakaro - Osteria & Co.",
        numreviews: 338,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13143574-Reviews-Ristorante_Bakaro_Osteria_Co-Venice_Veneto.html",
        percent_ital: 0.59171599,
        diversity_index_2: 0.43637285,
        diversity_index_3: -0.56362712,
        composite_ital_3: 1.3539867,
      },
      geometry: { type: "Point", coordinates: [12.32167, 45.43497] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.429821,
        lng: 12.33288,
        name: "Bistro da Cici",
        numreviews: 73,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13163085-Reviews-Bistro_da_Cici-Venice_Veneto.html",
        percent_ital: 0.71232879,
        diversity_index_2: 0.26811594,
        diversity_index_3: -0.73188406,
        composite_ital_3: 1.6555514,
      },
      geometry: { type: "Point", coordinates: [12.33288, 45.42982] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441212,
        lng: 12.339932,
        name: "Recondito",
        numreviews: 90,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13173444-Reviews-Recondito-Venice_Veneto.html",
        percent_ital: 0.34444445,
        diversity_index_2: 0.45706216,
        diversity_index_3: -0.54293787,
        composite_ital_3: 1.8487583,
      },
      geometry: { type: "Point", coordinates: [12.33993, 45.44121] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44286,
        lng: 12.324694,
        name: "Al Brindisi",
        numreviews: 740,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320305-Reviews-Al_Brindisi-Venice_Veneto.html",
        percent_ital: 0.25405404,
        diversity_index_2: 0.36406684,
        diversity_index_3: -0.63593316,
        composite_ital_3: 2.380626,
      },
      geometry: { type: "Point", coordinates: [12.32469, 45.44286] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443783,
        lng: 12.32981,
        name: "Osteria Da Poggi",
        numreviews: 149,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320307-Reviews-Osteria_Da_Poggi-Venice_Veneto.html",
        percent_ital: 0.38926175,
        diversity_index_2: 0.3803179,
        diversity_index_3: -0.61968207,
        composite_ital_3: 1.910251,
      },
      geometry: { type: "Point", coordinates: [12.32981, 45.44378] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441574,
        lng: 12.321136,
        name: "Ristorante Roma",
        numreviews: 355,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320308-Reviews-Ristorante_Roma-Venice_Veneto.html",
        percent_ital: 0.18309858,
        diversity_index_2: 0.36392537,
        diversity_index_3: -0.63607466,
        composite_ital_3: 2.7085369,
      },
      geometry: { type: "Point", coordinates: [12.32114, 45.44157] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436684,
        lng: 12.340109,
        name: "Ristorante Da Carletto",
        numreviews: 741,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320317-Reviews-Ristorante_Da_Carletto-Venice_Veneto.html",
        percent_ital: 0.24426451,
        diversity_index_2: 0.47696254,
        diversity_index_3: -0.52303743,
        composite_ital_3: 2.1498208,
      },
      geometry: { type: "Point", coordinates: [12.34011, 45.43668] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434605,
        lng: 12.34172,
        name: "Trovatore",
        numreviews: 992,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320319-Reviews-Trovatore-Venice_Veneto.html",
        percent_ital: 0.48387095,
        diversity_index_2: 0.35397971,
        diversity_index_3: -0.64602029,
        composite_ital_3: 1.7644527,
      },
      geometry: { type: "Point", coordinates: [12.34172, 45.4346] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432178,
        lng: 12.35152,
        name: "Sottoprova",
        numreviews: 290,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320321-Reviews-Sottoprova-Venice_Veneto.html",
        percent_ital: 0.24827586,
        diversity_index_2: 0.48866749,
        diversity_index_3: -0.51133251,
        composite_ital_3: 2.1092877,
      },
      geometry: { type: "Point", coordinates: [12.35152, 45.43218] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435043,
        lng: 12.344341,
        name: "Trattoria da Giorgio ai Greci",
        numreviews: 807,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320323-Reviews-Trattoria_da_Giorgio_ai_Greci-Venice_Veneto.html",
        percent_ital: 0.23791821,
        diversity_index_2: 0.37979999,
        diversity_index_3: -0.62020004,
        composite_ital_3: 2.4039388,
      },
      geometry: { type: "Point", coordinates: [12.34434, 45.43504] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434101,
        lng: 12.342743,
        name: "Ristorante Principessa",
        numreviews: 558,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320327-Reviews-Ristorante_Principessa-Venice_Veneto.html",
        percent_ital: 0.24193548,
        diversity_index_2: 0.32879314,
        diversity_index_3: -0.67120683,
        composite_ital_3: 2.5314107,
      },
      geometry: { type: "Point", coordinates: [12.34274, 45.4341] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434471,
        lng: 12.341393,
        name: "Taverna dei Dogi",
        numreviews: 231,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320328-Reviews-Taverna_dei_Dogi-Venice_Veneto.html",
        percent_ital: 0.2034632,
        diversity_index_2: 0.21301948,
        diversity_index_3: -0.78698051,
        composite_ital_3: 3.1386418,
      },
      geometry: { type: "Point", coordinates: [12.34139, 45.43447] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: null,
        lat: 45.431652,
        lng: 12.328908,
        name: "Cartis di Marcella Smith & C.",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320333-Reviews-Cartis_di_Marcella_Smith_C-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32891, 45.43165] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.438072,
        lng: 12.321194,
        name: "Ristorante Giardino d'Inverno - Hotel Papadopoli",
        numreviews: 123,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320335-Reviews-Ristorante_Giardino_d_Inverno_Hotel_Papadopoli-Venice_Veneto.html",
        percent_ital: 0.65853661,
        diversity_index_2: 0.33212888,
        diversity_index_3: -0.66787112,
        composite_ital_3: 1.5199673,
      },
      geometry: { type: "Point", coordinates: [12.32119, 45.43807] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.443874,
        lng: 12.326484,
        name: "Ristorante al Gazebo",
        numreviews: 473,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320338-Reviews-Ristorante_al_Gazebo-Venice_Veneto.html",
        percent_ital: 0.2769556,
        diversity_index_2: 0.36002696,
        diversity_index_3: -0.63997304,
        composite_ital_3: 2.3054745,
      },
      geometry: { type: "Point", coordinates: [12.32648, 45.44387] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.443989,
        lng: 12.328197,
        name: "Le Campane",
        numreviews: 362,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320341-Reviews-Le_Campane-Venice_Veneto.html",
        percent_ital: 0.42817679,
        diversity_index_2: 0.29195803,
        diversity_index_3: -0.70804197,
        composite_ital_3: 2.0793643,
      },
      geometry: { type: "Point", coordinates: [12.3282, 45.44399] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435165,
        lng: 12.339346,
        name: "Al Chianti",
        numreviews: 1134,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320343-Reviews-Al_Chianti-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.34107351,
        diversity_index_3: -0.65892649,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33935, 45.43516] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436798,
        lng: 12.338917,
        name: "Ristorante Cantina Canaletto",
        numreviews: 556,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320344-Reviews-Ristorante_Cantina_Canaletto-Venice_Veneto.html",
        percent_ital: 0.33812949,
        diversity_index_2: 0.4188388,
        diversity_index_3: -0.5811612,
        composite_ital_3: 1.9545954,
      },
      geometry: { type: "Point", coordinates: [12.33892, 45.4368] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43457,
        lng: 12.349667,
        name: "Trattoria Da Paolo",
        numreviews: 290,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320345-Reviews-Trattoria_Da_Paolo-Venice_Veneto.html",
        percent_ital: 0.33103448,
        diversity_index_2: 0.36870748,
        diversity_index_3: -0.63129252,
        composite_ital_3: 2.1032844,
      },
      geometry: { type: "Point", coordinates: [12.34967, 45.43457] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.44643,
        lng: 12.328393,
        name: "Osteria ai 40 Ladroni",
        numreviews: 1084,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320357-Reviews-Osteria_ai_40_Ladroni-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.38289478,
        diversity_index_3: -0.61710525,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32839, 45.44643] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439919,
        lng: 12.337049,
        name: "Trattoria Al Vagon",
        numreviews: 715,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320359-Reviews-Trattoria_Al_Vagon-Venice_Veneto.html",
        percent_ital: 0.37062937,
        diversity_index_2: 0.41842288,
        diversity_index_3: -0.58157712,
        composite_ital_3: 1.8638154,
      },
      geometry: { type: "Point", coordinates: [12.33705, 45.43992] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440907,
        lng: 12.33982,
        name: "Trattoria Cea",
        numreviews: 174,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320362-Reviews-Trattoria_Cea-Venice_Veneto.html",
        percent_ital: 0.36781609,
        diversity_index_2: 0.2851761,
        diversity_index_3: -0.7148239,
        composite_ital_3: 2.2548206,
      },
      geometry: { type: "Point", coordinates: [12.33982, 45.44091] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.441597,
        lng: 12.340346,
        name: "La Colonna",
        numreviews: 891,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320364-Reviews-La_Colonna-Venice_Veneto.html",
        percent_ital: 0.31874299,
        diversity_index_2: 0.39044583,
        diversity_index_3: -0.60955417,
        composite_ital_3: 2.0838363,
      },
      geometry: { type: "Point", coordinates: [12.34035, 45.4416] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439625,
        lng: 12.337168,
        name: "Ca Dolfin",
        numreviews: 562,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320365-Reviews-Ca_Dolfin-Venice_Veneto.html",
        percent_ital: 0.20996441,
        diversity_index_2: 0.38738576,
        diversity_index_3: -0.61261427,
        composite_ital_3: 2.5091515,
      },
      geometry: { type: "Point", coordinates: [12.33717, 45.43962] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443916,
        lng: 12.325365,
        name: "Trattoria Bar Pontini",
        numreviews: 2171,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320368-Reviews-Trattoria_Bar_Pontini-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.19137618,
        diversity_index_3: -0.80862379,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32536, 45.44392] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43428,
        lng: 12.346392,
        name: "Taverna Scalinetto",
        numreviews: 1347,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320374-Reviews-Taverna_Scalinetto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.3440083,
        diversity_index_3: -0.65599167,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34639, 45.43428] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434906,
        lng: 12.347011,
        name: "Bacarando Ai Corazzieri",
        numreviews: 110,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320376-Reviews-Bacarando_Ai_Corazzieri-Venice_Veneto.html",
        percent_ital: 0.39090911,
        diversity_index_2: 0.46839333,
        diversity_index_3: -0.53160667,
        composite_ital_3: 1.6977271,
      },
      geometry: { type: "Point", coordinates: [12.34701, 45.43491] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.430611,
        lng: 12.329407,
        name: "Ai Cugnai Dal 1911",
        numreviews: 1019,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320385-Reviews-Ai_Cugnai_Dal_1911-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.35456836,
        diversity_index_3: -0.64543164,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32941, 45.43061] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.434818,
        lng: 12.323839,
        name: "Ristorante Pizzeria Ai Sportivi",
        numreviews: 664,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320386-Reviews-Ristorante_Pizzeria_Ai_Sportivi-Venice_Veneto.html",
        percent_ital: 0.23945783,
        diversity_index_2: 0.33264491,
        diversity_index_3: -0.66735506,
        composite_ital_3: 2.5300577,
      },
      geometry: { type: "Point", coordinates: [12.32384, 45.43482] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436993,
        lng: 12.319886,
        name: "Trattoria Da Biasini",
        numreviews: 69,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320393-Reviews-Trattoria_Da_Biasini-Venice_Veneto.html",
        percent_ital: 0.23188406,
        diversity_index_2: 0.52131379,
        diversity_index_3: -0.47868621,
        composite_ital_3: 2.112921,
      },
      geometry: { type: "Point", coordinates: [12.31989, 45.43699] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.444778,
        lng: 12.328984,
        name: "Cantina Aziende Agricole",
        numreviews: 602,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320395-Reviews-Cantina_Aziende_Agricole-Venice_Veneto.html",
        percent_ital: 0.28737542,
        diversity_index_2: 0.41077539,
        diversity_index_3: -0.58922458,
        composite_ital_3: 2.1366744,
      },
      geometry: { type: "Point", coordinates: [12.32898, 45.44478] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.43512,
        lng: 12.334908,
        name: "Ai Mercanti",
        numreviews: 1653,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320403-Reviews-Ai_Mercanti-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41624445,
        diversity_index_3: -0.58375555,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33491, 45.43512] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.437756,
        lng: 12.337182,
        name: "Rosticceria Gislon",
        numreviews: 1309,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320404-Reviews-Rosticceria_Gislon-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.28304252,
        diversity_index_3: -0.71695745,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33718, 45.43776] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433968,
        lng: 12.333834,
        name: "Ristorante Al Theatro",
        numreviews: 729,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320406-Reviews-Ristorante_Al_Theatro-Venice_Veneto.html",
        percent_ital: 0.20164609,
        diversity_index_2: 0.36077708,
        diversity_index_3: -0.63922292,
        composite_ital_3: 2.6207361,
      },
      geometry: { type: "Point", coordinates: [12.33383, 45.43397] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438049,
        lng: 12.336109,
        name: "Al Buso",
        numreviews: 464,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320410-Reviews-Al_Buso-Venice_Veneto.html",
        percent_ital: 0.21551724,
        diversity_index_2: 0.40245083,
        diversity_index_3: -0.5975492,
        composite_ital_3: 2.4448967,
      },
      geometry: { type: "Point", coordinates: [12.33611, 45.43805] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434826,
        lng: 12.337229,
        name: "Ristorante Noemi",
        numreviews: 766,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320414-Reviews-Ristorante_Noemi-Venice_Veneto.html",
        percent_ital: 0.37336814,
        diversity_index_2: 0.34351549,
        diversity_index_3: -0.65648448,
        composite_ital_3: 2.0537136,
      },
      geometry: { type: "Point", coordinates: [12.33723, 45.43483] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435059,
        lng: 12.339051,
        name: "Kori",
        numreviews: 553,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320415-Reviews-Kori-Venice_Veneto.html",
        percent_ital: 0.17179024,
        diversity_index_2: 0.33695179,
        diversity_index_3: -0.66304821,
        composite_ital_3: 2.8492966,
      },
      geometry: { type: "Point", coordinates: [12.33905, 45.43506] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437325,
        lng: 12.336936,
        name: "Da Mamo",
        numreviews: 1831,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320417-Reviews-Da_Mamo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.31138471,
        diversity_index_3: -0.68861532,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33694, 45.43733] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43771,
        lng: 12.334868,
        name: "Ristorante Florida",
        numreviews: 1561,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320424-Reviews-Ristorante_Florida-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.16668394,
        diversity_index_3: -0.83331609,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33487, 45.43771] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436558,
        lng: 12.335864,
        name: "Al Teatro Goldoni",
        numreviews: 638,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320425-Reviews-Al_Teatro_Goldoni-Venice_Veneto.html",
        percent_ital: 0.16144201,
        diversity_index_2: 0.3705689,
        diversity_index_3: -0.62943113,
        composite_ital_3: 2.8163252,
      },
      geometry: { type: "Point", coordinates: [12.33586, 45.43656] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438732,
        lng: 12.332785,
        name: "Jazz Club Novecento 900",
        numreviews: 306,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320427-Reviews-Jazz_Club_Novecento_900-Venice_Veneto.html",
        percent_ital: 0.28431374,
        diversity_index_2: 0.31818181,
        diversity_index_3: -0.68181819,
        composite_ital_3: 2.4028094,
      },
      geometry: { type: "Point", coordinates: [12.33278, 45.43873] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434116,
        lng: 12.334595,
        name: "Anonimo Veneziano",
        numreviews: 581,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320428-Reviews-Anonimo_Veneziano-Venice_Veneto.html",
        percent_ital: 0.43889844,
        diversity_index_2: 0.33605969,
        diversity_index_3: -0.66394031,
        composite_ital_3: 1.9139537,
      },
      geometry: { type: "Point", coordinates: [12.3346, 45.43412] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435371,
        lng: 12.336682,
        name: "Trattoria a Le Colonete",
        numreviews: 420,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320433-Reviews-Trattoria_a_Le_Colonete-Venice_Veneto.html",
        percent_ital: 0.20238096,
        diversity_index_2: 0.31104282,
        diversity_index_3: -0.68895721,
        composite_ital_3: 2.7654281,
      },
      geometry: { type: "Point", coordinates: [12.33668, 45.43537] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436943,
        lng: 12.329722,
        name: "Al Campanile",
        numreviews: 362,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320435-Reviews-Al_Campanile-Venice_Veneto.html",
        percent_ital: 0.44751382,
        diversity_index_2: 0.26881099,
        diversity_index_3: -0.73118901,
        composite_ital_3: 2.1177945,
      },
      geometry: { type: "Point", coordinates: [12.32972, 45.43694] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43816,
        lng: 12.333822,
        name: "Antica Osteria Ruga Rialto",
        numreviews: 465,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1320438-Reviews-Antica_Osteria_Ruga_Rialto-Venice_Veneto.html",
        percent_ital: 0.68817204,
        diversity_index_2: 0.33655083,
        diversity_index_3: -0.66344917,
        composite_ital_3: 1.4627225,
      },
      geometry: { type: "Point", coordinates: [12.33382, 45.43816] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.438492,
        lng: 12.341758,
        name: "Ossi di Seppia",
        numreviews: 26,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13225780-Reviews-Ossi_di_Seppia-Venice_Veneto.html",
        percent_ital: 0.46153846,
        diversity_index_2: 0.25714287,
        diversity_index_3: -0.7428571,
        composite_ital_3: 2.1313133,
      },
      geometry: { type: "Point", coordinates: [12.34176, 45.43849] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442711,
        lng: 12.3411,
        name: "Osteria Al Tajer",
        numreviews: 45,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13289104-Reviews-Osteria_Al_Tajer-Venice_Veneto.html",
        percent_ital: 0.51111114,
        diversity_index_2: 0.21343873,
        diversity_index_3: -0.78656125,
        composite_ital_3: 2.2155735,
      },
      geometry: { type: "Point", coordinates: [12.3411, 45.44271] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.439098,
        lng: 12.334832,
        name: "Barcollo",
        numreviews: 19,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13289603-Reviews-Barcollo-Venice_Veneto.html",
        percent_ital: 0.42105263,
        diversity_index_2: 0.26923078,
        diversity_index_3: -0.73076922,
        composite_ital_3: 2.1771839,
      },
      geometry: { type: "Point", coordinates: [12.33483, 45.4391] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443424,
        lng: 12.327966,
        name: "Bar alle Guglie",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13339893-Reviews-Bar_alle_Guglie-Venice_Veneto.html",
        percent_ital: 0.80000000999999998,
        diversity_index_2: 0.1,
        diversity_index_3: -0.89999998000000003,
        composite_ital_3: 2.5257285,
      },
      geometry: { type: "Point", coordinates: [12.32797, 45.44342] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434135,
        lng: 12.343947,
        name: "Ristorante da Lorenzo",
        numreviews: 32,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13368745-Reviews-Ristorante_da_Lorenzo-Venice_Veneto.html",
        percent_ital: 0.09375,
        diversity_index_2: 0.4045977,
        diversity_index_3: -0.5954023,
        composite_ital_3: 3.2719858,
      },
      geometry: { type: "Point", coordinates: [12.34395, 45.43413] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439232,
        lng: 12.323116,
        name: "Punto G",
        numreviews: 115,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13454410-Reviews-Punto_G-Venice_Veneto.html",
        percent_ital: 0.59130436,
        diversity_index_2: 0.31632653,
        diversity_index_3: -0.6836735,
        composite_ital_3: 1.6764046,
      },
      geometry: { type: "Point", coordinates: [12.32312, 45.43923] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "Italian",
        lat: 45.442558,
        lng: 12.308576,
        name: "Remida",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13478022-Reviews-Remida-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.30858, 45.44256] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.43996,
        lng: 12.339087,
        name: "Art Cafe Venezia",
        numreviews: 55,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13486872-Reviews-Art_Cafe_Venezia-Venice_Veneto.html",
        percent_ital: 0.2,
        diversity_index_2: 0.48985508,
        diversity_index_3: -0.51014495,
        composite_ital_3: 2.3230836,
      },
      geometry: { type: "Point", coordinates: [12.33909, 45.43996] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433487,
        lng: 12.334321,
        name: "VinoVino Wine Bar",
        numreviews: 80,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13551871-Reviews-VinoVino_Wine_Bar-Venice_Veneto.html",
        percent_ital: 0.1375,
        diversity_index_2: 0.31801242,
        diversity_index_3: -0.68198758,
        composite_ital_3: 3.1297963,
      },
      geometry: { type: "Point", coordinates: [12.33432, 45.43349] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444401,
        lng: 12.332305,
        name: "sullaluna",
        numreviews: 72,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13651716-Reviews-Sullaluna-Venice_Veneto.html",
        percent_ital: 0.30555555,
        diversity_index_2: 0.52031928,
        diversity_index_3: -0.47968072,
        composite_ital_3: 1.8389363,
      },
      geometry: { type: "Point", coordinates: [12.3323, 45.4444] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436111,
        lng: 12.33804,
        name: "Trattoria Alla Scala",
        numreviews: 667,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1368545-Reviews-Trattoria_Alla_Scala-Venice_Veneto.html",
        percent_ital: 0.80809593,
        diversity_index_2: 0.30580363,
        diversity_index_3: -0.69419634,
        composite_ital_3: 1.3978866,
      },
      geometry: { type: "Point", coordinates: [12.33804, 45.43611] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435745,
        lng: 12.336116,
        name: "Osteria San Luca",
        numreviews: 58,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13756302-Reviews-Osteria_San_Luca-Venice_Veneto.html",
        percent_ital: 0.1724138,
        diversity_index_2: 0.21853742,
        diversity_index_3: -0.78146255,
        composite_ital_3: 3.2786558,
      },
      geometry: { type: "Point", coordinates: [12.33612, 45.43574] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43372,
        lng: 12.338383,
        name: "Museum Cafe",
        numreviews: 12,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13758359-Reviews-Museum_Cafe-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.17777778,
        diversity_index_3: -0.82222223,
        composite_ital_3: 2.8258331,
      },
      geometry: { type: "Point", coordinates: [12.33838, 45.43372] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439926,
        lng: 12.339583,
        name: "El Magazen",
        numreviews: 164,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13792249-Reviews-El_Magazen-Venice_Veneto.html",
        percent_ital: 0.32926831,
        diversity_index_2: 0.29058149,
        diversity_index_3: -0.70941854,
        composite_ital_3: 2.3467536,
      },
      geometry: { type: "Point", coordinates: [12.33958, 45.43993] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435631,
        lng: 12.338674,
        name: "Ristorante da Toto",
        numreviews: 265,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13810641-Reviews-Ristorante_da_Toto-Venice_Veneto.html",
        percent_ital: 0.1245283,
        diversity_index_2: 0.39169508,
        diversity_index_3: -0.60830492,
        composite_ital_3: 3.0204937,
      },
      geometry: { type: "Point", coordinates: [12.33867, 45.43563] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$$$",
        lat: 45.434116,
        lng: 12.335411,
        name: "La Colomba",
        numreviews: 58,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1381580-Reviews-La_Colomba-Venice_Veneto.html",
        percent_ital: 0.22413793,
        diversity_index_2: 0.42608696,
        diversity_index_3: -0.57391304,
        composite_ital_3: 2.3486054,
      },
      geometry: { type: "Point", coordinates: [12.33541, 45.43412] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.446892,
        lng: 12.326973,
        name: "Al Piron",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1381724-Reviews-Al_Piron-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32697, 45.44689] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435925,
        lng: 12.324222,
        name: "Dona Onesta",
        numreviews: 979,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1382159-Reviews-Dona_Onesta-Venice_Veneto.html",
        percent_ital: 0.43820226,
        diversity_index_2: 0.36661544,
        diversity_index_3: -0.63338459,
        composite_ital_3: 1.8285165,
      },
      geometry: { type: "Point", coordinates: [12.32422, 45.43592] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43457,
        lng: 12.336872,
        name: "Ristorante San Gallo",
        numreviews: 82,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13838089-Reviews-Ristorante_San_Gallo-Venice_Veneto.html",
        percent_ital: 0.39024389,
        diversity_index_2: 0.43921569,
        diversity_index_3: -0.56078434,
        composite_ital_3: 1.763748,
      },
      geometry: { type: "Point", coordinates: [12.33687, 45.43457] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436111,
        lng: 12.335834,
        name: "Ostaria a La Campana",
        numreviews: 877,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1384366-Reviews-Ostaria_a_La_Campana-Venice_Veneto.html",
        percent_ital: 0.49486887,
        diversity_index_2: 0.32288507,
        diversity_index_3: -0.67711496,
        composite_ital_3: 1.8339213,
      },
      geometry: { type: "Point", coordinates: [12.33583, 45.43611] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433075,
        lng: 12.330773,
        name: "A Beccafico",
        numreviews: 1081,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1385701-Reviews-A_Beccafico-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.34989908,
        diversity_index_3: -0.65010095,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33077, 45.43308] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43985,
        lng: 12.331915,
        name: "Osteria Antico Giardinetto",
        numreviews: 1483,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1392876-Reviews-Osteria_Antico_Giardinetto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.3514508,
        diversity_index_3: -0.6485492,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33192, 45.43985] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435593,
        lng: 12.345592,
        name: "PreBateo",
        numreviews: 40,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13966062-Reviews-PreBateo-Venice_Veneto.html",
        percent_ital: 0.52499998,
        diversity_index_2: 0.34761906,
        diversity_index_3: -0.65238094,
        composite_ital_3: 1.7010052,
      },
      geometry: { type: "Point", coordinates: [12.34559, 45.43559] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.424938,
        lng: 12.331012,
        name: "Ristorante Pizzeria Al Redentor",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d13986047-Reviews-Ristorante_Pizzeria_Al_Redentor-Venice_Veneto.html",
        percent_ital: 0.11111111,
        diversity_index_2: 0.39285713,
        diversity_index_3: -0.60714287,
        composite_ital_3: 3.1315339,
      },
      geometry: { type: "Point", coordinates: [12.33101, 45.42494] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435814,
        lng: 12.32331,
        name: "Pizzeria Ristorante da Sara",
        numreviews: 209,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14012839-Reviews-Pizzeria_Ristorante_da_Sara-Venice_Veneto.html",
        percent_ital: 0.28708133,
        diversity_index_2: 0.28847682,
        diversity_index_3: -0.71152318,
        composite_ital_3: 2.4911304,
      },
      geometry: { type: "Point", coordinates: [12.32331, 45.43581] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435875,
        lng: 12.33917,
        name: "Sapori di Mare",
        numreviews: 58,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14065161-Reviews-Sapori_di_Mare-Venice_Veneto.html",
        percent_ital: 0.15517241,
        diversity_index_2: 0.50122452,
        diversity_index_3: -0.49877548,
        composite_ital_3: 2.5539196,
      },
      geometry: { type: "Point", coordinates: [12.33917, 45.43588] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: null,
        lat: 45.433498,
        lng: 12.330874,
        name: "Caffe Mokaefti",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14078418-Reviews-Caffe_Mokaefti-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.60000001999999997,
        diversity_index_3: -0.39999997999999998,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33087, 45.4335] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441853,
        lng: 12.337756,
        name: "Osteria Ai  Tronchi",
        numreviews: 38,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14082536-Reviews-Osteria_Ai_Tronchi-Venice_Veneto.html",
        percent_ital: 0.2631579,
        diversity_index_2: 0.43103448,
        diversity_index_3: -0.56896555,
        composite_ital_3: 2.1765683,
      },
      geometry: { type: "Point", coordinates: [12.33776, 45.44185] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43961,
        lng: 12.340837,
        name: "Bar âA Brassacolloâ",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14082570-Reviews-Bar_A_Brassacollo-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 2.0149031,
      },
      geometry: { type: "Point", coordinates: [12.34084, 45.43961] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436344,
        lng: 12.326852,
        name: "Ostaria dal Bix",
        numreviews: 42,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14107679-Reviews-Ostaria_dal_Bix-Venice_Veneto.html",
        percent_ital: 0.69047618,
        diversity_index_2: 0.60439563,
        diversity_index_3: -0.39560437,
        composite_ital_3: 0.87390006,
      },
      geometry: { type: "Point", coordinates: [12.32685, 45.43634] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.426414,
        lng: 12.341283,
        name: "Giudecca 10 at Belmond Hotel Cipriani",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14149926-Reviews-Giudecca_10_at_Belmond_Hotel_Cipriani-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41666666,
        diversity_index_3: -0.58333337,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34128, 45.42641] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439793,
        lng: 12.320527,
        name: "Bistrot S. Lucia",
        numreviews: 29,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14164092-Reviews-Bistrot_S_Lucia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.5,
        diversity_index_3: -0.5,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32053, 45.43979] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.430386,
        lng: 12.324263,
        name: "sudest 1401",
        numreviews: 41,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14189775-Reviews-Sudest_1401-Venice_Veneto.html",
        percent_ital: 0.60975611,
        diversity_index_2: 0.36257309,
        diversity_index_3: -0.63742691,
        composite_ital_3: 1.5092255,
      },
      geometry: { type: "Point", coordinates: [12.32426, 45.43039] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437279,
        lng: 12.3304,
        name: "Mercante",
        numreviews: 84,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14236415-Reviews-Mercante-Venice_Veneto.html",
        percent_ital: 0.60714287,
        diversity_index_2: 0.47950089,
        diversity_index_3: -0.52049911,
        composite_ital_3: 1.2340007,
      },
      geometry: { type: "Point", coordinates: [12.3304, 45.43728] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443375,
        lng: 12.335807,
        name: "Dobermann Bar",
        numreviews: 27,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14396738-Reviews-Dobermann_Bar-Venice_Veneto.html",
        percent_ital: 0.48148149,
        diversity_index_2: 0.24166666,
        diversity_index_3: -0.75833333,
        composite_ital_3: 2.1510835,
      },
      geometry: { type: "Point", coordinates: [12.33581, 45.44338] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436031,
        lng: 12.33836,
        name: "Ristorante Osteria N.1",
        numreviews: 567,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1444335-Reviews-Ristorante_Osteria_N_1-Venice_Veneto.html",
        percent_ital: 0.39329806,
        diversity_index_2: 0.26672396,
        diversity_index_3: -0.73327601,
        composite_ital_3: 2.2547286,
      },
      geometry: { type: "Point", coordinates: [12.33836, 45.43603] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442654,
        lng: 12.341264,
        name: "Ristorante da Alvise",
        numreviews: 997,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1444431-Reviews-Ristorante_da_Alvise-Venice_Veneto.html",
        percent_ital: 0.42126378,
        diversity_index_2: 0.3762714,
        diversity_index_3: -0.62372863,
        composite_ital_3: 1.8419408,
      },
      geometry: { type: "Point", coordinates: [12.34126, 45.44265] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.435051,
        lng: 12.339155,
        name: "Bar Al Campanile",
        numreviews: 481,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1450246-Reviews-Bar_Al_Campanile-Venice_Veneto.html",
        percent_ital: 0.22661123,
        diversity_index_2: 0.35999483,
        diversity_index_3: -0.64000517,
        composite_ital_3: 2.5061851,
      },
      geometry: { type: "Point", coordinates: [12.33915, 45.43505] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438438,
        lng: 12.34286,
        name: "Osteria Alla Staffa",
        numreviews: 1832,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1455393-Reviews-Osteria_Alla_Staffa-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.36483094,
        diversity_index_3: -0.63516903,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34286, 45.43844] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434689,
        lng: 12.332747,
        name: "Ristorante la Feluca",
        numreviews: 873,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1458619-Reviews-Ristorante_la_Feluca-Venice_Veneto.html",
        percent_ital: 0.33906072,
        diversity_index_2: 0.46197477,
        diversity_index_3: -0.53802526,
        composite_ital_3: 1.853821,
      },
      geometry: { type: "Point", coordinates: [12.33275, 45.43469] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.43483,
        lng: 12.341838,
        name: "Bar Verde",
        numreviews: 211,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1465075-Reviews-Bar_Verde-Venice_Veneto.html",
        percent_ital: 0.32701421,
        diversity_index_2: 0.42795232,
        diversity_index_3: -0.57204771,
        composite_ital_3: 1.9664952,
      },
      geometry: { type: "Point", coordinates: [12.34184, 45.43483] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.434578,
        lng: 12.341788,
        name: "Osteria da Bacco S.N.C.",
        numreviews: 692,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1465076-Reviews-Osteria_da_Bacco_S_N_C-Venice_Veneto.html",
        percent_ital: 0.26589596,
        diversity_index_2: 0.32408413,
        diversity_index_3: -0.67591584,
        composite_ital_3: 2.4514022,
      },
      geometry: { type: "Point", coordinates: [12.34179, 45.43458] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436977,
        lng: 12.32172,
        name: "Ristorante Ribot",
        numreviews: 945,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1466163-Reviews-Ristorante_Ribot-Venice_Veneto.html",
        percent_ital: 0.33015874,
        diversity_index_2: 0.41899157,
        diversity_index_3: -0.58100843,
        composite_ital_3: 1.9780862,
      },
      geometry: { type: "Point", coordinates: [12.32172, 45.43698] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443207,
        lng: 12.331625,
        name: "Camin Storto",
        numreviews: 74,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14769335-Reviews-Camin_Storto-Venice_Veneto.html",
        percent_ital: 0.75675678,
        diversity_index_2: 0.51461989,
        diversity_index_3: -0.48538011,
        composite_ital_3: 0.94304013,
      },
      geometry: { type: "Point", coordinates: [12.33163, 45.44321] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440788,
        lng: 12.336002,
        name: "Osteria La Bottega ai Promessi Sposi",
        numreviews: 1919,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1487722-Reviews-Osteria_La_Bottega_ai_Promessi_Sposi-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.35157719,
        diversity_index_3: -0.64842284,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.336, 45.44079] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437538,
        lng: 12.33656,
        name: "Trattoria Aquila Nera",
        numreviews: 485,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1489245-Reviews-Trattoria_Aquila_Nera-Venice_Veneto.html",
        percent_ital: 0.38762885,
        diversity_index_2: 0.30562726,
        diversity_index_3: -0.69437277,
        composite_ital_3: 2.133096,
      },
      geometry: { type: "Point", coordinates: [12.33656, 45.43754] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.426895,
        lng: 12.338969,
        name: "L'Ulivo Restaurant",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14902951-Reviews-L_Ulivo_Restaurant-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.60000001999999997,
        diversity_index_3: -0.39999997999999998,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33897, 45.4269] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.441242,
        lng: 12.333976,
        name: "Spontini - Venezia",
        numreviews: 57,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14912721-Reviews-Spontini_Venezia-Venice_Veneto.html",
        percent_ital: 0.49122807,
        diversity_index_2: 0.36551723,
        diversity_index_3: -0.63448274,
        composite_ital_3: 1.7172886,
      },
      geometry: { type: "Point", coordinates: [12.33398, 45.44124] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43898,
        lng: 12.333839,
        name: "Osteria Ai Storti",
        numreviews: 292,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1492035-Reviews-Osteria_Ai_Storti-Venice_Veneto.html",
        percent_ital: 0.3938356,
        diversity_index_2: 0.43751177,
        diversity_index_3: -0.5624882,
        composite_ital_3: 1.7584734,
      },
      geometry: { type: "Point", coordinates: [12.33384, 45.43898] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.433372,
        lng: 12.334326,
        name: "Ae Veste Bar",
        numreviews: 36,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14934471-Reviews-Ae_Veste_Bar-Venice_Veneto.html",
        percent_ital: 0.27777779,
        diversity_index_2: 0.30484331,
        diversity_index_3: -0.69515669,
        composite_ital_3: 2.4688911,
      },
      geometry: { type: "Point", coordinates: [12.33433, 45.43337] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438854,
        lng: 12.350104,
        name: "Pizzeria Trattoria Alla Fonte",
        numreviews: 290,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1493988-Reviews-Pizzeria_Trattoria_Alla_Fonte-Venice_Veneto.html",
        percent_ital: 0.30344829,
        diversity_index_2: 0.32560611,
        diversity_index_3: -0.67439389,
        composite_ital_3: 2.314611,
      },
      geometry: { type: "Point", coordinates: [12.3501, 45.43885] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434456,
        lng: 12.332444,
        name: "Hostaria Galileo",
        numreviews: 397,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1494066-Reviews-Hostaria_Galileo-Venice_Veneto.html",
        percent_ital: 0.20403023,
        diversity_index_2: 0.38747692,
        diversity_index_3: -0.61252308,
        composite_ital_3: 2.537586,
      },
      geometry: { type: "Point", coordinates: [12.33244, 45.43446] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.43882,
        lng: 12.32358,
        name: "Osteria della Rivetta",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14944674-Reviews-Osteria_della_Rivetta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32358, 45.43882] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437206,
        lng: 12.340637,
        name: "Al Burchiello",
        numreviews: 328,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1498956-Reviews-Al_Burchiello-Venice_Veneto.html",
        percent_ital: 0.1402439,
        diversity_index_2: 0.44751903,
        diversity_index_3: -0.55248094,
        composite_ital_3: 2.7684085,
      },
      geometry: { type: "Point", coordinates: [12.34064, 45.43721] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43206,
        lng: 12.351925,
        name: "Ristorante Da Giulio",
        numreviews: 63,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d14990913-Reviews-Ristorante_Da_Giulio-Venice_Veneto.html",
        percent_ital: 0.46031746,
        diversity_index_2: 0.35714287,
        diversity_index_3: -0.64285713,
        composite_ital_3: 1.8054583,
      },
      geometry: { type: "Point", coordinates: [12.35192, 45.43206] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Italian",
        lat: 45.441463,
        lng: 12.322474,
        name: "Snack Bar",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15003851-Reviews-Snack_Bar-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.60000001999999997,
        diversity_index_3: -0.39999997999999998,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32247, 45.44146] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.446095,
        lng: 12.326158,
        name: "Osteria Al Bacco",
        numreviews: 465,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1500557-Reviews-Osteria_Al_Bacco-Venice_Veneto.html",
        percent_ital: 0.41505376,
        diversity_index_2: 0.43798295,
        diversity_index_3: -0.56201708,
        composite_ital_3: 1.7049226,
      },
      geometry: { type: "Point", coordinates: [12.32616, 45.44609] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440941,
        lng: 12.328351,
        name: "Trattoria Al Ponte del Megio",
        numreviews: 928,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1500560-Reviews-Trattoria_Al_Ponte_del_Megio-Venice_Veneto.html",
        percent_ital: 0.34806034,
        diversity_index_2: 0.50021112,
        diversity_index_3: -0.49978888,
        composite_ital_3: 1.7481045,
      },
      geometry: { type: "Point", coordinates: [12.32835, 45.44094] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.43446,
        lng: 12.341717,
        name: "Birreria Forst",
        numreviews: 408,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1501225-Reviews-Birreria_Forst-Venice_Veneto.html",
        percent_ital: 0.48774511,
        diversity_index_2: 0.29794627,
        diversity_index_3: -0.70205373,
        composite_ital_3: 1.9288045,
      },
      geometry: { type: "Point", coordinates: [12.34172, 45.43446] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.436665,
        lng: 12.340009,
        name: "Pasta Go Espresso",
        numreviews: 53,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15014154-Reviews-Pasta_Go_Espresso-Venice_Veneto.html",
        percent_ital: 0.32075471,
        diversity_index_2: 0.25035563,
        diversity_index_3: -0.7496444,
        composite_ital_3: 2.5219514,
      },
      geometry: { type: "Point", coordinates: [12.34001, 45.43666] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.436317,
        lng: 12.319863,
        name: "Crema&Cioccolato Venezia Bubble tea",
        numreviews: 11,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15026502-Reviews-Crema_Cioccolato_Venezia_Bubble_tea-Venice_Veneto.html",
        percent_ital: 0.72727275,
        diversity_index_2: 0.46666667,
        diversity_index_3: -0.5333333,
        composite_ital_3: 1.0805938,
      },
      geometry: { type: "Point", coordinates: [12.31986, 45.43632] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435703,
        lng: 12.344275,
        name: "Gransapor Ristorante",
        numreviews: 62,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15029768-Reviews-Gransapor_Ristorante-Venice_Veneto.html",
        percent_ital: 0.20967741,
        diversity_index_2: 0.45469388,
        diversity_index_3: -0.54530609,
        composite_ital_3: 2.3503158,
      },
      geometry: { type: "Point", coordinates: [12.34427, 45.4357] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438499,
        lng: 12.334046,
        name: "Ostaria Antico Dolo",
        numreviews: 1056,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1508607-Reviews-Ostaria_Antico_Dolo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40783921,
        diversity_index_3: -0.59216082,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33405, 45.4385] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.426903,
        lng: 12.32446,
        name: "Osteria da Moro",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15091082-Reviews-Osteria_da_Moro-Venice_Veneto.html",
        percent_ital: 0.22222222,
        diversity_index_2: 0.71428573,
        diversity_index_3: -0.28571427,
        composite_ital_3: 1.8405496,
      },
      geometry: { type: "Point", coordinates: [12.32446, 45.4269] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.426846,
        lng: 12.324484,
        name: "Ostaria Da Moro",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15091113-Reviews-Ostaria_Da_Moro-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32448, 45.42685] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440712,
        lng: 12.336076,
        name: "Taverna Barababao",
        numreviews: 103,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15099727-Reviews-Taverna_Barababao-Venice_Veneto.html",
        percent_ital: 0.44660193,
        diversity_index_2: 0.3629764,
        diversity_index_3: -0.63702357,
        composite_ital_3: 1.8195051,
      },
      geometry: { type: "Point", coordinates: [12.33608, 45.44071] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436058,
        lng: 12.333887,
        name: "Enoteca al Volto",
        numreviews: 1095,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1510076-Reviews-Enoteca_al_Volto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33945888,
        diversity_index_3: -0.66054112,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33389, 45.43606] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436314,
        lng: 12.337696,
        name: "Trattoria Al Gazzettino",
        numreviews: 1986,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1510422-Reviews-Trattoria_Al_Gazzettino-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.18640509,
        diversity_index_3: -0.81359494,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3377, 45.43631] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434414,
        lng: 12.341708,
        name: "La Nuova Grotta",
        numreviews: 520,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1510495-Reviews-La_Nuova_Grotta-Venice_Veneto.html",
        percent_ital: 0.27884614,
        diversity_index_2: 0.39007479,
        diversity_index_3: -0.60992521,
        composite_ital_3: 2.2185118,
      },
      geometry: { type: "Point", coordinates: [12.34171, 45.43441] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.438835,
        lng: 12.337096,
        name: "GROM - Il Gelato come una volta",
        numreviews: 12,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15123065-Reviews-GROM_Il_Gelato_come_una_volta-Venice_Veneto.html",
        percent_ital: 0.41666666,
        diversity_index_2: 0.19047619,
        diversity_index_3: -0.80952382,
        composite_ital_3: 2.5336969,
      },
      geometry: { type: "Point", coordinates: [12.3371, 45.43883] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440624,
        lng: 12.328216,
        name: "Bar Rosa",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15124370-Reviews-Bar_Rosa-Venice_Veneto.html",
        percent_ital: 0.2857143,
        diversity_index_2: 0.66666669,
        diversity_index_3: -0.33333331,
        composite_ital_3: 1.6582279,
      },
      geometry: { type: "Point", coordinates: [12.32822, 45.44062] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.426605,
        lng: 12.325489,
        name: "Bar Al Bateo",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15143872-Reviews-Bar_Al_Bateo-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32549, 45.42661] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434841,
        lng: 12.333214,
        name: "Ristorante Rosa Rossa",
        numreviews: 1255,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1514649-Reviews-Ristorante_Rosa_Rossa-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.32081753,
        diversity_index_3: -0.67918247,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33321, 45.43484] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436161,
        lng: 12.327054,
        name: "Trattoria San Toma",
        numreviews: 559,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1516904-Reviews-Trattoria_San_Toma-Venice_Veneto.html",
        percent_ital: 0.36851519,
        diversity_index_2: 0.4468745,
        diversity_index_3: -0.5531255,
        composite_ital_3: 1.8037508,
      },
      geometry: { type: "Point", coordinates: [12.32705, 45.43616] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.43512,
        lng: 12.34172,
        name: "Il Ridotto",
        numreviews: 1198,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1520518-Reviews-Il_Ridotto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.44139954,
        diversity_index_3: -0.55860043,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34172, 45.43512] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.434116,
        lng: 12.345277,
        name: "Oriental Bar",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15210752-Reviews-Oriental_Bar-Venice_Veneto.html",
        percent_ital: 0.1,
        diversity_index_2: 0.6111111,
        diversity_index_3: -0.3888889,
        composite_ital_3: 2.7950616,
      },
      geometry: { type: "Point", coordinates: [12.34528, 45.43412] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439404,
        lng: 12.333014,
        name: "Ristorante Mercante",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15210951-Reviews-Ristorante_Mercante-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33301, 45.4394] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.434025,
        lng: 12.343551,
        name: "Ristorante Do Leoni",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15210953-Reviews-Ristorante_Do_Leoni-Venice_Veneto.html",
        percent_ital: 0.80000000999999998,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.22314353,
      },
      geometry: { type: "Point", coordinates: [12.34355, 45.43402] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441669,
        lng: 12.32268,
        name: "Trattoria Bella Venezia",
        numreviews: 71,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15247293-Reviews-Trattoria_Bella_Venezia-Venice_Veneto.html",
        percent_ital: 0.1971831,
        diversity_index_2: 0.33030853,
        diversity_index_3: -0.66969144,
        composite_ital_3: 2.7313507,
      },
      geometry: { type: "Point", coordinates: [12.32268, 45.44167] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439514,
        lng: 12.33472,
        name: "I Compari Pulperia a Venezia",
        numreviews: 82,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15265507-Reviews-I_Compari_Pulperia_a_Venezia-Venice_Veneto.html",
        percent_ital: 0.48780489,
        diversity_index_2: 0.25249168,
        diversity_index_3: -0.74750829,
        composite_ital_3: 2.0942168,
      },
      geometry: { type: "Point", coordinates: [12.33472, 45.43951] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434711,
        lng: 12.324214,
        name: "Pier Dickens",
        numreviews: 426,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1527185-Reviews-Pier_Dickens-Venice_Veneto.html",
        percent_ital: 0.20657277,
        diversity_index_2: 0.40466771,
        diversity_index_3: -0.59533226,
        composite_ital_3: 2.4817915,
      },
      geometry: { type: "Point", coordinates: [12.32421, 45.43471] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437351,
        lng: 12.329603,
        name: "Ristorante Due Colonne",
        numreviews: 681,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1527187-Reviews-Ristorante_Due_Colonne-Venice_Veneto.html",
        percent_ital: 0.37738618,
        diversity_index_2: 0.32438478,
        diversity_index_3: -0.67561519,
        composite_ital_3: 2.100311,
      },
      geometry: { type: "Point", coordinates: [12.3296, 45.43735] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435711,
        lng: 12.339931,
        name: "Wine Bar HK",
        numreviews: 169,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1527672-Reviews-Wine_Bar_HK-Venice_Veneto.html",
        percent_ital: 0.14201184,
        diversity_index_2: 0.55314124,
        diversity_index_3: -0.44685876,
        composite_ital_3: 2.5439868,
      },
      geometry: { type: "Point", coordinates: [12.33993, 45.43571] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.444096,
        lng: 12.328417,
        name: "Bar Caffe Senzanome",
        numreviews: 16,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15278592-Reviews-Bar_Caffe_Senzanome-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32842, 45.4441] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435131,
        lng: 12.337955,
        name: "Ai Due Vescovi",
        numreviews: 488,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1528056-Reviews-Ai_Due_Vescovi-Venice_Veneto.html",
        percent_ital: 0.54918033,
        diversity_index_2: 0.33553463,
        diversity_index_3: -0.66446537,
        composite_ital_3: 1.6913584,
      },
      geometry: { type: "Point", coordinates: [12.33795, 45.43513] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437386,
        lng: 12.33829,
        name: "Ristorante Carpaccio",
        numreviews: 505,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1528682-Reviews-Ristorante_Carpaccio-Venice_Veneto.html",
        percent_ital: 0.32475248,
        diversity_index_2: 0.47037661,
        diversity_index_3: -0.52962339,
        composite_ital_3: 1.8789135,
      },
      geometry: { type: "Point", coordinates: [12.33829, 45.43739] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439526,
        lng: 12.337128,
        name: "S. Giovanni Vini E Cicchetti",
        numreviews: 220,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15289594-Reviews-S_Giovanni_Vini_E_Cicchetti-Venice_Veneto.html",
        percent_ital: 0.40454546,
        diversity_index_2: 0.39367074,
        diversity_index_3: -0.60632926,
        composite_ital_3: 1.8372315,
      },
      geometry: { type: "Point", coordinates: [12.33713, 45.43953] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445091,
        lng: 12.329205,
        name: "Marciano Pub Venezia",
        numreviews: 47,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15293642-Reviews-Marciano_Pub_Venezia-Venice_Veneto.html",
        percent_ital: 0.76595747,
        diversity_index_2: 0.48717949,
        diversity_index_3: -0.51282048,
        composite_ital_3: 0.98575127,
      },
      geometry: { type: "Point", coordinates: [12.3292, 45.44509] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437077,
        lng: 12.334792,
        name: "Antica Carbonera",
        numreviews: 855,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1536046-Reviews-Antica_Carbonera-Venice_Veneto.html",
        percent_ital: 0.35555556,
        diversity_index_2: 0.29525167,
        diversity_index_3: -0.70474833,
        composite_ital_3: 2.2540009,
      },
      geometry: { type: "Point", coordinates: [12.33479, 45.43708] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444691,
        lng: 12.331726,
        name: "Ostaria Da Rioba",
        numreviews: 1158,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1537846-Reviews-Ostaria_Da_Rioba-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.48875463,
        diversity_index_3: -0.51124537,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33173, 45.44469] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43082,
        lng: 12.32093,
        name: "Trattoria Borghi",
        numreviews: 47,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1544593-Reviews-Trattoria_Borghi-Venice_Veneto.html",
        percent_ital: 0.10638298,
        diversity_index_2: 0.39756367,
        diversity_index_3: -0.6024363,
        composite_ital_3: 3.1631098,
      },
      geometry: { type: "Point", coordinates: [12.32093, 45.43082] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434105,
        lng: 12.336858,
        name: "Hard Rock Cafe",
        numreviews: 1259,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1546389-Reviews-Hard_Rock_Cafe-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.17716511,
        diversity_index_3: -0.82283491,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33686, 45.43411] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445362,
        lng: 12.332158,
        name: "Osteria L'Orto dei Mori",
        numreviews: 1081,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1550750-Reviews-Osteria_L_Orto_dei_Mori-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.55420494,
        diversity_index_3: -0.44579506,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33216, 45.44536] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "Fast Food",
        lat: 45.44128,
        lng: 12.334268,
        name: "Mcdonald's",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15510715-Reviews-Mcdonald_s-Venice_Veneto.html",
        percent_ital: 0.60000001999999997,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.51082557,
      },
      geometry: { type: "Point", coordinates: [12.33427, 45.44128] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438782,
        lng: 12.335445,
        name: "Osteria Bancogiro",
        numreviews: 1514,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1551575-Reviews-Osteria_Bancogiro-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.37923092,
        diversity_index_3: -0.62076908,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33544, 45.43878] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435989,
        lng: 12.344262,
        name: "Ristorante Alla Conchiglia",
        numreviews: 453,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1552437-Reviews-Ristorante_Alla_Conchiglia-Venice_Veneto.html",
        percent_ital: 0.21854305,
        diversity_index_2: 0.39923835,
        diversity_index_3: -0.60076165,
        composite_ital_3: 2.4389689,
      },
      geometry: { type: "Point", coordinates: [12.34426, 45.43599] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.444107,
        lng: 12.328828,
        name: "Trattoria Ai Do Fradei",
        numreviews: 228,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15528556-Reviews-Trattoria_Ai_Do_Fradei-Venice_Veneto.html",
        percent_ital: 0.24122807,
        diversity_index_2: 0.55982363,
        diversity_index_3: -0.44017637,
        composite_ital_3: 2.002146,
      },
      geometry: { type: "Point", coordinates: [12.32883, 45.44411] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: null,
        lat: 45.437485,
        lng: 12.335708,
        name: "Bar Rizzo (Mogo G)",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15548352-Reviews-Bar_Rizzo_Mogo_G-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.39285713,
        diversity_index_3: -0.60714287,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33571, 45.43749] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$$$",
        lat: 45.437214,
        lng: 12.330903,
        name: "Bistro'",
        numreviews: 38,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15548807-Reviews-Bistro-Venice_Veneto.html",
        percent_ital: 0.44736841,
        diversity_index_2: 0.27667984,
        diversity_index_3: -0.72332013,
        composite_ital_3: 2.089267,
      },
      geometry: { type: "Point", coordinates: [12.3309, 45.43721] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.446312,
        lng: 12.325557,
        name: "Osteria Bea Vita",
        numreviews: 853,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1557843-Reviews-Osteria_Bea_Vita-Venice_Veneto.html",
        percent_ital: 0.57209849,
        diversity_index_2: 0.36291632,
        diversity_index_3: -0.63708365,
        composite_ital_3: 1.5720271,
      },
      geometry: { type: "Point", coordinates: [12.32556, 45.44631] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440605,
        lng: 12.338041,
        name: "Hostaria Bacanera",
        numreviews: 142,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15598970-Reviews-Hostaria_Bacanera-Venice_Veneto.html",
        percent_ital: 0.75352114,
        diversity_index_2: 0.40058056,
        diversity_index_3: -0.59941947,
        composite_ital_3: 1.1978387,
      },
      geometry: { type: "Point", coordinates: [12.33804, 45.4406] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.494205,
        lng: 12.240602,
        name: "Pizzeria Napule",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15606186-Reviews-Pizzeria_Napule-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.2406, 45.49421] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$$$",
        lat: 45.430649,
        lng: 12.326679,
        name: "Vitraria Caffe",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15619460-Reviews-Vitraria_Caffe-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32668, 45.43065] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440613,
        lng: 12.329232,
        name: "Cucina del Tentor",
        numreviews: 50,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15619647-Reviews-Cucina_del_Tentor-Venice_Veneto.html",
        percent_ital: 0.66000003,
        diversity_index_2: 0.25238097,
        diversity_index_3: -0.74761903,
        composite_ital_3: 1.792331,
      },
      geometry: { type: "Point", coordinates: [12.32923, 45.44061] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.440548,
        lng: 12.328084,
        name: "La Cantinetta",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15643175-Reviews-La_Cantinetta-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32808, 45.44055] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437809,
        lng: 12.333318,
        name: "Ristorante San Silvestro",
        numreviews: 878,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15644399-Reviews-Ristorante_San_Silvestro-Venice_Veneto.html",
        percent_ital: 0.2881549,
        diversity_index_2: 0.35295689,
        diversity_index_3: -0.64704311,
        composite_ital_3: 2.2856665,
      },
      geometry: { type: "Point", coordinates: [12.33332, 45.43781] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: null,
        lat: 45.435909,
        lng: 12.335532,
        name: "Emilio Colussi Srl",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15650037-Reviews-Emilio_Colussi_Srl-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 1.0986123,
      },
      geometry: { type: "Point", coordinates: [12.33553, 45.43591] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436539,
        lng: 12.335798,
        name: "Osteria del Lovo",
        numreviews: 233,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15687491-Reviews-Osteria_del_Lovo-Venice_Veneto.html",
        percent_ital: 0.36909872,
        diversity_index_2: 0.29766008,
        diversity_index_3: -0.70233989,
        composite_ital_3: 2.2084942,
      },
      geometry: { type: "Point", coordinates: [12.3358, 45.43654] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.436623,
        lng: 12.33721,
        name: "Forno D'asolo",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15691149-Reviews-Forno_D_asolo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33721, 45.43662] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.431217,
        lng: 12.320883,
        name: "Al Terminal",
        numreviews: 15,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15694870-Reviews-Al_Terminal-Venice_Veneto.html",
        percent_ital: 0.66666669,
        diversity_index_2: 0.42857143,
        diversity_index_3: -0.57142854,
        composite_ital_3: 1.2527629,
      },
      geometry: { type: "Point", coordinates: [12.32088, 45.43122] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437477,
        lng: 12.327182,
        name: "Frary's",
        numreviews: 906,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1573934-Reviews-Frary_s-Venice_Veneto.html",
        percent_ital: 0.57284766,
        diversity_index_2: 0.54678851,
        diversity_index_3: -0.45321149,
        composite_ital_3: 1.1608286,
      },
      geometry: { type: "Point", coordinates: [12.32718, 45.43748] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439251,
        lng: 12.321151,
        name: "Ristorante Pizzeria Al Bacco Felice",
        numreviews: 1746,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1574601-Reviews-Ristorante_Pizzeria_Al_Bacco_Felice-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.35271129,
        diversity_index_3: -0.64728868,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32115, 45.43925] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436474,
        lng: 12.339871,
        name: "Planet Ristorante",
        numreviews: 839,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1575455-Reviews-Planet_Ristorante-Venice_Veneto.html",
        percent_ital: 0.73301548,
        diversity_index_2: 0.3261022,
        diversity_index_3: -0.6738978,
        composite_ital_3: 1.4311329,
      },
      geometry: { type: "Point", coordinates: [12.33987, 45.43647] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436039,
        lng: 12.338768,
        name: "Cavatappi",
        numreviews: 260,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1576144-Reviews-Cavatappi-Venice_Veneto.html",
        percent_ital: 0.41153845,
        diversity_index_2: 0.38768327,
        diversity_index_3: -0.61231673,
        composite_ital_3: 1.8354194,
      },
      geometry: { type: "Point", coordinates: [12.33877, 45.43604] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436859,
        lng: 12.321496,
        name: "Bar Pasticceria La Bauta",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15780030-Reviews-Bar_Pasticceria_La_Bauta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40000001000000002,
        diversity_index_3: -0.60000001999999997,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3215, 45.43686] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434776,
        lng: 12.343054,
        name: "Trattoria Zaccaria",
        numreviews: 281,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1581293-Reviews-Trattoria_Zaccaria-Venice_Veneto.html",
        percent_ital: 0.22775801,
        diversity_index_2: 0.31619957,
        diversity_index_3: -0.68380046,
        composite_ital_3: 2.6308534,
      },
      geometry: { type: "Point", coordinates: [12.34305, 45.43478] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445419,
        lng: 12.329112,
        name: "Oficina Ormesini",
        numreviews: 168,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15831990-Reviews-Oficina_Ormesini-Venice_Veneto.html",
        percent_ital: 0.40476191,
        diversity_index_2: 0.38237622,
        diversity_index_3: -0.61762381,
        composite_ital_3: 1.8658066,
      },
      geometry: { type: "Point", coordinates: [12.32911, 45.44542] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.4436,
        lng: 12.330599,
        name: "Trattoria alla Maddalena",
        numreviews: 77,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15843174-Reviews-Trattoria_alla_Maddalena-Venice_Veneto.html",
        percent_ital: 0.19480519,
        diversity_index_2: 0.63901693,
        diversity_index_3: -0.36098307,
        composite_ital_3: 2.0835795,
      },
      geometry: { type: "Point", coordinates: [12.3306, 45.4436] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438511,
        lng: 12.345037,
        name: "Gibran",
        numreviews: 34,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d15850572-Reviews-Gibran-Venice_Veneto.html",
        percent_ital: 0.94117647,
        diversity_index_2: 0.71428573,
        diversity_index_3: -0.28571427,
        composite_ital_3: 0.39709684,
      },
      geometry: { type: "Point", coordinates: [12.34504, 45.43851] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.432171,
        lng: 12.352662,
        name: "El Refolo",
        numreviews: 881,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1592029-Reviews-El_Refolo-Venice_Veneto.html",
        percent_ital: 0.5584563,
        diversity_index_2: 0.34932947,
        diversity_index_3: -0.65067053,
        composite_ital_3: 1.6343187,
      },
      geometry: { type: "Point", coordinates: [12.35266, 45.43217] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432835,
        lng: 12.331728,
        name: "Tavernetta San Maurizio",
        numreviews: 765,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1595036-Reviews-Tavernetta_San_Maurizio-Venice_Veneto.html",
        percent_ital: 0.2888889,
        diversity_index_2: 0.38991499,
        diversity_index_3: -0.61008501,
        composite_ital_3: 2.1835396,
      },
      geometry: { type: "Point", coordinates: [12.33173, 45.43283] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433819,
        lng: 12.334417,
        name: "Hostaria Ai Coristi",
        numreviews: 515,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1597205-Reviews-Hostaria_Ai_Coristi-Venice_Veneto.html",
        percent_ital: 0.3669903,
        diversity_index_2: 0.46399269,
        diversity_index_3: -0.53600729,
        composite_ital_3: 1.7703063,
      },
      geometry: { type: "Point", coordinates: [12.33442, 45.43382] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436291,
        lng: 12.342255,
        name: "Osteria al Pozzo Roverso",
        numreviews: 958,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1597688-Reviews-Osteria_al_Pozzo_Roverso-Venice_Veneto.html",
        percent_ital: 0.46346554,
        diversity_index_2: 0.34020573,
        diversity_index_3: -0.65979427,
        composite_ital_3: 1.8472281,
      },
      geometry: { type: "Point", coordinates: [12.34225, 45.43629] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.435463,
        lng: 12.341657,
        name: "Pizza Crash",
        numreviews: 44,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1605081-Reviews-Pizza_Crash-Venice_Veneto.html",
        percent_ital: 0.11363637,
        diversity_index_2: 0.43589744,
        diversity_index_3: -0.56410253,
        composite_ital_3: 3.0051,
      },
      geometry: { type: "Point", coordinates: [12.34166, 45.43546] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434025,
        lng: 12.335373,
        name: "Ristorante Piccolo Martini",
        numreviews: 931,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1626605-Reviews-Ristorante_Piccolo_Martini-Venice_Veneto.html",
        percent_ital: 0.23415682,
        diversity_index_2: 0.39218393,
        diversity_index_3: -0.6078161,
        composite_ital_3: 2.3877885,
      },
      geometry: { type: "Point", coordinates: [12.33537, 45.43402] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435337,
        lng: 12.346642,
        name: "Osteria ae Spezie",
        numreviews: 751,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1627733-Reviews-Osteria_ae_Spezie-Venice_Veneto.html",
        percent_ital: 0.29560587,
        diversity_index_2: 0.39684397,
        diversity_index_3: -0.60315603,
        composite_ital_3: 2.1429403,
      },
      geometry: { type: "Point", coordinates: [12.34664, 45.43534] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43512,
        lng: 12.339237,
        name: "Birreria Pedavena",
        numreviews: 376,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1627779-Reviews-Birreria_Pedavena-Venice_Veneto.html",
        percent_ital: 0.22606383,
        diversity_index_2: 0.28128946,
        diversity_index_3: -0.71871054,
        composite_ital_3: 2.7553089,
      },
      geometry: { type: "Point", coordinates: [12.33924, 45.43512] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434155,
        lng: 12.347895,
        name: "Al Vecio Portal",
        numreviews: 954,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1628882-Reviews-Al_Vecio_Portal-Venice_Veneto.html",
        percent_ital: 0.52096438,
        diversity_index_2: 0.34909186,
        diversity_index_3: -0.65090811,
        composite_ital_3: 1.7044938,
      },
      geometry: { type: "Point", coordinates: [12.34789, 45.43415] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434685,
        lng: 12.332538,
        name: "Al Vaporetto",
        numreviews: 1719,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1630476-Reviews-Al_Vaporetto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.23140261,
        diversity_index_3: -0.76859736,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33254, 45.43469] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438606,
        lng: 12.343301,
        name: "Pizzeria - Cicchetteria Alla Strega Venezia",
        numreviews: 313,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1639039-Reviews-Pizzeria_Cicchetteria_Alla_Strega_Venezia-Venice_Veneto.html",
        percent_ital: 0.39936101,
        diversity_index_2: 0.35165691,
        diversity_index_3: -0.64834309,
        composite_ital_3: 1.9629887,
      },
      geometry: { type: "Point", coordinates: [12.3433, 45.43861] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.44154,
        lng: 12.333181,
        name: "La Cantina",
        numreviews: 1095,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1645912-Reviews-La_Cantina-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.42837107,
        diversity_index_3: -0.57162893,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33318, 45.44154] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435089,
        lng: 12.341334,
        name: "Conca d'Oro",
        numreviews: 832,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1650558-Reviews-Conca_d_Oro-Venice_Veneto.html",
        percent_ital: 0.24639423,
        diversity_index_2: 0.38889748,
        diversity_index_3: -0.61110252,
        composite_ital_3: 2.3452621,
      },
      geometry: { type: "Point", coordinates: [12.34133, 45.43509] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.444656,
        lng: 12.320786,
        name: "Casa bonita",
        numreviews: 1252,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1657131-Reviews-Casa_bonita-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.37423784,
        diversity_index_3: -0.62576216,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32079, 45.44466] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.432812,
        lng: 12.324814,
        name: "Panini e Vini da Babbo",
        numreviews: 111,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16657302-Reviews-Panini_e_Vini_da_Babbo-Venice_Veneto.html",
        percent_ital: 0.72072071,
        diversity_index_2: 0.42045453,
        diversity_index_3: -0.5795455,
        composite_ital_3: 1.1939225,
      },
      geometry: { type: "Point", coordinates: [12.32481, 45.43281] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "Italian",
        lat: 45.445919,
        lng: 12.326992,
        name: "Profondo Rosso",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16658934-Reviews-Profondo_Rosso-Venice_Veneto.html",
        percent_ital: 0.60000001999999997,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32699, 45.44592] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43494,
        lng: 12.341928,
        name: "Osteria da Baco",
        numreviews: 33,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16662314-Reviews-Osteria_da_Baco-Venice_Veneto.html",
        percent_ital: 0.21212122,
        diversity_index_2: 0.35978836,
        diversity_index_3: -0.64021164,
        composite_ital_3: 2.5728366,
      },
      geometry: { type: "Point", coordinates: [12.34193, 45.43494] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445621,
        lng: 12.328206,
        name: "Bacaro Dai Morosi Chiara & Elvis",
        numreviews: 14,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16695702-Reviews-Bacaro_Dai_Morosi_Chiara_Elvis-Venice_Veneto.html",
        percent_ital: 0.21428572,
        diversity_index_2: 0.56363636,
        diversity_index_3: -0.43636364,
        composite_ital_3: 2.113791,
      },
      geometry: { type: "Point", coordinates: [12.32821, 45.44562] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.426693,
        lng: 12.324648,
        name: "Panificio Crosara",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16700124-Reviews-Panificio_Crosara-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.16666667,
        diversity_index_3: -0.83333331,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32465, 45.42669] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444756,
        lng: 12.323684,
        name: "L'Osteria Le Guglie",
        numreviews: 47,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16808575-Reviews-L_Osteria_Le_Guglie-Venice_Veneto.html",
        percent_ital: 0.29787233,
        diversity_index_2: 0.27450982,
        diversity_index_3: -0.72549021,
        composite_ital_3: 2.5038586,
      },
      geometry: { type: "Point", coordinates: [12.32368, 45.44476] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437325,
        lng: 12.341344,
        name: "Ristorante Santa Maria Formosa",
        numreviews: 99,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16853813-Reviews-Ristorante_Santa_Maria_Formosa-Venice_Veneto.html",
        percent_ital: 0.34343433,
        diversity_index_2: 0.42966983,
        diversity_index_3: -0.57033014,
        composite_ital_3: 1.9134976,
      },
      geometry: { type: "Point", coordinates: [12.34134, 45.43733] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.441566,
        lng: 12.327914,
        name: "Ristorante Regina Sconta",
        numreviews: 138,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16856998-Reviews-Ristorante_Regina_Sconta-Venice_Veneto.html",
        percent_ital: 0.48550725,
        diversity_index_2: 0.37206572,
        diversity_index_3: -0.62793428,
        composite_ital_3: 1.7112458,
      },
      geometry: { type: "Point", coordinates: [12.32791, 45.44157] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438282,
        lng: 12.334603,
        name: "Casa Cappellari Ristorante",
        numreviews: 126,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16875889-Reviews-Casa_Cappellari_Ristorante-Venice_Veneto.html",
        percent_ital: 0.60317463,
        diversity_index_2: 0.38745099,
        diversity_index_3: -0.61254901,
        composite_ital_3: 1.4537145,
      },
      geometry: { type: "Point", coordinates: [12.3346, 45.43828] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440662,
        lng: 12.336059,
        name: "Osteria Contemporanea da Riccardo",
        numreviews: 45,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16883109-Reviews-Osteria_Contemporanea_da_Riccardo-Venice_Veneto.html",
        percent_ital: 0.73333335,
        diversity_index_2: 0.34999998999999998,
        diversity_index_3: -0.64999998,
        composite_ital_3: 1.3599771,
      },
      geometry: { type: "Point", coordinates: [12.33606, 45.44066] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435772,
        lng: 12.338974,
        name: "1000 Gourmet",
        numreviews: 325,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d16897874-Reviews-1000_Gourmet-Venice_Veneto.html",
        percent_ital: 0.60307693,
        diversity_index_2: 0.31189948,
        diversity_index_3: -0.68810052,
        composite_ital_3: 1.6707848,
      },
      geometry: { type: "Point", coordinates: [12.33897, 45.43577] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.435493,
        lng: 12.339261,
        name: "Full Season",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17143024-Reviews-Full_Season-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33926, 45.43549] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "Cafe",
        lat: 45.434002,
        lng: 12.331,
        name: "Bar Spritz",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17205898-Reviews-Bar_Spritz-Venice_Veneto.html",
        percent_ital: 0.25,
        diversity_index_2: 0.095238097,
        diversity_index_3: -0.90476191,
        composite_ital_3: 3.7376697,
      },
      geometry: { type: "Point", coordinates: [12.331, 45.434] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435787,
        lng: 12.326666,
        name: "Osteria da Nason",
        numreviews: 28,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17210089-Reviews-Osteria_da_Nason-Venice_Veneto.html",
        percent_ital: 0.53571427,
        diversity_index_2: 0.37362638,
        diversity_index_3: -0.62637365,
        composite_ital_3: 1.6086533,
      },
      geometry: { type: "Point", coordinates: [12.32667, 45.43579] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$",
        lat: 45.437538,
        lng: 12.336994,
        name: "Bar XIXI",
        numreviews: 44,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1725289-Reviews-Bar_XIXI-Venice_Veneto.html",
        percent_ital: 0.29545453,
        diversity_index_2: 0.32056451,
        diversity_index_3: -0.67943549,
        composite_ital_3: 2.3569121,
      },
      geometry: { type: "Point", coordinates: [12.33699, 45.43754] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.442223,
        lng: 12.323894,
        name: "Cicchetti",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17253102-Reviews-Cicchetti-Venice_Veneto.html",
        percent_ital: 0.69230771,
        diversity_index_2: 0.66666669,
        diversity_index_3: -0.33333331,
        composite_ital_3: 0.77318984,
      },
      geometry: { type: "Point", coordinates: [12.32389, 45.44222] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.446369,
        lng: 12.319998,
        name: "Bar Al Molo",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17290701-Reviews-Bar_Al_Molo-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32, 45.44637] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.42942,
        lng: 12.343204,
        name: "San Giorgio Cafe",
        numreviews: 54,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17310061-Reviews-San_Giorgio_Cafe-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.42292491,
        diversity_index_3: -0.57707512,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3432, 45.42942] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "Italian",
        lat: 45.435547,
        lng: 12.345517,
        name: "Aurora Pizza & Kebab Halal",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17317061-Reviews-Aurora_Pizza_Kebab_Halal-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34552, 45.43555] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437271,
        lng: 12.333673,
        name: "La Porta D'Acqua",
        numreviews: 1053,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1735599-Reviews-La_Porta_D_Acqua-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.43930545,
        diversity_index_3: -0.56069458,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33367, 45.43727] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.435669,
        lng: 12.338407,
        name: "Hutte Gastronomia",
        numreviews: 18,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17373481-Reviews-Hutte_Gastronomia-Venice_Veneto.html",
        percent_ital: 0.27777779,
        diversity_index_2: 0.1923077,
        diversity_index_3: -0.80769229,
        composite_ital_3: 2.9295924,
      },
      geometry: { type: "Point", coordinates: [12.33841, 45.43567] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442959,
        lng: 12.332606,
        name: "Ristorante Da Bera",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1738068-Reviews-Ristorante_Da_Bera-Venice_Veneto.html",
        percent_ital: 0.25,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 2.4849067,
      },
      geometry: { type: "Point", coordinates: [12.33261, 45.44296] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.426674,
        lng: 12.365535,
        name: "Trattoria al Diporto",
        numreviews: 188,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1739355-Reviews-Trattoria_al_Diporto-Venice_Veneto.html",
        percent_ital: 0.67021275,
        diversity_index_2: 0.42757937,
        diversity_index_3: -0.5724206,
        composite_ital_3: 1.2497754,
      },
      geometry: { type: "Point", coordinates: [12.36553, 45.42667] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441196,
        lng: 12.326015,
        name: "Osteria Alba Nova dalla Maria",
        numreviews: 489,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1741081-Reviews-Osteria_Alba_Nova_dalla_Maria-Venice_Veneto.html",
        percent_ital: 0.28629857,
        diversity_index_2: 0.39319494,
        diversity_index_3: -0.60680509,
        composite_ital_3: 2.1841698,
      },
      geometry: { type: "Point", coordinates: [12.32601, 45.4412] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443657,
        lng: 12.325535,
        name: "Ostoria Da Bepi",
        numreviews: 121,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1742748-Reviews-Ostoria_Da_Bepi-Venice_Veneto.html",
        percent_ital: 0.1570248,
        diversity_index_2: 0.38815916,
        diversity_index_3: -0.61184084,
        composite_ital_3: 2.7976913,
      },
      geometry: { type: "Point", coordinates: [12.32554, 45.44366] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434101,
        lng: 12.33576,
        name: "Trattoria da Nico",
        numreviews: 68,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1743743-Reviews-Trattoria_da_Nico-Venice_Veneto.html",
        percent_ital: 0.33823529,
        diversity_index_2: 0.42415458,
        diversity_index_3: -0.57584542,
        composite_ital_3: 1.9416709,
      },
      geometry: { type: "Point", coordinates: [12.33576, 45.4341] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "Italian",
        lat: 45.437637,
        lng: 12.341692,
        name: "Pizzeria Peter Pan",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17443515-Reviews-Pizzeria_Peter_Pan-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34169, 45.43764] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.440502,
        lng: 12.335706,
        name: "Caffe' Brasilia",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17445181-Reviews-Caffe_Brasilia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40000001000000002,
        diversity_index_3: -0.60000001999999997,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33571, 45.4405] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437363,
        lng: 12.338424,
        name: "Localino",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17465456-Reviews-Localino-Venice_Veneto.html",
        percent_ital: 0.75,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33842, 45.43736] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.446232,
        lng: 12.326125,
        name: "Ital-India Indian Restaurant",
        numreviews: 94,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17465608-Reviews-Ital_India_Indian_Restaurant-Venice_Veneto.html",
        percent_ital: 0.10638298,
        diversity_index_2: 0.73837537,
        diversity_index_3: -0.26162463,
        composite_ital_3: 2.5440125,
      },
      geometry: { type: "Point", coordinates: [12.32612, 45.44623] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438995,
        lng: 12.337659,
        name: "Restaurant Malibran",
        numreviews: 690,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1746577-Reviews-Restaurant_Malibran-Venice_Veneto.html",
        percent_ital: 0.23188406,
        diversity_index_2: 0.34086576,
        diversity_index_3: -0.65913427,
        composite_ital_3: 2.5377843,
      },
      geometry: { type: "Point", coordinates: [12.33766, 45.43899] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "Italian",
        lat: 45.437103,
        lng: 12.339434,
        name: "Manuel Cafe",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17478261-Reviews-Manuel_Cafe-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33943, 45.4371] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.436333,
        lng: 12.319198,
        name: "Ristorante Santamaria",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17497420-Reviews-Ristorante_Santamaria-Venice_Veneto.html",
        percent_ital: 0.375,
        diversity_index_2: 0.30000000999999998,
        diversity_index_3: -0.69999999000000002,
        composite_ital_3: 2.1848021,
      },
      geometry: { type: "Point", coordinates: [12.3192, 45.43633] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442829,
        lng: 12.325082,
        name: "Trattoria Vittoria",
        numreviews: 188,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1749966-Reviews-Trattoria_Vittoria-Venice_Veneto.html",
        percent_ital: 0.29255319,
        diversity_index_2: 0.47871754,
        diversity_index_3: -0.52128243,
        composite_ital_3: 1.9657533,
      },
      geometry: { type: "Point", coordinates: [12.32508, 45.44283] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: null,
        lat: 45.432171,
        lng: 12.351683,
        name: "Bar Ka di Zhang Yongkai",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17528410-Reviews-Bar_Ka_di_Zhang_Yongkai-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.35168, 45.43217] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.439823,
        lng: 12.338183,
        name: "Osteria la Busara",
        numreviews: 486,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17561440-Reviews-Osteria_la_Busara-Venice_Veneto.html",
        percent_ital: 0.34567901,
        diversity_index_2: 0.31090343,
        diversity_index_3: -0.68909657,
        composite_ital_3: 2.2305176,
      },
      geometry: { type: "Point", coordinates: [12.33818, 45.43982] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.435581,
        lng: 12.343526,
        name: "Ristorante dell'Osmarin",
        numreviews: 24,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17561787-Reviews-Ristorante_dell_Osmarin-Venice_Veneto.html",
        percent_ital: 0.125,
        diversity_index_2: 0.35930735,
        diversity_index_3: -0.64069265,
        composite_ital_3: 3.1030188,
      },
      geometry: { type: "Point", coordinates: [12.34353, 45.43558] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.446129,
        lng: 12.323604,
        name: "Al Vecio Marangon",
        numreviews: 879,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1756956-Reviews-Al_Vecio_Marangon-Venice_Veneto.html",
        percent_ital: 0.34698522,
        diversity_index_2: 0.39633998,
        diversity_index_3: -0.60365999,
        composite_ital_3: 1.983956,
      },
      geometry: { type: "Point", coordinates: [12.3236, 45.44613] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440548,
        lng: 12.329413,
        name: "Al Grill",
        numreviews: 144,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17577217-Reviews-Al_Grill-Venice_Veneto.html",
        percent_ital: 0.36805555,
        diversity_index_2: 0.51266128,
        diversity_index_3: -0.48733872,
        composite_ital_3: 1.6676613,
      },
      geometry: { type: "Point", coordinates: [12.32941, 45.44055] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439339,
        lng: 12.332622,
        name: "Ostaria Al Garanghelo",
        numreviews: 603,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1759874-Reviews-Ostaria_Al_Garanghelo-Venice_Veneto.html",
        percent_ital: 0.23383084,
        diversity_index_2: 0.39970222,
        diversity_index_3: -0.60029781,
        composite_ital_3: 2.3701928,
      },
      geometry: { type: "Point", coordinates: [12.33262, 45.43934] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$$$",
        lat: 45.426483,
        lng: 12.362622,
        name: "Ristorante Savor",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17630040-Reviews-Ristorante_Savor-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.36262, 45.42648] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43454,
        lng: 12.347601,
        name: "Da Noi Osteria Pizzeria",
        numreviews: 92,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17678706-Reviews-Da_Noi_Osteria_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.19565217,
        diversity_index_2: 0.40576577,
        diversity_index_3: -0.59423423,
        composite_ital_3: 2.533396,
      },
      geometry: { type: "Point", coordinates: [12.3476, 45.43454] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.433647,
        lng: 12.322653,
        name: "Osteria Ai pugni",
        numreviews: 383,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1769750-Reviews-Osteria_Ai_pugni-Venice_Veneto.html",
        percent_ital: 0.41253263,
        diversity_index_2: 0.36903045,
        diversity_index_3: -0.63096952,
        composite_ital_3: 1.8823161,
      },
      geometry: { type: "Point", coordinates: [12.32265, 45.43365] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.439255,
        lng: 12.321157,
        name: "Gianoâs",
        numreviews: 18,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17703985-Reviews-Giano_s-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.26923078,
        diversity_index_3: -0.73076922,
        composite_ital_3: 2.4107985,
      },
      geometry: { type: "Point", coordinates: [12.32116, 45.43926] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437366,
        lng: 12.338724,
        name: "Taverna San Lio",
        numreviews: 634,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1772771-Reviews-Taverna_San_Lio-Venice_Veneto.html",
        percent_ital: 0.34069401,
        diversity_index_2: 0.37024418,
        diversity_index_3: -0.62975585,
        composite_ital_3: 2.070363,
      },
      geometry: { type: "Point", coordinates: [12.33872, 45.43737] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432274,
        lng: 12.352232,
        name: "Bacaro Dai Bei",
        numreviews: 82,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17728433-Reviews-Bacaro_Dai_Bei-Venice_Veneto.html",
        percent_ital: 0.56097561,
        diversity_index_2: 0.4069069,
        diversity_index_3: -0.5930931,
        composite_ital_3: 1.4772487,
      },
      geometry: { type: "Point", coordinates: [12.35223, 45.43227] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437302,
        lng: 12.329952,
        name: "Muro Frari",
        numreviews: 1163,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1774989-Reviews-Muro_Frari-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.45728427,
        diversity_index_3: -0.54271573,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32995, 45.4373] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437473,
        lng: 12.334506,
        name: "Ristorante Canal Grande",
        numreviews: 834,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1774997-Reviews-Ristorante_Canal_Grande-Venice_Veneto.html",
        percent_ital: 0.23980816,
        diversity_index_2: 0.38318589,
        diversity_index_3: -0.61681414,
        composite_ital_3: 2.387151,
      },
      geometry: { type: "Point", coordinates: [12.33451, 45.43747] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434078,
        lng: 12.32317,
        name: "Osteria alla Bifora",
        numreviews: 1040,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1774999-Reviews-Osteria_alla_Bifora-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.31482291,
        diversity_index_3: -0.68517709,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32317, 45.43408] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.434063,
        lng: 12.323147,
        name: "Lounge Bar Samurai",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17751072-Reviews-Lounge_Bar_Samurai-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40000001000000002,
        diversity_index_3: -0.60000001999999997,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32315, 45.43406] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.438801,
        lng: 12.334177,
        name: "Baccala Veneto",
        numreviews: 20,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17778910-Reviews-Baccala_Veneto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.1,
        diversity_index_3: -0.89999998000000003,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33418, 45.4388] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.442947,
        lng: 12.332607,
        name: "Osteria santa Fosca",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17785537-Reviews-Osteria_santa_Fosca-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33261, 45.44295] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$$$",
        lat: 45.445038,
        lng: 12.330395,
        name: "Levante",
        numreviews: 51,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17795540-Reviews-Levante-Venice_Veneto.html",
        percent_ital: 0.41176471,
        diversity_index_2: 0.47096774,
        diversity_index_3: -0.52903223,
        composite_ital_3: 1.6402688,
      },
      geometry: { type: "Point", coordinates: [12.33039, 45.44504] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$$$",
        lat: 45.435772,
        lng: 12.326692,
        name: "Wisteria Restaurant",
        numreviews: 97,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17840212-Reviews-Wisteria_Restaurant-Venice_Veneto.html",
        percent_ital: 0.52577317,
        diversity_index_2: 0.23404256,
        diversity_index_3: -0.76595747,
        composite_ital_3: 2.0951376,
      },
      geometry: { type: "Point", coordinates: [12.32669, 45.43577] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43552,
        lng: 12.320015,
        name: "8millimetri Cicchetti & Wine",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17862710-Reviews-8millimetri_Cicchetti_Wine-Venice_Veneto.html",
        percent_ital: 0.42857143,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.84729785,
      },
      geometry: { type: "Point", coordinates: [12.32001, 45.43552] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432465,
        lng: 12.333477,
        name: "Ristorante Da Raffaele",
        numreviews: 1362,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1790766-Reviews-Ristorante_Da_Raffaele-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.44318557,
        diversity_index_3: -0.55681443,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33348, 45.43247] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439922,
        lng: 12.339018,
        name: "Antico Gatoleto",
        numreviews: 1658,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1791021-Reviews-Antico_Gatoleto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.46194419,
        diversity_index_3: -0.53805578,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33902, 45.43992] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43483,
        lng: 12.341837,
        name: "Verde Bistro",
        numreviews: 28,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d17950233-Reviews-Verde_Bistro-Venice_Veneto.html",
        percent_ital: 0.2857143,
        diversity_index_2: 0.24736843,
        diversity_index_3: -0.75263155,
        composite_ital_3: 2.6496394,
      },
      geometry: { type: "Point", coordinates: [12.34184, 45.43483] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.424583,
        lng: 12.330893,
        name: "Ristorante Al Redentor",
        numreviews: 260,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1804287-Reviews-Ristorante_Al_Redentor-Venice_Veneto.html",
        percent_ital: 0.25769231,
        diversity_index_2: 0.37090528,
        diversity_index_3: -0.62909472,
        composite_ital_3: 2.3477976,
      },
      geometry: { type: "Point", coordinates: [12.33089, 45.42458] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435856,
        lng: 12.325378,
        name: "Impronta",
        numreviews: 2086,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1808953-Reviews-Impronta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40748364,
        diversity_index_3: -0.59251636,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32538, 45.43586] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.434433,
        lng: 12.341496,
        name: "Trattoria Chinellato",
        numreviews: 255,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1815446-Reviews-Trattoria_Chinellato-Venice_Veneto.html",
        percent_ital: 0.63137257,
        diversity_index_2: 0.24254386,
        diversity_index_3: -0.75745612,
        composite_ital_3: 1.8764318,
      },
      geometry: { type: "Point", coordinates: [12.3415, 45.43443] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.43108,
        lng: 12.328139,
        name: "Raging Pub",
        numreviews: 24,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1815686-Reviews-Raging_Pub-Venice_Veneto.html",
        percent_ital: 0.041666668,
        diversity_index_2: 0.43083003,
        diversity_index_3: -0.56917,
        composite_ital_3: 4.0200953,
      },
      geometry: { type: "Point", coordinates: [12.32814, 45.43108] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.441643,
        lng: 12.334087,
        name: "Why&Not osteria",
        numreviews: 31,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18195602-Reviews-Why_Not_osteria-Venice_Veneto.html",
        percent_ital: 0.58064514,
        diversity_index_2: 0.50549453,
        diversity_index_3: -0.49450547,
        composite_ital_3: 1.2258335,
      },
      geometry: { type: "Point", coordinates: [12.33409, 45.44164] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.44389,
        lng: 12.327474,
        name: "Trattoria da GiGio",
        numreviews: 1546,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1827723-Reviews-Trattoria_da_GiGio-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.29433966,
        diversity_index_3: -0.70566034,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32747, 45.44389] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.423634,
        lng: 12.32888,
        name: "al storico da Crea",
        numreviews: 339,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1828952-Reviews-Al_storico_da_Crea-Venice_Veneto.html",
        percent_ital: 0.41887906,
        diversity_index_2: 0.36683416,
        diversity_index_3: -0.63316584,
        composite_ital_3: 1.8730184,
      },
      geometry: { type: "Point", coordinates: [12.32888, 45.42363] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437366,
        lng: 12.338599,
        name: "Ristorante Marco Polo",
        numreviews: 927,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1829552-Reviews-Ristorante_Marco_Polo-Venice_Veneto.html",
        percent_ital: 0.31930959,
        diversity_index_2: 0.40183529,
        diversity_index_3: -0.59816468,
        composite_ital_3: 2.0533071,
      },
      geometry: { type: "Point", coordinates: [12.3386, 45.43737] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433113,
        lng: 12.332446,
        name: "Da Mario",
        numreviews: 261,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1830726-Reviews-Da_Mario-Venice_Veneto.html",
        percent_ital: 0.34865901,
        diversity_index_2: 0.34020129,
        diversity_index_3: -0.65979874,
        composite_ital_3: 2.1318786,
      },
      geometry: { type: "Point", coordinates: [12.33245, 45.43311] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43536,
        lng: 12.336666,
        name: "LagunaBlu restaurant",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18344589-Reviews-LagunaBlu_restaurant-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.2,
        diversity_index_3: -0.80000000999999998,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33667, 45.43536] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44426,
        lng: 12.332801,
        name: "Trattoria Misericordia",
        numreviews: 1152,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1836188-Reviews-Trattoria_Misericordia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40009782,
        diversity_index_3: -0.59990215,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3328, 45.44426] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43552,
        lng: 12.320015,
        name: "8 Millimetri - Cicchetti & Wine",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18378017-Reviews-8_Millimetri_Cicchetti_Wine-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32001, 45.43552] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.443989,
        lng: 12.3292,
        name: "Ristorante Al Teatro Italia",
        numreviews: 67,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18454639-Reviews-Ristorante_Al_Teatro_Italia-Venice_Veneto.html",
        percent_ital: 0.28358209,
        diversity_index_2: 0.42431971,
        diversity_index_3: -0.57568026,
        composite_ital_3: 2.1175218,
      },
      geometry: { type: "Point", coordinates: [12.3292, 45.44399] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.436764,
        lng: 12.334476,
        name: "Self Service Rialto",
        numreviews: 125,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1852280-Reviews-Self_Service_Rialto-Venice_Veneto.html",
        percent_ital: 0.51999998,
        diversity_index_2: 0.18032786,
        diversity_index_3: -0.81967211,
        composite_ital_3: 2.3669052,
      },
      geometry: { type: "Point", coordinates: [12.33448, 45.43676] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.43198,
        lng: 12.335499,
        name: "Gio's",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18543458-Reviews-Gio_s-Venice_Veneto.html",
        percent_ital: 0.46153846,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.7731899,
      },
      geometry: { type: "Point", coordinates: [12.3355, 45.43198] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432407,
        lng: 12.354373,
        name: "IL Nuovo Galeon",
        numreviews: 484,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1860839-Reviews-IL_Nuovo_Galeon-Venice_Veneto.html",
        percent_ital: 0.40289256,
        diversity_index_2: 0.42140064,
        diversity_index_3: -0.57859933,
        composite_ital_3: 1.7732567,
      },
      geometry: { type: "Point", coordinates: [12.35437, 45.43241] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43734,
        lng: 12.334214,
        name: "Caffe Centrale SNC",
        numreviews: 92,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1863490-Reviews-Caffe_Centrale_SNC-Venice_Veneto.html",
        percent_ital: 0.13043478,
        diversity_index_2: 0.36645588,
        diversity_index_3: -0.63354409,
        composite_ital_3: 3.0407591,
      },
      geometry: { type: "Point", coordinates: [12.33421, 45.43734] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.4436,
        lng: 12.323723,
        name: "Alla Palazzina",
        numreviews: 538,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1866987-Reviews-Alla_Palazzina-Venice_Veneto.html",
        percent_ital: 0.29182157,
        diversity_index_2: 0.37804613,
        diversity_index_3: -0.62195385,
        composite_ital_3: 2.2043519,
      },
      geometry: { type: "Point", coordinates: [12.32372, 45.4436] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.43132,
        lng: 12.320746,
        name: "San Basegio Ristorante",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18717222-Reviews-San_Basegio_Ristorante-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.1,
        diversity_index_3: -0.89999998000000003,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32075, 45.43132] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: null,
        lat: 45.437714,
        lng: 12.335967,
        name: "Ristorante Rialto Sul Canallgrande",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18753339-Reviews-Ristorante_Rialto_Sul_Canallgrande-Venice_Veneto.html",
        percent_ital: 0.2,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33597, 45.43771] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436012,
        lng: 12.33601,
        name: "Trattoria Pizzeria Ai Fabbri",
        numreviews: 272,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1883309-Reviews-Trattoria_Pizzeria_Ai_Fabbri-Venice_Veneto.html",
        percent_ital: 0.24632353,
        diversity_index_2: 0.31916574,
        diversity_index_3: -0.68083429,
        composite_ital_3: 2.5431542,
      },
      geometry: { type: "Point", coordinates: [12.33601, 45.43601] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.439735,
        lng: 12.33816,
        name: "Un Mondo Di Vino",
        numreviews: 404,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1886705-Reviews-Un_Mondo_Di_Vino-Venice_Veneto.html",
        percent_ital: 0.40346536,
        diversity_index_2: 0.39655817,
        diversity_index_3: -0.60344183,
        composite_ital_3: 1.8325973,
      },
      geometry: { type: "Point", coordinates: [12.33816, 45.43973] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443295,
        lng: 12.325056,
        name: "Ristorante Pedrocchi",
        numreviews: 553,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1888050-Reviews-Ristorante_Pedrocchi-Venice_Veneto.html",
        percent_ital: 0.13019891,
        diversity_index_2: 0.42473865,
        diversity_index_3: -0.57526135,
        composite_ital_3: 2.8949733,
      },
      geometry: { type: "Point", coordinates: [12.32506, 45.44329] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435368,
        lng: 12.34266,
        name: "Ristorante San Provolo",
        numreviews: 342,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1888052-Reviews-Ristorante_San_Provolo-Venice_Veneto.html",
        percent_ital: 0.26900584,
        diversity_index_2: 0.3887634,
        diversity_index_3: -0.61123657,
        composite_ital_3: 2.2578065,
      },
      geometry: { type: "Point", coordinates: [12.34266, 45.43537] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439335,
        lng: 12.333479,
        name: "Vini da Pinto",
        numreviews: 828,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1888367-Reviews-Vini_da_Pinto-Venice_Veneto.html",
        percent_ital: 0.31642511,
        diversity_index_2: 0.39821389,
        diversity_index_3: -0.60178614,
        composite_ital_3: 2.0714347,
      },
      geometry: { type: "Point", coordinates: [12.33348, 45.43933] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440693,
        lng: 12.323109,
        name: "Pizzeria Vittoria",
        numreviews: 631,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1889376-Reviews-Pizzeria_Vittoria-Venice_Veneto.html",
        percent_ital: 0.26307449,
        diversity_index_2: 0.40855581,
        diversity_index_3: -0.59144419,
        composite_ital_3: 2.2304449,
      },
      geometry: { type: "Point", coordinates: [12.32311, 45.44069] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.443462,
        lng: 12.327783,
        name: "Casa Dea Corte",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18898289-Reviews-Casa_Dea_Corte-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32778, 45.44346] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439701,
        lng: 12.336749,
        name: "Bacaroo amoenus",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18904707-Reviews-Bacaroo_amoenus-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33675, 45.4397] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: null,
        lat: 45.434776,
        lng: 12.339147,
        name: "Piramide",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18931430-Reviews-Piramide-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33915, 45.43478] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.444798,
        lng: 12.328966,
        name: "Ristorante Riva",
        numreviews: 16,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18956873-Reviews-Ristorante_Riva-Venice_Veneto.html",
        percent_ital: 0.625,
        diversity_index_2: 0.30555555,
        diversity_index_3: -0.69444442,
        composite_ital_3: 1.6556273,
      },
      geometry: { type: "Point", coordinates: [12.32897, 45.4448] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.438423,
        lng: 12.341999,
        name: "Ai pie del ponte",
        numreviews: 27,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d18962986-Reviews-Ai_pie_del_ponte-Venice_Veneto.html",
        percent_ital: 0.55555558,
        diversity_index_2: 0.70512819,
        diversity_index_3: -0.29487181,
        composite_ital_3: 0.93716228,
      },
      geometry: { type: "Point", coordinates: [12.342, 45.43842] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.441975,
        lng: 12.323022,
        name: "Bella Venezia",
        numreviews: 797,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1899114-Reviews-Bella_Venezia-Venice_Veneto.html",
        percent_ital: 0.38644919,
        diversity_index_2: 0.33272845,
        diversity_index_3: -0.66727155,
        composite_ital_3: 2.0511835,
      },
      geometry: { type: "Point", coordinates: [12.32302, 45.44197] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.430733,
        lng: 12.328729,
        name: "Ristorante Agli Alboretti",
        numreviews: 644,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1899733-Reviews-Ristorante_Agli_Alboretti-Venice_Veneto.html",
        percent_ital: 0.29813665,
        diversity_index_2: 0.36589941,
        diversity_index_3: -0.63410056,
        composite_ital_3: 2.2156003,
      },
      geometry: { type: "Point", coordinates: [12.32873, 45.43073] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.438419,
        lng: 12.34201,
        name: "Ai piede del ponte",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19004074-Reviews-Ai_piede_del_ponte-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34201, 45.43842] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443169,
        lng: 12.331079,
        name: "Osteria al Cantinon",
        numreviews: 957,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1904933-Reviews-Osteria_al_Cantinon-Venice_Veneto.html",
        percent_ital: 0.53918493,
        diversity_index_2: 0.41892746,
        diversity_index_3: -0.58107257,
        composite_ital_3: 1.4877542,
      },
      geometry: { type: "Point", coordinates: [12.33108, 45.44317] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.43211,
        lng: 12.352461,
        name: "Vecio Trani",
        numreviews: 239,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1905009-Reviews-Vecio_Trani-Venice_Veneto.html",
        percent_ital: 0.69456065,
        diversity_index_2: 0.34842107,
        diversity_index_3: -0.6515789,
        composite_ital_3: 1.4188193,
      },
      geometry: { type: "Point", coordinates: [12.35246, 45.43211] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.436039,
        lng: 12.325523,
        name: "Joker's Cocktails by Vinus Venezia",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19081402-Reviews-Joker_s_Cocktails_by_Vinus_Venezia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32552, 45.43604] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.434464,
        lng: 12.325853,
        name: 'Osteria Cicchetteria "Aea Canevassa"',
        numreviews: 12,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19085557-Reviews-Osteria_Cicchetteria_Aea_Canevassa-Venice_Veneto.html",
        percent_ital: 0.83333331,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.18232158,
      },
      geometry: { type: "Point", coordinates: [12.32585, 45.43446] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43594,
        lng: 12.326521,
        name: "Osteria El Codega",
        numreviews: 111,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19118056-Reviews-Osteria_El_Codega-Venice_Veneto.html",
        percent_ital: 0.58558559,
        diversity_index_2: 0.33376622,
        diversity_index_3: -0.66623378,
        composite_ital_3: 1.6324574,
      },
      geometry: { type: "Point", coordinates: [12.32652, 45.43594] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.443768,
        lng: 12.327579,
        name: "Trattoria Da Mimmo",
        numreviews: 790,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1917367-Reviews-Trattoria_Da_Mimmo-Venice_Veneto.html",
        percent_ital: 0.57721519,
        diversity_index_2: 0.3528609,
        diversity_index_3: -0.64713907,
        composite_ital_3: 1.5912215,
      },
      geometry: { type: "Point", coordinates: [12.32758, 45.44377] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440739,
        lng: 12.325215,
        name: "Trattoria Marciana",
        numreviews: 262,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1917373-Reviews-Trattoria_Marciana-Venice_Veneto.html",
        percent_ital: 0.17557251,
        diversity_index_2: 0.42666891,
        diversity_index_3: -0.57333112,
        composite_ital_3: 2.59145,
      },
      geometry: { type: "Point", coordinates: [12.32522, 45.44074] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.430408,
        lng: 12.32311,
        name: "Ristorante Adriatica",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19212449-Reviews-Ristorante_Adriatica-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.5,
        diversity_index_3: -0.5,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32311, 45.43041] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: null,
        lat: 45.435696,
        lng: 12.33506,
        name: "Cafe Alla Citta di Torino",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19219619-Reviews-Cafe_Alla_Citta_di_Torino-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.5,
        diversity_index_3: -0.5,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33506, 45.4357] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$$$",
        lat: 45.446587,
        lng: 12.33117,
        name: "La Voga Bar",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19221566-Reviews-La_Voga_Bar-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33117, 45.44659] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435112,
        lng: 12.333094,
        name: "RistoPub Rossini",
        numreviews: 43,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19351092-Reviews-RistoPub_Rossini-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.66666669,
        diversity_index_3: -0.33333331,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33309, 45.43511] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437801,
        lng: 12.335126,
        name: "Caffe Saraceno",
        numreviews: 1481,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1935593-Reviews-Caffe_Saraceno-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.4027262,
        diversity_index_3: -0.59727383,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33513, 45.4378] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.437206,
        lng: 12.337281,
        name: "Ristorante Da Mario alla Fava",
        numreviews: 1273,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1937690-Reviews-Ristorante_Da_Mario_alla_Fava-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.38844636,
        diversity_index_3: -0.61155367,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33728, 45.43721] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.440697,
        lng: 12.329073,
        name: "Pizza Sofia di Kuch Vitaliy",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19389461-Reviews-Pizza_Sofia_di_Kuch_Vitaliy-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 2.0149031,
      },
      geometry: { type: "Point", coordinates: [12.32907, 45.4407] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.4384,
        lng: 12.328253,
        name: "Taverna da Baffo",
        numreviews: 1220,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1946522-Reviews-Taverna_da_Baffo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41516238,
        diversity_index_3: -0.58483762,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32825, 45.4384] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445248,
        lng: 12.326178,
        name: "Il Tappo",
        numreviews: 39,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19484441-Reviews-Il_Tappo-Venice_Veneto.html",
        percent_ital: 0.79487181,
        diversity_index_2: 0.80000000999999998,
        diversity_index_3: -0.19999998999999999,
        composite_ital_3: 0.45271796,
      },
      geometry: { type: "Point", coordinates: [12.32618, 45.44525] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438316,
        lng: 12.255313,
        name: "Corner Pub",
        numreviews: 1294,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1953035-Reviews-Corner_Pub-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.3392705,
        diversity_index_3: -0.66072953,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.25531, 45.43832] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.426926,
        lng: 12.324229,
        name: "Ostaria Ae Botti",
        numreviews: 724,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1953688-Reviews-Ostaria_Ae_Botti-Venice_Veneto.html",
        percent_ital: 0.4019337,
        diversity_index_2: 0.4672043,
        diversity_index_3: -0.53279567,
        composite_ital_3: 1.6724567,
      },
      geometry: { type: "Point", coordinates: [12.32423, 45.42693] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$",
        lat: 45.437798,
        lng: 12.337033,
        name: "Snack Bar Nostro",
        numreviews: 359,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1955050-Reviews-Snack_Bar_Nostro-Venice_Veneto.html",
        percent_ital: 0.12256268,
        diversity_index_2: 0.44231921,
        diversity_index_3: -0.55768079,
        composite_ital_3: 2.9148562,
      },
      geometry: { type: "Point", coordinates: [12.33703, 45.4378] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439243,
        lng: 12.321143,
        name: "Trattoria Pizzeria Antico Gafaro",
        numreviews: 345,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1974706-Reviews-Trattoria_Pizzeria_Antico_Gafaro-Venice_Veneto.html",
        percent_ital: 0.20869565,
        diversity_index_2: 0.37645653,
        diversity_index_3: -0.6235435,
        composite_ital_3: 2.5438311,
      },
      geometry: { type: "Point", coordinates: [12.32114, 45.43924] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434822,
        lng: 12.324129,
        name: "Osteria Bar Al Fontego",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19753456-Reviews-Osteria_Bar_Al_Fontego-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 2.0149031,
      },
      geometry: { type: "Point", coordinates: [12.32413, 45.43482] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: null,
        lat: 45.432983,
        lng: 12.338291,
        name: "Illy Caffe",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19816841-Reviews-Illy_Caffe-Venice_Veneto.html",
        percent_ital: 0.5,
        diversity_index_2: 0.60000001999999997,
        diversity_index_3: -0.39999997999999998,
        composite_ital_3: 1.2039728,
      },
      geometry: { type: "Point", coordinates: [12.33829, 45.43298] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.440521,
        lng: 12.33705,
        name: "Bacaro Risorto Cannaregio",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19834393-Reviews-Bacaro_Risorto_Cannaregio-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33705, 45.44052] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438137,
        lng: 12.331946,
        name: "Osteria Ai 4 Feri Storti",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19838929-Reviews-Osteria_Ai_4_Feri_Storti-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33195, 45.43814] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435749,
        lng: 12.338777,
        name: "Ristorante La Piazza",
        numreviews: 170,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19876242-Reviews-Ristorante_La_Piazza-Venice_Veneto.html",
        percent_ital: 0.15294118,
        diversity_index_2: 0.33462733,
        diversity_index_3: -0.66537267,
        composite_ital_3: 2.9724398,
      },
      geometry: { type: "Point", coordinates: [12.33878, 45.43575] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$$$",
        lat: 45.434559,
        lng: 12.337668,
        name: "Snack Bar Da Piero",
        numreviews: 502,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1994676-Reviews-Snack_Bar_Da_Piero-Venice_Veneto.html",
        percent_ital: 0.3565737,
        diversity_index_2: 0.36296296,
        diversity_index_3: -0.63703704,
        composite_ital_3: 2.0446687,
      },
      geometry: { type: "Point", coordinates: [12.33767, 45.43456] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.435768,
        lng: 12.336138,
        name: "Caffeteria Doria",
        numreviews: 60,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1995815-Reviews-Caffeteria_Doria-Venice_Veneto.html",
        percent_ital: 0.23333333,
        diversity_index_2: 0.29232192,
        diversity_index_3: -0.70767808,
        composite_ital_3: 2.6851869,
      },
      geometry: { type: "Point", coordinates: [12.33614, 45.43577] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436047,
        lng: 12.325501,
        name: "Osteria dai Fradei",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19961597-Reviews-Osteria_dai_Fradei-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.0,
      },
      geometry: { type: "Point", coordinates: [12.3255, 45.43605] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440273,
        lng: 12.330122,
        name: "Muro San Stae",
        numreviews: 1257,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1997995-Reviews-Muro_San_Stae-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.4352316,
        diversity_index_3: -0.56476843,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33012, 45.44027] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.437313,
        lng: 12.330465,
        name: "Pizzeria Cico",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d19981021-Reviews-Pizzeria_Cico-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33047, 45.43731] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438881,
        lng: 12.33225,
        name: "Pane Vino e San Daniele Rialto NICHT GESCHLOSSEN!",
        numreviews: 214,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d1998510-Reviews-Pane_Vino_e_San_Daniele_Rialto_NICHT_GESCHLOSSEN-Venice_Veneto.html",
        percent_ital: 0.39719626,
        diversity_index_2: 0.42409062,
        diversity_index_3: -0.57590938,
        composite_ital_3: 1.7811328,
      },
      geometry: { type: "Point", coordinates: [12.33225, 45.43888] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.446465,
        lng: 12.32633,
        name: "Pizzeria Al-Maaida",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d20030248-Reviews-Pizzeria_Al_Maaida-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32633, 45.44647] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445011,
        lng: 12.3228,
        name: "Osteria Sottobanco",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d20070676-Reviews-Osteria_Sottobanco-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3228, 45.44501] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438259,
        lng: 12.33406,
        name: "Ristorante Pizzeria Al Gobbo di Rialto",
        numreviews: 19,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d20083361-Reviews-Ristorante_Pizzeria_Al_Gobbo_di_Rialto-Venice_Veneto.html",
        percent_ital: 0.7368421,
        diversity_index_2: 0.71428573,
        diversity_index_3: -0.28571427,
        composite_ital_3: 0.64185387,
      },
      geometry: { type: "Point", coordinates: [12.33406, 45.43826] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: null,
        lat: 45.438152,
        lng: 12.336917,
        name: "Antica Gelateria del Corso",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d20140694-Reviews-Antica_Gelateria_del_Corso-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33692, 45.43815] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.0,
        dollarsigns: "Italian",
        lat: 45.434071,
        lng: 12.335535,
        name: "Caffe' Dei Fabbri Di Yu Peifu & C. Sas",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d20140760-Reviews-Caffe_Dei_Fabbri_Di_Yu_Peifu_C_Sas-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33554, 45.43407] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43219,
        lng: 12.352462,
        name: "La Barrique Wine Bar",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d20176991-Reviews-La_Barrique_Wine_Bar-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.35246, 45.43219] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438835,
        lng: 12.326352,
        name: "Rio Marin Ristorante Pizzeria",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d20239345-Reviews-Rio_Marin_Ristorante_Pizzeria-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32635, 45.43883] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.443081,
        lng: 12.338719,
        name: "Trattoria Storica",
        numreviews: 717,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2025873-Reviews-Trattoria_Storica-Venice_Veneto.html",
        percent_ital: 0.46304044,
        diversity_index_2: 0.38512731,
        diversity_index_3: -0.61487269,
        composite_ital_3: 1.7241223,
      },
      geometry: { type: "Point", coordinates: [12.33872, 45.44308] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439426,
        lng: 12.334609,
        name: "Caffe Vergnano 1882",
        numreviews: 400,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2031192-Reviews-Caffe_Vergnano_1882-Venice_Veneto.html",
        percent_ital: 0.32499999,
        diversity_index_2: 0.45737466,
        diversity_index_3: -0.54262531,
        composite_ital_3: 1.9061825,
      },
      geometry: { type: "Point", coordinates: [12.33461, 45.43943] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437176,
        lng: 12.339252,
        name: "La Serenissima",
        numreviews: 531,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2039614-Reviews-La_Serenissima-Venice_Veneto.html",
        percent_ital: 0.23163842,
        diversity_index_2: 0.35944453,
        diversity_index_3: -0.6405555,
        composite_ital_3: 2.4857731,
      },
      geometry: { type: "Point", coordinates: [12.33925, 45.43718] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.437298,
        lng: 12.336926,
        name: "Devil's Forest Pub",
        numreviews: 974,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2042091-Reviews-Devil_s_Forest_Pub-Venice_Veneto.html",
        percent_ital: 0.38603696,
        diversity_index_2: 0.68267137,
        diversity_index_3: -0.31732863,
        composite_ital_3: 1.3335638,
      },
      geometry: { type: "Point", coordinates: [12.33693, 45.4373] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434437,
        lng: 12.341796,
        name: "Oasi",
        numreviews: 38,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2046625-Reviews-Oasi-Venice_Veneto.html",
        percent_ital: 0.18421052,
        diversity_index_2: 0.44758064,
        diversity_index_3: -0.55241936,
        composite_ital_3: 2.4955745,
      },
      geometry: { type: "Point", coordinates: [12.3418, 45.43444] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.437908,
        lng: 12.332995,
        name: "Ostaria dai Zemei",
        numreviews: 1203,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2047687-Reviews-Ostaria_dai_Zemei-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.35893953,
        diversity_index_3: -0.64106047,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.333, 45.43791] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437237,
        lng: 12.339316,
        name: "Ristorante da Sabrina",
        numreviews: 1216,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2067411-Reviews-Ristorante_da_Sabrina-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.45264608,
        diversity_index_3: -0.54735392,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33932, 45.43724] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.441051,
        lng: 12.336595,
        name: "El Sbarlefo",
        numreviews: 233,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2069211-Reviews-El_Sbarlefo-Venice_Veneto.html",
        percent_ital: 0.47639486,
        diversity_index_2: 0.42079726,
        diversity_index_3: -0.57920277,
        composite_ital_3: 1.6071124,
      },
      geometry: { type: "Point", coordinates: [12.3366, 45.44105] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.444458,
        lng: 12.325465,
        name: "Panificio Volpe Giovanni",
        numreviews: 114,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2069217-Reviews-Panificio_Volpe_Giovanni-Venice_Veneto.html",
        percent_ital: 0.71929824,
        diversity_index_2: 0.44206774,
        diversity_index_3: -0.55793226,
        composite_ital_3: 1.1457713,
      },
      geometry: { type: "Point", coordinates: [12.32546, 45.44446] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442764,
        lng: 12.324336,
        name: "Ristorante Pizzeria Da Giorgio",
        numreviews: 490,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2070389-Reviews-Ristorante_Pizzeria_Da_Giorgio-Venice_Veneto.html",
        percent_ital: 0.32040817,
        diversity_index_2: 0.36094379,
        diversity_index_3: -0.63905621,
        composite_ital_3: 2.1571925,
      },
      geometry: { type: "Point", coordinates: [12.32434, 45.44276] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435841,
        lng: 12.334884,
        name: "Osteria Leon Bianco",
        numreviews: 585,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2072781-Reviews-Osteria_Leon_Bianco-Venice_Veneto.html",
        percent_ital: 0.27179489,
        diversity_index_2: 0.43254253,
        diversity_index_3: -0.56745744,
        composite_ital_3: 2.1407821,
      },
      geometry: { type: "Point", coordinates: [12.33488, 45.43584] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435982,
        lng: 12.339922,
        name: "Ristorante Da Stefano",
        numreviews: 490,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2073383-Reviews-Ristorante_Da_Stefano-Venice_Veneto.html",
        percent_ital: 0.35510203,
        diversity_index_2: 0.29098746,
        diversity_index_3: -0.70901251,
        composite_ital_3: 2.2698252,
      },
      geometry: { type: "Point", coordinates: [12.33992, 45.43598] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.426376,
        lng: 12.361813,
        name: "Vecia Gina",
        numreviews: 246,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2075711-Reviews-Vecia_Gina-Venice_Veneto.html",
        percent_ital: 0.36585367,
        diversity_index_2: 0.35201162,
        diversity_index_3: -0.64798838,
        composite_ital_3: 2.049613,
      },
      geometry: { type: "Point", coordinates: [12.36181, 45.42638] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.431667,
        lng: 12.333415,
        name: "Club del Doge Restaurant",
        numreviews: 501,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2076329-Reviews-Club_del_Doge_Restaurant-Venice_Veneto.html",
        percent_ital: 0.073852293,
        diversity_index_2: 0.53709906,
        diversity_index_3: -0.46290094,
        composite_ital_3: 3.2272611,
      },
      geometry: { type: "Point", coordinates: [12.33342, 45.43167] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439194,
        lng: 12.334228,
        name: "AL PEOCETO RISORTO",
        numreviews: 311,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2084170-Reviews-AL_PEOCETO_RISORTO-Venice_Veneto.html",
        percent_ital: 0.46945336,
        diversity_index_2: 0.40898925,
        diversity_index_3: -0.59101075,
        composite_ital_3: 1.6502527,
      },
      geometry: { type: "Point", coordinates: [12.33423, 45.43919] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432247,
        lng: 12.336572,
        name: "Ombra del Leone",
        numreviews: 229,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2085081-Reviews-Ombra_del_Leone-Venice_Veneto.html",
        percent_ital: 0.35371178,
        diversity_index_2: 0.4320358,
        diversity_index_3: -0.5679642,
        composite_ital_3: 1.8785197,
      },
      geometry: { type: "Point", coordinates: [12.33657, 45.43225] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438396,
        lng: 12.334915,
        name: "Trattoria Rialto Novo",
        numreviews: 880,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2085941-Reviews-Trattoria_Rialto_Novo-Venice_Veneto.html",
        percent_ital: 0.45795456,
        diversity_index_2: 0.34254429,
        diversity_index_3: -0.65745568,
        composite_ital_3: 1.8523396,
      },
      geometry: { type: "Point", coordinates: [12.33492, 45.4384] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435944,
        lng: 12.335355,
        name: "bar torino",
        numreviews: 219,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2086618-Reviews-Bar_torino-Venice_Veneto.html",
        percent_ital: 0.42465752,
        diversity_index_2: 0.38757655,
        diversity_index_3: -0.61242342,
        composite_ital_3: 1.8043141,
      },
      geometry: { type: "Point", coordinates: [12.33535, 45.43594] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.440289,
        lng: 12.329951,
        name: "LINOTECA",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2087164-Reviews-LINOTECA-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32995, 45.44029] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438034,
        lng: 12.337201,
        name: "Bacarando in Corte dell'Orso",
        numreviews: 953,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2087222-Reviews-Bacarando_in_Corte_dell_Orso-Venice_Veneto.html",
        percent_ital: 0.71143758,
        diversity_index_2: 0.46947807,
        diversity_index_3: -0.53052193,
        composite_ital_3: 1.0966012,
      },
      geometry: { type: "Point", coordinates: [12.3372, 45.43803] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434822,
        lng: 12.323842,
        name: "Fuori Rotta",
        numreviews: 240,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2090482-Reviews-Fuori_Rotta-Venice_Veneto.html",
        percent_ital: 0.24583334,
        diversity_index_2: 0.406113,
        diversity_index_3: -0.59388697,
        composite_ital_3: 2.3042254,
      },
      geometry: { type: "Point", coordinates: [12.32384, 45.43482] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443768,
        lng: 12.329124,
        name: "La Colombina",
        numreviews: 1372,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2090619-Reviews-La_Colombina-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40252572,
        diversity_index_3: -0.59747428,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32912, 45.44377] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439255,
        lng: 12.321157,
        name: "Trattoria Ai Tre Ponti Di Trevisan B",
        numreviews: 130,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2091937-Reviews-Trattoria_Ai_Tre_Ponti_Di_Trevisan_B-Venice_Veneto.html",
        percent_ital: 0.33846155,
        diversity_index_2: 0.36728147,
        diversity_index_3: -0.63271856,
        composite_ital_3: 2.0849714,
      },
      geometry: { type: "Point", coordinates: [12.32116, 45.43926] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.431396,
        lng: 12.328815,
        name: "Bar Foscarini",
        numreviews: 355,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2097469-Reviews-Bar_Foscarini-Venice_Veneto.html",
        percent_ital: 0.12394366,
        diversity_index_2: 0.54139018,
        diversity_index_3: -0.45860982,
        composite_ital_3: 2.7015431,
      },
      geometry: { type: "Point", coordinates: [12.32882, 45.4314] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.440556,
        lng: 12.334373,
        name: "L'Alcova Restaurant at Ca' Sagredo Hotel",
        numreviews: 188,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2098747-Reviews-L_Alcova_Restaurant_at_Ca_Sagredo_Hotel-Venice_Veneto.html",
        percent_ital: 0.2606383,
        diversity_index_2: 0.59331965,
        diversity_index_3: -0.40668035,
        composite_ital_3: 1.8666437,
      },
      geometry: { type: "Point", coordinates: [12.33437, 45.44056] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.444595,
        lng: 12.332064,
        name: "Paradiso Perduto",
        numreviews: 1314,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2102004-Reviews-Paradiso_Perduto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.36851019,
        diversity_index_3: -0.63148981,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33206, 45.44459] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432034,
        lng: 12.350597,
        name: "la nuova perla",
        numreviews: 449,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2102600-Reviews-La_nuova_perla-Venice_Veneto.html",
        percent_ital: 0.21603563,
        diversity_index_2: 0.35687649,
        diversity_index_3: -0.64312351,
        composite_ital_3: 2.5626774,
      },
      geometry: { type: "Point", coordinates: [12.3506, 45.43203] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43512,
        lng: 12.339819,
        name: "Trattoria Ai Leoncini",
        numreviews: 605,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2108455-Reviews-Trattoria_Ai_Leoncini-Venice_Veneto.html",
        percent_ital: 0.23305786,
        diversity_index_2: 0.3757664,
        diversity_index_3: -0.6242336,
        composite_ital_3: 2.4352562,
      },
      geometry: { type: "Point", coordinates: [12.33982, 45.43512] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437729,
        lng: 12.337481,
        name: "Bar Novo",
        numreviews: 409,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2108576-Reviews-Bar_Novo-Venice_Veneto.html",
        percent_ital: 0.15892421,
        diversity_index_2: 0.36704364,
        diversity_index_3: -0.63295639,
        composite_ital_3: 2.8416023,
      },
      geometry: { type: "Point", coordinates: [12.33748, 45.43773] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435219,
        lng: 12.340232,
        name: "Trattoria Canonica",
        numreviews: 789,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2143266-Reviews-Trattoria_Canonica-Venice_Veneto.html",
        percent_ital: 0.22686945,
        diversity_index_2: 0.3984172,
        diversity_index_3: -0.60158277,
        composite_ital_3: 2.403636,
      },
      geometry: { type: "Point", coordinates: [12.34023, 45.43522] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.443714,
        lng: 12.325801,
        name: "Trattoria Spaccanapoli",
        numreviews: 12,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2148072-Reviews-Trattoria_Spaccanapoli-Venice_Veneto.html",
        percent_ital: 1.0,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3258, 45.44371] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433304,
        lng: 12.330824,
        name: "Le Cafe",
        numreviews: 938,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2148659-Reviews-Le_Cafe-Venice_Veneto.html",
        percent_ital: 0.26652452,
        diversity_index_2: 0.40219399,
        diversity_index_3: -0.59780598,
        composite_ital_3: 2.2331097,
      },
      geometry: { type: "Point", coordinates: [12.33082, 45.4333] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43449,
        lng: 12.347569,
        name: "Ristorante Fantasia",
        numreviews: 167,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2160508-Reviews-Ristorante_Fantasia-Venice_Veneto.html",
        percent_ital: 0.13772455,
        diversity_index_2: 0.49128354,
        diversity_index_3: -0.50871646,
        composite_ital_3: 2.6932335,
      },
      geometry: { type: "Point", coordinates: [12.34757, 45.43449] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Italian",
        lat: 45.445244,
        lng: 12.326609,
        name: "Ai Quattro Rusteghi",
        numreviews: 11,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2163365-Reviews-Ai_Quattro_Rusteghi-Venice_Veneto.html",
        percent_ital: 0.27272728,
        diversity_index_2: 0.6111111,
        diversity_index_3: -0.3888889,
        composite_ital_3: 1.7917595,
      },
      geometry: { type: "Point", coordinates: [12.32661, 45.44524] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433239,
        lng: 12.334425,
        name: "Ristorante Alla Borsa",
        numreviews: 289,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2186395-Reviews-Ristorante_Alla_Borsa-Venice_Veneto.html",
        percent_ital: 0.12456747,
        diversity_index_2: 0.47957388,
        diversity_index_3: -0.52042615,
        composite_ital_3: 2.817765,
      },
      geometry: { type: "Point", coordinates: [12.33442, 45.43324] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433834,
        lng: 12.338746,
        name: "Caffe Aurora",
        numreviews: 269,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2186544-Reviews-Caffe_Aurora-Venice_Veneto.html",
        percent_ital: 0.14869888,
        diversity_index_2: 0.4151327,
        diversity_index_3: -0.5848673,
        composite_ital_3: 2.7849891,
      },
      geometry: { type: "Point", coordinates: [12.33875, 45.43383] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.444263,
        lng: 12.332699,
        name: "Ristorante Diana",
        numreviews: 601,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2188038-Reviews-Ristorante_Diana-Venice_Veneto.html",
        percent_ital: 0.13643926,
        diversity_index_2: 0.48154521,
        diversity_index_3: -0.51845479,
        composite_ital_3: 2.722631,
      },
      geometry: { type: "Point", coordinates: [12.3327, 45.44426] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.443897,
        lng: 12.338865,
        name: "Pizzeria Tortuga",
        numreviews: 142,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2205723-Reviews-Pizzeria_Tortuga-Venice_Veneto.html",
        percent_ital: 0.11267605,
        diversity_index_2: 0.22522184,
        diversity_index_3: -0.77477813,
        composite_ital_3: 3.6739078,
      },
      geometry: { type: "Point", coordinates: [12.33887, 45.4439] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44083,
        lng: 12.325424,
        name: "Bar Mirabar",
        numreviews: 145,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2209719-Reviews-Bar_Mirabar-Venice_Veneto.html",
        percent_ital: 0.096551724,
        diversity_index_2: 0.49144113,
        diversity_index_3: -0.50855887,
        composite_ital_3: 3.0480895,
      },
      geometry: { type: "Point", coordinates: [12.32542, 45.44083] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439716,
        lng: 12.337076,
        name: "L'Osteria All'Ombra",
        numreviews: 105,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2212955-Reviews-L_Osteria_All_Ombra-Venice_Veneto.html",
        percent_ital: 0.32380953,
        diversity_index_2: 0.57496196,
        diversity_index_3: -0.42503804,
        composite_ital_3: 1.6810513,
      },
      geometry: { type: "Point", coordinates: [12.33708, 45.43972] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433754,
        lng: 12.357149,
        name: "Trattoria alla Nuova Speranza",
        numreviews: 173,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2213158-Reviews-Trattoria_alla_Nuova_Speranza-Venice_Veneto.html",
        percent_ital: 0.63583815,
        diversity_index_2: 0.36309522,
        diversity_index_3: -0.63690478,
        composite_ital_3: 1.4659014,
      },
      geometry: { type: "Point", coordinates: [12.35715, 45.43375] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.437214,
        lng: 12.331018,
        name: "Sanpolo Kebab",
        numreviews: 34,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2216482-Reviews-Sanpolo_Kebab-Venice_Veneto.html",
        percent_ital: 0.47058824,
        diversity_index_2: 0.2748538,
        diversity_index_3: -0.72514617,
        composite_ital_3: 2.0452878,
      },
      geometry: { type: "Point", coordinates: [12.33102, 45.43721] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432281,
        lng: 12.353157,
        name: "Ristorante Biennale",
        numreviews: 260,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2216767-Reviews-Ristorante_Biennale-Venice_Veneto.html",
        percent_ital: 0.23846154,
        diversity_index_2: 0.36723617,
        diversity_index_3: -0.63276386,
        composite_ital_3: 2.4352973,
      },
      geometry: { type: "Point", coordinates: [12.35316, 45.43228] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.44352,
        lng: 12.32746,
        name: "Times Cafe",
        numreviews: 30,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2221251-Reviews-Times_Cafe-Venice_Veneto.html",
        percent_ital: 0.26666668,
        diversity_index_2: 0.32411069,
        diversity_index_3: -0.67588931,
        composite_ital_3: 2.448426,
      },
      geometry: { type: "Point", coordinates: [12.32746, 45.44352] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.433052,
        lng: 12.324989,
        name: "Bar Canton",
        numreviews: 60,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2221322-Reviews-Bar_Canton-Venice_Veneto.html",
        percent_ital: 0.23333333,
        diversity_index_2: 0.29972249,
        diversity_index_3: -0.70027751,
        composite_ital_3: 2.6601856,
      },
      geometry: { type: "Point", coordinates: [12.32499, 45.43305] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.434212,
        lng: 12.32581,
        name: "Bar Ai Artisti",
        numreviews: 251,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2228067-Reviews-Bar_Ai_Artisti-Venice_Veneto.html",
        percent_ital: 0.21513945,
        diversity_index_2: 0.37927008,
        diversity_index_3: -0.62072992,
        composite_ital_3: 2.5059755,
      },
      geometry: { type: "Point", coordinates: [12.32581, 45.43421] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.43343,
        lng: 12.324405,
        name: "Imagina",
        numreviews: 137,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2230306-Reviews-Imagina-Venice_Veneto.html",
        percent_ital: 0.270073,
        diversity_index_2: 0.41762376,
        diversity_index_3: -0.58237624,
        composite_ital_3: 2.1822374,
      },
      geometry: { type: "Point", coordinates: [12.32441, 45.43343] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441158,
        lng: 12.322723,
        name: "Ristorante Ai Scalzi",
        numreviews: 331,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2236327-Reviews-Ristorante_Ai_Scalzi-Venice_Veneto.html",
        percent_ital: 0.27492446,
        diversity_index_2: 0.4093824,
        diversity_index_3: -0.5906176,
        composite_ital_3: 2.1843646,
      },
      geometry: { type: "Point", coordinates: [12.32272, 45.44116] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440289,
        lng: 12.3363,
        name: "Solda",
        numreviews: 166,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2240918-Reviews-Solda-Venice_Veneto.html",
        percent_ital: 0.22289157,
        diversity_index_2: 0.47573048,
        diversity_index_3: -0.52426952,
        composite_ital_3: 2.2439737,
      },
      geometry: { type: "Point", coordinates: [12.3363, 45.44029] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435532,
        lng: 12.323934,
        name: "Trattoria Ca' Foscari Al Canton",
        numreviews: 289,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2244386-Reviews-Trattoria_Ca_Foscari_Al_Canton-Venice_Veneto.html",
        percent_ital: 0.40830451,
        diversity_index_2: 0.31904855,
        diversity_index_3: -0.68095148,
        composite_ital_3: 2.0381541,
      },
      geometry: { type: "Point", coordinates: [12.32393, 45.43553] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43911,
        lng: 12.34119,
        name: "Snack Al Cavallo",
        numreviews: 105,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2248460-Reviews-Snack_Al_Cavallo-Venice_Veneto.html",
        percent_ital: 0.10476191,
        diversity_index_2: 0.3905935,
        diversity_index_3: -0.60940647,
        composite_ital_3: 3.1961529,
      },
      geometry: { type: "Point", coordinates: [12.34119, 45.43911] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.443764,
        lng: 12.326035,
        name: "Bar Gelateria Da Nini",
        numreviews: 48,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2248501-Reviews-Bar_Gelateria_Da_Nini-Venice_Veneto.html",
        percent_ital: 0.35416666,
        diversity_index_2: 0.26411289,
        diversity_index_3: -0.73588711,
        composite_ital_3: 2.3693664,
      },
      geometry: { type: "Point", coordinates: [12.32603, 45.44376] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433887,
        lng: 12.346666,
        name: "Caffe Bucintoro",
        numreviews: 111,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2275410-Reviews-Caffe_Bucintoro-Venice_Veneto.html",
        percent_ital: 0.32432431,
        diversity_index_2: 0.38491228,
        diversity_index_3: -0.61508775,
        composite_ital_3: 2.0807512,
      },
      geometry: { type: "Point", coordinates: [12.34667, 45.43389] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.428772,
        lng: 12.358081,
        name: "Ristorante InParadiso",
        numreviews: 195,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2290278-Reviews-Ristorante_InParadiso-Venice_Veneto.html",
        percent_ital: 0.37435898,
        diversity_index_2: 0.35492471,
        diversity_index_3: -0.64507532,
        composite_ital_3: 2.0183897,
      },
      geometry: { type: "Point", coordinates: [12.35808, 45.42877] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.435963,
        lng: 12.337566,
        name: "Le Maschere",
        numreviews: 315,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2292422-Reviews-Le_Maschere-Venice_Veneto.html",
        percent_ital: 0.59682542,
        diversity_index_2: 0.30038759,
        diversity_index_3: -0.69961238,
        composite_ital_3: 1.7188122,
      },
      geometry: { type: "Point", coordinates: [12.33757, 45.43596] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.431679,
        lng: 12.32642,
        name: "Bar alla Toletta",
        numreviews: 535,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2294015-Reviews-Bar_alla_Toletta-Venice_Veneto.html",
        percent_ital: 0.49345794,
        diversity_index_2: 0.31627497,
        diversity_index_3: -0.683725,
        composite_ital_3: 1.8574609,
      },
      geometry: { type: "Point", coordinates: [12.32642, 45.43168] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438507,
        lng: 12.345386,
        name: "El Bacaro dal Doge",
        numreviews: 26,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2299401-Reviews-El_Bacaro_dal_Doge-Venice_Veneto.html",
        percent_ital: 0.57692307,
        diversity_index_2: 0.27472529,
        diversity_index_3: -0.72527468,
        composite_ital_3: 1.84203,
      },
      geometry: { type: "Point", coordinates: [12.34539, 45.43851] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44471,
        lng: 12.33145,
        name: "Ristorante Il Migliore",
        numreviews: 114,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2313031-Reviews-Ristorante_Il_Migliore-Venice_Veneto.html",
        percent_ital: 0.21052632,
        diversity_index_2: 0.42295483,
        diversity_index_3: -0.5770452,
        composite_ital_3: 2.4186344,
      },
      geometry: { type: "Point", coordinates: [12.33145, 45.44471] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435616,
        lng: 12.344111,
        name: "Crazy Bar",
        numreviews: 253,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2315010-Reviews-Crazy_Bar-Venice_Veneto.html",
        percent_ital: 0.15810277,
        diversity_index_2: 0.49058899,
        diversity_index_3: -0.50941098,
        composite_ital_3: 2.5566585,
      },
      geometry: { type: "Point", coordinates: [12.34411, 45.43562] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43605,
        lng: 12.343469,
        name: "Luna Sentada",
        numreviews: 510,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2321195-Reviews-Luna_Sentada-Venice_Veneto.html",
        percent_ital: 0.3137255,
        diversity_index_2: 0.41163236,
        diversity_index_3: -0.58836764,
        composite_ital_3: 2.0468614,
      },
      geometry: { type: "Point", coordinates: [12.34347, 45.43605] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435143,
        lng: 12.339395,
        name: "Ristorante Marciana San Marco",
        numreviews: 580,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2321827-Reviews-Ristorante_Marciana_San_Marco-Venice_Veneto.html",
        percent_ital: 0.20862068,
        diversity_index_2: 0.33212197,
        diversity_index_3: -0.66787803,
        composite_ital_3: 2.6694906,
      },
      geometry: { type: "Point", coordinates: [12.33939, 45.43514] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436081,
        lng: 12.33904,
        name: "San Zulian",
        numreviews: 528,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2323759-Reviews-San_Zulian-Venice_Veneto.html",
        percent_ital: 0.28030303,
        diversity_index_2: 0.4023993,
        diversity_index_3: -0.5976007,
        composite_ital_3: 2.1821945,
      },
      geometry: { type: "Point", coordinates: [12.33904, 45.43608] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43681,
        lng: 12.325253,
        name: "Bar Al Timon",
        numreviews: 41,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2325608-Reviews-Bar_Al_Timon-Venice_Veneto.html",
        percent_ital: 0.31707317,
        diversity_index_2: 0.3275862,
        diversity_index_3: -0.67241383,
        composite_ital_3: 2.2646267,
      },
      geometry: { type: "Point", coordinates: [12.32525, 45.43681] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445049,
        lng: 12.325869,
        name: "Pizzeria Ristorante Al Faro",
        numreviews: 529,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2328914-Reviews-Pizzeria_Ristorante_Al_Faro-Venice_Veneto.html",
        percent_ital: 0.21928166,
        diversity_index_2: 0.37386647,
        diversity_index_3: -0.62613356,
        composite_ital_3: 2.5012548,
      },
      geometry: { type: "Point", coordinates: [12.32587, 45.44505] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432789,
        lng: 12.333374,
        name: "Ristorante Al GIglio",
        numreviews: 415,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2329059-Reviews-Ristorante_Al_GIglio-Venice_Veneto.html",
        percent_ital: 0.077108435,
        diversity_index_2: 0.45840096,
        diversity_index_3: -0.54159904,
        composite_ital_3: 3.3425536,
      },
      geometry: { type: "Point", coordinates: [12.33337, 45.43279] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438915,
        lng: 12.323416,
        name: "La Rivetta",
        numreviews: 83,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2330309-Reviews-La_Rivetta-Venice_Veneto.html",
        percent_ital: 0.77108431,
        diversity_index_2: 0.28138527,
        diversity_index_3: -0.7186147,
        composite_ital_3: 1.5279881,
      },
      geometry: { type: "Point", coordinates: [12.32342, 45.43892] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.441486,
        lng: 12.336562,
        name: "Osteria ai Osti",
        numreviews: 224,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2330956-Reviews-Osteria_ai_Osti-Venice_Veneto.html",
        percent_ital: 0.6875,
        diversity_index_2: 0.32496196,
        diversity_index_3: -0.67503804,
        composite_ital_3: 1.4987406,
      },
      geometry: { type: "Point", coordinates: [12.33656, 45.44149] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436844,
        lng: 12.319353,
        name: "Trattoria Hostaria Venexiana",
        numreviews: 327,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2337952-Reviews-Trattoria_Hostaria_Venexiana-Venice_Veneto.html",
        percent_ital: 0.33027524,
        diversity_index_2: 0.40222132,
        diversity_index_3: -0.59777868,
        composite_ital_3: 2.0185816,
      },
      geometry: { type: "Point", coordinates: [12.31935, 45.43684] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436558,
        lng: 12.347619,
        name: "Trattoria da Jonny",
        numreviews: 976,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2342315-Reviews-Trattoria_da_Jonny-Venice_Veneto.html",
        percent_ital: 0.44569671,
        diversity_index_2: 0.40056103,
        diversity_index_3: -0.59943897,
        composite_ital_3: 1.7230057,
      },
      geometry: { type: "Point", coordinates: [12.34762, 45.43656] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438828,
        lng: 12.335269,
        name: "Ancora",
        numreviews: 304,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2342692-Reviews-Ancora-Venice_Veneto.html",
        percent_ital: 0.3881579,
        diversity_index_2: 0.37529868,
        diversity_index_3: -0.62470132,
        composite_ital_3: 1.9263761,
      },
      geometry: { type: "Point", coordinates: [12.33527, 45.43883] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Italian",
        lat: 45.438805,
        lng: 12.333615,
        name: "Rinomato Restaurant",
        numreviews: 15,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2342718-Reviews-Rinomato_Restaurant-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.38095239,
        diversity_index_3: -0.61904764,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33361, 45.43881] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445324,
        lng: 12.329458,
        name: "Osteria Al Mariner",
        numreviews: 462,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2342758-Reviews-Osteria_Al_Mariner-Venice_Veneto.html",
        percent_ital: 0.40909091,
        diversity_index_2: 0.41285902,
        diversity_index_3: -0.58714098,
        composite_ital_3: 1.7784669,
      },
      geometry: { type: "Point", coordinates: [12.32946, 45.44532] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.430866,
        lng: 12.333824,
        name: "Antinoo's Lounge & Restaurant",
        numreviews: 139,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2346482-Reviews-Antinoo_s_Lounge_Restaurant-Venice_Veneto.html",
        percent_ital: 0.30215827,
        diversity_index_2: 0.42583632,
        diversity_index_3: -0.57416368,
        composite_ital_3: 2.0505047,
      },
      geometry: { type: "Point", coordinates: [12.33382, 45.43087] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$",
        lat: 45.439419,
        lng: 12.333486,
        name: "Bar Stellina",
        numreviews: 134,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2346728-Reviews-Bar_Stellina-Venice_Veneto.html",
        percent_ital: 0.2238806,
        diversity_index_2: 0.34835166,
        diversity_index_3: -0.65164834,
        composite_ital_3: 2.5511851,
      },
      geometry: { type: "Point", coordinates: [12.33349, 45.43942] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440289,
        lng: 12.325215,
        name: "Trattoria Alla Ferrata",
        numreviews: 1633,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2357976-Reviews-Trattoria_Alla_Ferrata-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.15837497,
        diversity_index_3: -0.84162503,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32522, 45.44029] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.431419,
        lng: 12.355869,
        name: "Ristorante Ai Tosi Grandi",
        numreviews: 111,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2359369-Reviews-Ristorante_Ai_Tosi_Grandi-Venice_Veneto.html",
        percent_ital: 0.61261261,
        diversity_index_2: 0.35959595,
        diversity_index_3: -0.64040405,
        composite_ital_3: 1.5127968,
      },
      geometry: { type: "Point", coordinates: [12.35587, 45.43142] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434948,
        lng: 12.339729,
        name: "Ristorante Falciani",
        numreviews: 457,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2360954-Reviews-Ristorante_Falciani-Venice_Veneto.html",
        percent_ital: 0.1356674,
        diversity_index_2: 0.36601555,
        diversity_index_3: -0.63398445,
        composite_ital_3: 3.0026286,
      },
      geometry: { type: "Point", coordinates: [12.33973, 45.43495] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442501,
        lng: 12.323217,
        name: "Ristorante All'Aquila",
        numreviews: 534,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2368212-Reviews-Ristorante_All_Aquila-Venice_Veneto.html",
        percent_ital: 0.31835207,
        diversity_index_2: 0.29472265,
        diversity_index_3: -0.70527732,
        composite_ital_3: 2.366318,
      },
      geometry: { type: "Point", coordinates: [12.32322, 45.4425] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437313,
        lng: 12.3304,
        name: "Cico",
        numreviews: 192,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2369057-Reviews-Cico-Venice_Veneto.html",
        percent_ital: 0.15625,
        diversity_index_2: 0.31568584,
        diversity_index_3: -0.68431413,
        composite_ital_3: 3.0093057,
      },
      geometry: { type: "Point", coordinates: [12.3304, 45.43731] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435204,
        lng: 12.33948,
        name: "Ristorante pizza e bar da celio",
        numreviews: 189,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2369387-Reviews-Ristorante_pizza_e_bar_da_celio-Venice_Veneto.html",
        percent_ital: 0.16402116,
        diversity_index_2: 0.46071172,
        diversity_index_3: -0.53928828,
        composite_ital_3: 2.5827427,
      },
      geometry: { type: "Point", coordinates: [12.33948, 45.4352] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437748,
        lng: 12.330316,
        name: "Osteria Al Sacro & Profano",
        numreviews: 482,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2370479-Reviews-Osteria_Al_Sacro_Profano-Venice_Veneto.html",
        percent_ital: 0.36307055,
        diversity_index_2: 0.37683353,
        diversity_index_3: -0.62316644,
        composite_ital_3: 1.9891099,
      },
      geometry: { type: "Point", coordinates: [12.33032, 45.43775] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Italian",
        lat: 45.439442,
        lng: 12.32101,
        name: "Vispa Teresa",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2371321-Reviews-Vispa_Teresa-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32101, 45.43944] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.44379,
        lng: 12.325944,
        name: "Al Poggio",
        numreviews: 847,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2375019-Reviews-Al_Poggio-Venice_Veneto.html",
        percent_ital: 0.31523022,
        diversity_index_2: 0.38557085,
        diversity_index_3: -0.61442912,
        composite_ital_3: 2.1074824,
      },
      geometry: { type: "Point", coordinates: [12.32594, 45.44379] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437641,
        lng: 12.321597,
        name: "Ca' Leon",
        numreviews: 280,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2384932-Reviews-Ca_Leon-Venice_Veneto.html",
        percent_ital: 0.21071428,
        diversity_index_2: 0.50987756,
        diversity_index_3: -0.49012244,
        composite_ital_3: 2.2308369,
      },
      geometry: { type: "Point", coordinates: [12.3216, 45.43764] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.433975,
        lng: 12.32303,
        name: "Mi e Ti",
        numreviews: 34,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2389450-Reviews-Mi_e_Ti-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.30000000999999998,
        diversity_index_3: -0.69999999000000002,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32303, 45.43397] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435234,
        lng: 12.336859,
        name: "Trattoria Pizzeria da Gioia",
        numreviews: 1341,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2390420-Reviews-Trattoria_Pizzeria_da_Gioia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.35352376,
        diversity_index_3: -0.64647627,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33686, 45.43523] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433773,
        lng: 12.346326,
        name: "Al Gabbiano",
        numreviews: 296,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2390502-Reviews-Al_Gabbiano-Venice_Veneto.html",
        percent_ital: 0.20608108,
        diversity_index_2: 0.42709005,
        diversity_index_3: -0.57290995,
        composite_ital_3: 2.4302461,
      },
      geometry: { type: "Point", coordinates: [12.34633, 45.43377] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444225,
        lng: 12.323996,
        name: "La Bella Pollastrella",
        numreviews: 679,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2391595-Reviews-La_Bella_Pollastrella-Venice_Veneto.html",
        percent_ital: 0.70544916,
        diversity_index_2: 0.40108269,
        diversity_index_3: -0.59891731,
        composite_ital_3: 1.2625082,
      },
      geometry: { type: "Point", coordinates: [12.324, 45.44423] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.442139,
        lng: 12.321714,
        name: "Shanghai",
        numreviews: 34,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2399629-Reviews-Shanghai-Venice_Veneto.html",
        percent_ital: 0.14705883,
        diversity_index_2: 0.42528737,
        diversity_index_3: -0.57471263,
        composite_ital_3: 2.7719128,
      },
      geometry: { type: "Point", coordinates: [12.32171, 45.44214] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434063,
        lng: 12.33551,
        name: "Al Gallo D'Oro",
        numreviews: 272,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2414548-Reviews-Al_Gallo_D_Oro-Venice_Veneto.html",
        percent_ital: 0.15073529,
        diversity_index_2: 0.30986384,
        diversity_index_3: -0.69013619,
        composite_ital_3: 3.0638523,
      },
      geometry: { type: "Point", coordinates: [12.33551, 45.43406] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.443829,
        lng: 12.328705,
        name: "Enoteca Do Colonne",
        numreviews: 240,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2420375-Reviews-Enoteca_Do_Colonne-Venice_Veneto.html",
        percent_ital: 0.68333334,
        diversity_index_2: 0.32684192,
        diversity_index_3: -0.67315805,
        composite_ital_3: 1.4990511,
      },
      geometry: { type: "Point", coordinates: [12.3287, 45.44383] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445023,
        lng: 12.321668,
        name: "Ai Tre Archi",
        numreviews: 1573,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2434985-Reviews-Ai_Tre_Archi-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.37970278,
        diversity_index_3: -0.62029719,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32167, 45.44502] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445572,
        lng: 12.320724,
        name: "Osteria ai Canottieri",
        numreviews: 239,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2440702-Reviews-Osteria_ai_Canottieri-Venice_Veneto.html",
        percent_ital: 0.61506277,
        diversity_index_2: 0.34408602,
        diversity_index_3: -0.65591395,
        composite_ital_3: 1.5528946,
      },
      geometry: { type: "Point", coordinates: [12.32072, 45.44557] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.434052,
        lng: 12.328197,
        name: "The Restaurant",
        numreviews: 56,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2446923-Reviews-The_Restaurant-Venice_Veneto.html",
        percent_ital: 0.26785713,
        diversity_index_2: 0.45760745,
        diversity_index_3: -0.54239255,
        composite_ital_3: 2.099045,
      },
      geometry: { type: "Point", coordinates: [12.3282, 45.43405] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.440655,
        lng: 12.336481,
        name: "Maitardi Enobar",
        numreviews: 21,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2475446-Reviews-Maitardi_Enobar-Venice_Veneto.html",
        percent_ital: 0.38095239,
        diversity_index_2: 0.34065935,
        diversity_index_3: -0.65934062,
        composite_ital_3: 2.0419531,
      },
      geometry: { type: "Point", coordinates: [12.33648, 45.44065] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437786,
        lng: 12.333428,
        name: "Ai Coghi",
        numreviews: 391,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2478369-Reviews-Ai_Coghi-Venice_Veneto.html",
        percent_ital: 0.17902814,
        diversity_index_2: 0.4368574,
        diversity_index_3: -0.5631426,
        composite_ital_3: 2.5483608,
      },
      geometry: { type: "Point", coordinates: [12.33343, 45.43779] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440357,
        lng: 12.336826,
        name: "Trattoria da Rino",
        numreviews: 744,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2489959-Reviews-Trattoria_da_Rino-Venice_Veneto.html",
        percent_ital: 0.50403225,
        diversity_index_2: 0.4484719,
        diversity_index_3: -0.5515281,
        composite_ital_3: 1.4870243,
      },
      geometry: { type: "Point", coordinates: [12.33683, 45.44036] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$",
        lat: 45.439098,
        lng: 12.332325,
        name: "Il Sigillo da Mauro e Mimmo",
        numreviews: 112,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2492112-Reviews-Il_Sigillo_da_Mauro_e_Mimmo-Venice_Veneto.html",
        percent_ital: 0.30357143,
        diversity_index_2: 0.33560532,
        diversity_index_3: -0.66439468,
        composite_ital_3: 2.2839577,
      },
      geometry: { type: "Point", coordinates: [12.33233, 45.4391] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.444832,
        lng: 12.329051,
        name: "Orient Experience",
        numreviews: 729,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2524755-Reviews-Orient_Experience-Venice_Veneto.html",
        percent_ital: 0.58299041,
        diversity_index_2: 0.50505155,
        diversity_index_3: -0.49494845,
        composite_ital_3: 1.2226794,
      },
      geometry: { type: "Point", coordinates: [12.32905, 45.44483] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.443352,
        lng: 12.33218,
        name: "Il Santo Bevitore",
        numreviews: 476,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2531159-Reviews-Il_Santo_Bevitore-Venice_Veneto.html",
        percent_ital: 0.37605041,
        diversity_index_2: 0.5478707,
        diversity_index_3: -0.4521293,
        composite_ital_3: 1.579748,
      },
      geometry: { type: "Point", coordinates: [12.33218, 45.44335] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.429321,
        lng: 12.327468,
        name: "bar laguna",
        numreviews: 181,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2539707-Reviews-Bar_laguna-Venice_Veneto.html",
        percent_ital: 0.31491712,
        diversity_index_2: 0.40228572,
        diversity_index_3: -0.5977143,
        composite_ital_3: 2.0660384,
      },
      geometry: { type: "Point", coordinates: [12.32747, 45.42932] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.443707,
        lng: 12.326181,
        name: "Cicchetteria Venexiana Da Luca e Fred",
        numreviews: 601,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2542152-Reviews-Cicchetteria_Venexiana_Da_Luca_e_Fred-Venice_Veneto.html",
        percent_ital: 0.66888517,
        diversity_index_2: 0.32471308,
        diversity_index_3: -0.67528689,
        composite_ital_3: 1.5269562,
      },
      geometry: { type: "Point", coordinates: [12.32618, 45.44371] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43523,
        lng: 12.339415,
        name: "Ai Specchieri",
        numreviews: 383,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2542204-Reviews-Ai_Specchieri-Venice_Veneto.html",
        percent_ital: 0.42036554,
        diversity_index_2: 0.35994554,
        diversity_index_3: -0.64005446,
        composite_ital_3: 1.8884331,
      },
      geometry: { type: "Point", coordinates: [12.33942, 45.43523] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.440689,
        lng: 12.325006,
        name: "Panini Lampo",
        numreviews: 162,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2546800-Reviews-Panini_Lampo-Venice_Veneto.html",
        percent_ital: 0.67901236,
        diversity_index_2: 0.39259797,
        diversity_index_3: -0.60740203,
        composite_ital_3: 1.3220851,
      },
      geometry: { type: "Point", coordinates: [12.32501, 45.44069] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438477,
        lng: 12.334046,
        name: "Vianello Maddalisa Panificio",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2557292-Reviews-Vianello_Maddalisa_Panificio-Venice_Veneto.html",
        percent_ital: 0.85714287,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.2527629,
      },
      geometry: { type: "Point", coordinates: [12.33405, 45.43848] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.431538,
        lng: 12.320775,
        name: "Osteria Da Toni",
        numreviews: 176,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2557438-Reviews-Osteria_Da_Toni-Venice_Veneto.html",
        percent_ital: 0.26704547,
        diversity_index_2: 0.33548003,
        diversity_index_3: -0.66451997,
        composite_ital_3: 2.4125292,
      },
      geometry: { type: "Point", coordinates: [12.32077, 45.43154] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.437603,
        lng: 12.336732,
        name: "Bar Mister Sandwich",
        numreviews: 108,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2569914-Reviews-Bar_Mister_Sandwich-Venice_Veneto.html",
        percent_ital: 0.31481481,
        diversity_index_2: 0.38350877,
        diversity_index_3: -0.6164912,
        composite_ital_3: 2.1141636,
      },
      geometry: { type: "Point", coordinates: [12.33673, 45.4376] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437778,
        lng: 12.33604,
        name: "Ri.GU sas - Birreria",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2652283-Reviews-Ri_GU_sas_Birreria-Venice_Veneto.html",
        percent_ital: 0.30769232,
        diversity_index_2: 0.38181818,
        diversity_index_3: -0.61818182,
        composite_ital_3: 2.1414657,
      },
      geometry: { type: "Point", coordinates: [12.33604, 45.43778] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437401,
        lng: 12.329574,
        name: "Ristobar San Polo",
        numreviews: 179,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2669060-Reviews-Ristobar_San_Polo-Venice_Veneto.html",
        percent_ital: 0.18435754,
        diversity_index_2: 0.43173981,
        diversity_index_3: -0.56826019,
        composite_ital_3: 2.5308104,
      },
      geometry: { type: "Point", coordinates: [12.32957, 45.4374] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435295,
        lng: 12.339662,
        name: "Ristorante Beppino",
        numreviews: 580,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2707619-Reviews-Ristorante_Beppino-Venice_Veneto.html",
        percent_ital: 0.34310344,
        diversity_index_2: 0.36863577,
        diversity_index_3: -0.63136423,
        composite_ital_3: 2.0676694,
      },
      geometry: { type: "Point", coordinates: [12.33966, 45.4353] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439945,
        lng: 12.325676,
        name: "Al Canton Dei Artisti",
        numreviews: 214,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d2721451-Reviews-Al_Canton_Dei_Artisti-Venice_Veneto.html",
        percent_ital: 0.18224299,
        diversity_index_2: 0.37750384,
        diversity_index_3: -0.62249613,
        composite_ital_3: 2.6765888,
      },
      geometry: { type: "Point", coordinates: [12.32568, 45.43995] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.446777,
        lng: 12.323698,
        name: "Trattoria Alle Due Gondolette",
        numreviews: 176,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3135802-Reviews-Trattoria_Alle_Due_Gondolette-Venice_Veneto.html",
        percent_ital: 0.61931819,
        diversity_index_2: 0.39288849,
        diversity_index_3: -0.60711151,
        composite_ital_3: 1.4133656,
      },
      geometry: { type: "Point", coordinates: [12.3237, 45.44678] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.429028,
        lng: 12.328575,
        name: "Ristorante Terrazza Dei Nobili",
        numreviews: 643,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3135967-Reviews-Ristorante_Terrazza_Dei_Nobili-Venice_Veneto.html",
        percent_ital: 0.19129083,
        diversity_index_2: 0.40979528,
        diversity_index_3: -0.59020472,
        composite_ital_3: 2.5460579,
      },
      geometry: { type: "Point", coordinates: [12.32858, 45.42903] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436436,
        lng: 12.337144,
        name: "Osteria da Luca",
        numreviews: 439,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3155286-Reviews-Osteria_da_Luca-Venice_Veneto.html",
        percent_ital: 0.27790433,
        diversity_index_2: 0.32816783,
        diversity_index_3: -0.6718322,
        composite_ital_3: 2.3947084,
      },
      geometry: { type: "Point", coordinates: [12.33714, 45.43644] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435669,
        lng: 12.33637,
        name: "Birreria Nuova Valigia",
        numreviews: 452,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3155363-Reviews-Birreria_Nuova_Valigia-Venice_Veneto.html",
        percent_ital: 0.15929204,
        diversity_index_2: 0.28548384,
        diversity_index_3: -0.71451616,
        composite_ital_3: 3.0905859,
      },
      geometry: { type: "Point", coordinates: [12.33637, 45.43567] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.441353,
        lng: 12.333967,
        name: "Neapolis Kebab Venice",
        numreviews: 43,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3167484-Reviews-Neapolis_Kebab_Venice-Venice_Veneto.html",
        percent_ital: 0.30232558,
        diversity_index_2: 0.56653225,
        diversity_index_3: -0.43346775,
        composite_ital_3: 1.764472,
      },
      geometry: { type: "Point", coordinates: [12.33397, 45.44135] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43346,
        lng: 12.339772,
        name: "Gran Caffe Chioggia",
        numreviews: 235,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3170586-Reviews-Gran_Caffe_Chioggia-Venice_Veneto.html",
        percent_ital: 0.1319149,
        diversity_index_2: 0.29287237,
        diversity_index_3: -0.70712763,
        composite_ital_3: 3.2536166,
      },
      geometry: { type: "Point", coordinates: [12.33977, 45.43346] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44302,
        lng: 12.332496,
        name: "Pizzeria Trattoria Alle Lanterine",
        numreviews: 25,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3178673-Reviews-Pizzeria_Trattoria_Alle_Lanterine-Venice_Veneto.html",
        percent_ital: 0.12,
        diversity_index_2: 0.45887446,
        diversity_index_3: -0.54112554,
        composite_ital_3: 2.8992422,
      },
      geometry: { type: "Point", coordinates: [12.3325, 45.44302] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43959,
        lng: 12.332777,
        name: "Ristorante Cinese Giardino di Giada Sas",
        numreviews: 378,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3191814-Reviews-Ristorante_Cinese_Giardino_di_Giada_Sas-Venice_Veneto.html",
        percent_ital: 0.4074074,
        diversity_index_2: 0.52849555,
        diversity_index_3: -0.47150445,
        composite_ital_3: 1.5356625,
      },
      geometry: { type: "Point", coordinates: [12.33278, 45.43959] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435223,
        lng: 12.342624,
        name: "Trattoria Pizzeria da Roberto",
        numreviews: 1066,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3196217-Reviews-Trattoria_Pizzeria_da_Roberto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.44095194,
        diversity_index_3: -0.55904806,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34262, 45.43522] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.427559,
        lng: 12.317792,
        name: "Bacaromi",
        numreviews: 676,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3197221-Reviews-Bacaromi-Venice_Veneto.html",
        percent_ital: 0.57248521,
        diversity_index_2: 0.61072505,
        diversity_index_3: -0.38927495,
        composite_ital_3: 1.0508769,
      },
      geometry: { type: "Point", coordinates: [12.31779, 45.42756] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43898,
        lng: 12.332191,
        name: "Trattoria Ai Botteri",
        numreviews: 312,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3206930-Reviews-Trattoria_Ai_Botteri-Venice_Veneto.html",
        percent_ital: 0.30769232,
        diversity_index_2: 0.33254462,
        diversity_index_3: -0.66745538,
        composite_ital_3: 2.2796361,
      },
      geometry: { type: "Point", coordinates: [12.33219, 45.43898] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.430275,
        lng: 12.327057,
        name: "Ristorante San Trovaso",
        numreviews: 860,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3217087-Reviews-Ristorante_San_Trovaso-Venice_Veneto.html",
        percent_ital: 0.38372093,
        diversity_index_2: 0.37227714,
        diversity_index_3: -0.62772286,
        composite_ital_3: 1.9459565,
      },
      geometry: { type: "Point", coordinates: [12.32706, 45.43028] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.430119,
        lng: 12.326151,
        name: "Osteria Al Squero",
        numreviews: 1737,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3226055-Reviews-Osteria_Al_Squero-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.286093,
        diversity_index_3: -0.713907,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32615, 45.43012] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.426121,
        lng: 12.32769,
        name: "Trattoria ai Cacciatori",
        numreviews: 860,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3237385-Reviews-Trattoria_ai_Cacciatori-Venice_Veneto.html",
        percent_ital: 0.36162791,
        diversity_index_2: 0.47548389,
        diversity_index_3: -0.52451611,
        composite_ital_3: 1.7605618,
      },
      geometry: { type: "Point", coordinates: [12.32769, 45.42612] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.439251,
        lng: 12.321149,
        name: "Trattoria Agli Amici",
        numreviews: 207,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3256501-Reviews-Trattoria_Agli_Amici-Venice_Veneto.html",
        percent_ital: 0.14009662,
        diversity_index_2: 0.3705152,
        diversity_index_3: -0.62948477,
        composite_ital_3: 2.9582837,
      },
      geometry: { type: "Point", coordinates: [12.32115, 45.43925] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Italian",
        lat: 45.434139,
        lng: 12.336196,
        name: "Pelletteria Maria",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3293251-Reviews-Pelletteria_Maria-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3362, 45.43414] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435345,
        lng: 12.339405,
        name: "Ristorante Centrale",
        numreviews: 698,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3294421-Reviews-Ristorante_Centrale-Venice_Veneto.html",
        percent_ital: 0.21346705,
        diversity_index_2: 0.3032271,
        diversity_index_3: -0.69677293,
        composite_ital_3: 2.7375462,
      },
      geometry: { type: "Point", coordinates: [12.3394, 45.43534] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436859,
        lng: 12.319442,
        name: "Trattoria alle Burchielle",
        numreviews: 281,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3295077-Reviews-Trattoria_alle_Burchielle-Venice_Veneto.html",
        percent_ital: 0.33096084,
        diversity_index_2: 0.38540795,
        diversity_index_3: -0.61459208,
        composite_ital_3: 2.0592082,
      },
      geometry: { type: "Point", coordinates: [12.31944, 45.43686] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435295,
        lng: 12.346758,
        name: "Buena Onda Olinda S.N.C",
        numreviews: 35,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3349061-Reviews-Buena_Onda_Olinda_S_N_C-Venice_Veneto.html",
        percent_ital: 0.085714288,
        diversity_index_2: 0.39393941,
        diversity_index_3: -0.60606062,
        composite_ital_3: 3.388294,
      },
      geometry: { type: "Point", coordinates: [12.34676, 45.4353] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "Italian",
        lat: 45.438137,
        lng: 12.331943,
        name: "Osteria con Cucina",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3378117-Reviews-Osteria_con_Cucina-Venice_Veneto.html",
        percent_ital: 0.2,
        diversity_index_2: 0.58333331,
        diversity_index_3: -0.41666669,
        composite_ital_3: 2.1484344,
      },
      geometry: { type: "Point", coordinates: [12.33194, 45.43814] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432213,
        lng: 12.353887,
        name: "Le Spighe",
        numreviews: 130,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3399736-Reviews-Le_Spighe-Venice_Veneto.html",
        percent_ital: 0.46923077,
        diversity_index_2: 0.67991716,
        diversity_index_3: -0.32008284,
        composite_ital_3: 1.1424448,
      },
      geometry: { type: "Point", coordinates: [12.35389, 45.43221] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437946,
        lng: 12.336636,
        name: "Osteria all'Alba",
        numreviews: 207,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3431194-Reviews-Osteria_all_Alba-Venice_Veneto.html",
        percent_ital: 0.35265699,
        diversity_index_2: 0.39248204,
        diversity_index_3: -0.60751796,
        composite_ital_3: 1.9775239,
      },
      geometry: { type: "Point", coordinates: [12.33664, 45.43795] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.437061,
        lng: 12.340004,
        name: "Inishark pub",
        numreviews: 117,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3431204-Reviews-Inishark_pub-Venice_Veneto.html",
        percent_ital: 0.20512821,
        diversity_index_2: 0.61175931,
        diversity_index_3: -0.38824069,
        composite_ital_3: 2.0755365,
      },
      geometry: { type: "Point", coordinates: [12.34, 45.43706] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.432678,
        lng: 12.32411,
        name: "Fujiyama Tea Room Beatrice",
        numreviews: 144,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3445594-Reviews-Fujiyama_Tea_Room_Beatrice-Venice_Veneto.html",
        percent_ital: 0.40277779,
        diversity_index_2: 0.4044373,
        diversity_index_3: -0.5955627,
        composite_ital_3: 1.8146288,
      },
      geometry: { type: "Point", coordinates: [12.32411, 45.43268] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437054,
        lng: 12.33707,
        name: "Antico Calice",
        numreviews: 1216,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3448132-Reviews-Antico_Calice-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.27514699,
        diversity_index_3: -0.72485304,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33707, 45.43705] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$",
        lat: 45.43401,
        lng: 12.344864,
        name: "Bar Riviera",
        numreviews: 55,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3456936-Reviews-Bar_Riviera-Venice_Veneto.html",
        percent_ital: 0.45454547,
        diversity_index_2: 0.56451613,
        diversity_index_3: -0.43548387,
        composite_ital_3: 1.3602437,
      },
      geometry: { type: "Point", coordinates: [12.34486, 45.43401] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442291,
        lng: 12.322946,
        name: "Osteria Al Cicheto",
        numreviews: 885,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3512290-Reviews-Osteria_Al_Cicheto-Venice_Veneto.html",
        percent_ital: 0.56497175,
        diversity_index_2: 0.38788116,
        diversity_index_3: -0.61211884,
        composite_ital_3: 1.5180358,
      },
      geometry: { type: "Point", coordinates: [12.32295, 45.44229] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440773,
        lng: 12.334988,
        name: "Bar Santa Sofia",
        numreviews: 81,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3518734-Reviews-Bar_Santa_Sofia-Venice_Veneto.html",
        percent_ital: 0.27160493,
        diversity_index_2: 0.36892655,
        diversity_index_3: -0.63107347,
        composite_ital_3: 2.3005645,
      },
      geometry: { type: "Point", coordinates: [12.33499, 45.44077] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.436024,
        lng: 12.348622,
        name: "Osteria Ai Do Pozzi",
        numreviews: 265,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3539493-Reviews-Osteria_Ai_Do_Pozzi-Venice_Veneto.html",
        percent_ital: 0.47169811,
        diversity_index_2: 0.33024722,
        diversity_index_3: -0.66975278,
        composite_ital_3: 1.8593298,
      },
      geometry: { type: "Point", coordinates: [12.34862, 45.43602] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.432434,
        lng: 12.355596,
        name: "Trattoria Alla Rampa",
        numreviews: 221,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3539496-Reviews-Trattoria_Alla_Rampa-Venice_Veneto.html",
        percent_ital: 0.49773756,
        diversity_index_2: 0.34292036,
        diversity_index_3: -0.65707964,
        composite_ital_3: 1.7679394,
      },
      geometry: { type: "Point", coordinates: [12.3556, 45.43243] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.426476,
        lng: 12.325773,
        name: "Trattoria & Pizzeria Do Mori",
        numreviews: 453,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3544767-Reviews-Trattoria_Pizzeria_Do_Mori-Venice_Veneto.html",
        percent_ital: 0.16114791,
        diversity_index_2: 0.50399196,
        diversity_index_3: -0.49600804,
        composite_ital_3: 2.5106275,
      },
      geometry: { type: "Point", coordinates: [12.32577, 45.42648] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442291,
        lng: 12.326244,
        name: "Ristorante Bar Vittoria",
        numreviews: 169,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3556580-Reviews-Ristorante_Bar_Vittoria-Venice_Veneto.html",
        percent_ital: 0.14201184,
        diversity_index_2: 0.56438357,
        diversity_index_3: -0.43561643,
        composite_ital_3: 2.5238662,
      },
      geometry: { type: "Point", coordinates: [12.32624, 45.44229] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434776,
        lng: 12.322104,
        name: "Osteria Do Torri",
        numreviews: 286,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3566822-Reviews-Osteria_Do_Torri-Venice_Veneto.html",
        percent_ital: 0.24475524,
        diversity_index_2: 0.33564451,
        diversity_index_3: -0.66435552,
        composite_ital_3: 2.4991994,
      },
      geometry: { type: "Point", coordinates: [12.3221, 45.43478] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$",
        lat: 45.440941,
        lng: 12.334807,
        name: "La Tappa Bar",
        numreviews: 68,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3580740-Reviews-La_Tappa_Bar-Venice_Veneto.html",
        percent_ital: 0.55882353,
        diversity_index_2: 0.29677418,
        diversity_index_3: -0.70322585,
        composite_ital_3: 1.7967052,
      },
      geometry: { type: "Point", coordinates: [12.33481, 45.44094] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43261,
        lng: 12.323692,
        name: "L'Osteria San Barnaba Ristorante",
        numreviews: 540,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3600070-Reviews-L_Osteria_San_Barnaba_Ristorante-Venice_Veneto.html",
        percent_ital: 0.28518519,
        diversity_index_2: 0.37969416,
        diversity_index_3: -0.62030584,
        composite_ital_3: 2.2230058,
      },
      geometry: { type: "Point", coordinates: [12.32369, 45.43261] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43536,
        lng: 12.340041,
        name: "Rossopomodoro Venezia",
        numreviews: 1797,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3603071-Reviews-Rossopomodoro_Venezia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.2376982,
        diversity_index_3: -0.7623018,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34004, 45.43536] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436882,
        lng: 12.339743,
        name: "Trattoria Da Gigi",
        numreviews: 648,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3608057-Reviews-Trattoria_Da_Gigi-Venice_Veneto.html",
        percent_ital: 0.33024693,
        diversity_index_2: 0.37375975,
        diversity_index_3: -0.62624025,
        composite_ital_3: 2.0920568,
      },
      geometry: { type: "Point", coordinates: [12.33974, 45.43688] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434849,
        lng: 12.332491,
        name: "Teamo Wine Bar",
        numreviews: 1299,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3628276-Reviews-Teamo_Wine_Bar-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.42379162,
        diversity_index_3: -0.57620835,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33249, 45.43485] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438137,
        lng: 12.331961,
        name: "Al Ponte Storto Osteria con Cucina",
        numreviews: 530,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3631644-Reviews-Al_Ponte_Storto_Osteria_con_Cucina-Venice_Veneto.html",
        percent_ital: 0.48490566,
        diversity_index_2: 0.45275363,
        diversity_index_3: -0.54724634,
        composite_ital_3: 1.5162081,
      },
      geometry: { type: "Point", coordinates: [12.33196, 45.43814] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.437634,
        lng: 12.338241,
        name: "Via Mulino 3",
        numreviews: 78,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3635629-Reviews-Via_Mulino_3-Venice_Veneto.html",
        percent_ital: 0.41025642,
        diversity_index_2: 0.39361703,
        diversity_index_3: -0.60638297,
        composite_ital_3: 1.8233497,
      },
      geometry: { type: "Point", coordinates: [12.33824, 45.43763] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.434971,
        lng: 12.31846,
        name: "Pizza Kebab Sydur Rahman",
        numreviews: 11,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3662994-Reviews-Pizza_Kebab_Sydur_Rahman-Venice_Veneto.html",
        percent_ital: 0.81818181,
        diversity_index_2: 0.60000001999999997,
        diversity_index_3: -0.39999997999999998,
        composite_ital_3: 0.71149629,
      },
      geometry: { type: "Point", coordinates: [12.31846, 45.43497] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435123,
        lng: 12.337792,
        name: "Caffe Venezia",
        numreviews: 76,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3667723-Reviews-Caffe_Venezia-Venice_Veneto.html",
        percent_ital: 0.22368421,
        diversity_index_2: 0.24745762,
        diversity_index_3: -0.75254238,
        composite_ital_3: 2.8940358,
      },
      geometry: { type: "Point", coordinates: [12.33779, 45.43512] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.442303,
        lng: 12.33262,
        name: "Pizzeria Trattoria alle Lanternine",
        numreviews: 612,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3671284-Reviews-Pizzeria_Trattoria_alle_Lanternine-Venice_Veneto.html",
        percent_ital: 0.24019608,
        diversity_index_2: 0.34563446,
        diversity_index_3: -0.65436554,
        composite_ital_3: 2.4886732,
      },
      geometry: { type: "Point", coordinates: [12.33262, 45.4423] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.432266,
        lng: 12.350412,
        name: "Pub Angio Wine Bar",
        numreviews: 141,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3678475-Reviews-Pub_Angio_Wine_Bar-Venice_Veneto.html",
        percent_ital: 0.28368795,
        diversity_index_2: 0.46689963,
        diversity_index_3: -0.53310037,
        composite_ital_3: 2.0215213,
      },
      geometry: { type: "Point", coordinates: [12.35041, 45.43227] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.43372,
        lng: 12.322851,
        name: "Al Bocon Divino",
        numreviews: 193,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3689611-Reviews-Al_Bocon_Divino-Venice_Veneto.html",
        percent_ital: 0.65803111,
        diversity_index_2: 0.30289727,
        diversity_index_3: -0.69710273,
        composite_ital_3: 1.6128646,
      },
      geometry: { type: "Point", coordinates: [12.32285, 45.43372] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.436729,
        lng: 12.328483,
        name: "All'Antico Merca'",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3707844-Reviews-All_Antico_Merca-Venice_Veneto.html",
        percent_ital: 0.80000000999999998,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32848, 45.43673] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437054,
        lng: 12.329844,
        name: "Ristorante Pizzeria Wine Bar Riva del Vin",
        numreviews: 656,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3708108-Reviews-Ristorante_Pizzeria_Wine_Bar_Riva_del_Vin-Venice_Veneto.html",
        percent_ital: 0.21493903,
        diversity_index_2: 0.39416939,
        diversity_index_3: -0.60583061,
        composite_ital_3: 2.4683754,
      },
      geometry: { type: "Point", coordinates: [12.32984, 45.43705] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436005,
        lng: 12.327929,
        name: "Bar Ciak 1",
        numreviews: 105,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3716710-Reviews-Bar_Ciak_1-Venice_Veneto.html",
        percent_ital: 0.27619049,
        diversity_index_2: 0.36763236,
        diversity_index_3: -0.63236761,
        composite_ital_3: 2.2873363,
      },
      geometry: { type: "Point", coordinates: [12.32793, 45.43601] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.436718,
        lng: 12.326577,
        name: "Bar Dogale",
        numreviews: 57,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3723304-Reviews-Bar_Dogale-Venice_Veneto.html",
        percent_ital: 0.19298245,
        diversity_index_2: 0.30249768,
        diversity_index_3: -0.69750232,
        composite_ital_3: 2.8408377,
      },
      geometry: { type: "Point", coordinates: [12.32658, 45.43672] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.442696,
        lng: 12.3315,
        name: "Mq10",
        numreviews: 193,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3724792-Reviews-Mq10-Venice_Veneto.html",
        percent_ital: 0.21761657,
        diversity_index_2: 0.41207737,
        diversity_index_3: -0.58792263,
        composite_ital_3: 2.4115648,
      },
      geometry: { type: "Point", coordinates: [12.3315, 45.4427] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "Mediterranean",
        lat: 45.435295,
        lng: 12.324065,
        name: "Corner Club",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3741243-Reviews-Corner_Club-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32406, 45.4353] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434029,
        lng: 12.335387,
        name: "B Bar Lounge",
        numreviews: 11,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3754624-Reviews-B_Bar_Lounge-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.43636364,
        diversity_index_3: -0.56363636,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33539, 45.43403] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.435349,
        lng: 12.334355,
        name: "Skk",
        numreviews: 98,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3768911-Reviews-Skk-Venice_Veneto.html",
        percent_ital: 0.1632653,
        diversity_index_2: 0.47869527,
        diversity_index_3: -0.52130473,
        composite_ital_3: 2.5490699,
      },
      geometry: { type: "Point", coordinates: [12.33436, 45.43535] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43951,
        lng: 12.333052,
        name: "Osteria Sora al Ponte",
        numreviews: 44,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3812846-Reviews-Osteria_Sora_al_Ponte-Venice_Veneto.html",
        percent_ital: 0.22727273,
        diversity_index_2: 0.37687689,
        diversity_index_3: -0.62312311,
        composite_ital_3: 2.4574411,
      },
      geometry: { type: "Point", coordinates: [12.33305, 45.43951] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.437111,
        lng: 12.337708,
        name: "Ristorante Alle Corone",
        numreviews: 1635,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3830336-Reviews-Ristorante_Alle_Corone-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.35155031,
        diversity_index_3: -0.64844966,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33771, 45.43711] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.440052,
        lng: 12.319698,
        name: "Ristorante La Cupola",
        numreviews: 120,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3830569-Reviews-Ristorante_La_Cupola-Venice_Veneto.html",
        percent_ital: 0.15833333,
        diversity_index_2: 0.30421278,
        diversity_index_3: -0.69578719,
        composite_ital_3: 3.0330806,
      },
      geometry: { type: "Point", coordinates: [12.3197, 45.44005] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$$$",
        lat: 45.440071,
        lng: 12.3197,
        name: "Top of the Carlton Sky Lounge",
        numreviews: 94,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3830627-Reviews-Top_of_the_Carlton_Sky_Lounge-Venice_Veneto.html",
        percent_ital: 0.074468084,
        diversity_index_2: 0.67816091,
        diversity_index_3: -0.32183909,
        composite_ital_3: 2.9857554,
      },
      geometry: { type: "Point", coordinates: [12.3197, 45.44007] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437286,
        lng: 12.3304,
        name: "Trattoria Ai Botteri",
        numreviews: 57,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3831648-Reviews-Trattoria_Ai_Botteri-Venice_Veneto.html",
        percent_ital: 0.14035088,
        diversity_index_2: 0.25224489,
        diversity_index_3: -0.74775511,
        composite_ital_3: 3.3409646,
      },
      geometry: { type: "Point", coordinates: [12.3304, 45.43729] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43502,
        lng: 12.341185,
        name: "Ristorante Cinese Capitol",
        numreviews: 64,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3836164-Reviews-Ristorante_Cinese_Capitol-Venice_Veneto.html",
        percent_ital: 0.09375,
        diversity_index_2: 0.56399769,
        diversity_index_3: -0.43600231,
        composite_ital_3: 2.9398289,
      },
      geometry: { type: "Point", coordinates: [12.34118, 45.43502] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.440277,
        lng: 12.336808,
        name: "Steval Pizza e Kebab",
        numreviews: 27,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3840133-Reviews-Steval_Pizza_e_Kebab-Venice_Veneto.html",
        percent_ital: 0.18518518,
        diversity_index_2: 0.39525691,
        diversity_index_3: -0.60474312,
        composite_ital_3: 2.6146183,
      },
      geometry: { type: "Point", coordinates: [12.33681, 45.44028] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.439018,
        lng: 12.33709,
        name: "Tiziano Snack Bar",
        numreviews: 296,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3840821-Reviews-Tiziano_Snack_Bar-Venice_Veneto.html",
        percent_ital: 0.45945945,
        diversity_index_2: 0.2897017,
        diversity_index_3: -0.7102983,
        composite_ital_3: 2.016608,
      },
      geometry: { type: "Point", coordinates: [12.33709, 45.43902] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437546,
        lng: 12.332755,
        name: "Vineria allâAmarone",
        numreviews: 1423,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3842739-Reviews-Vineria_all_Amarone-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.42329189,
        diversity_index_3: -0.57670808,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33276, 45.43755] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43705,
        lng: 12.337066,
        name: "Antico Calice",
        numreviews: 157,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3844796-Reviews-Antico_Calice-Venice_Veneto.html",
        percent_ital: 0.42038217,
        diversity_index_2: 0.41925466,
        diversity_index_3: -0.58074534,
        composite_ital_3: 1.7358679,
      },
      geometry: { type: "Point", coordinates: [12.33707, 45.43705] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43082,
        lng: 12.357414,
        name: "Antica Osteria da Gino",
        numreviews: 304,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3844822-Reviews-Antica_Osteria_da_Gino-Venice_Veneto.html",
        percent_ital: 0.47697368,
        diversity_index_2: 0.34008127,
        diversity_index_3: -0.65991873,
        composite_ital_3: 1.8188646,
      },
      geometry: { type: "Point", coordinates: [12.35741, 45.43082] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437469,
        lng: 12.338892,
        name: "Snack & Sweet",
        numreviews: 136,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3846805-Reviews-Snack_Sweet-Venice_Veneto.html",
        percent_ital: 0.41176471,
        diversity_index_2: 0.27975315,
        diversity_index_3: -0.72024685,
        composite_ital_3: 2.1611509,
      },
      geometry: { type: "Point", coordinates: [12.33889, 45.43747] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.426964,
        lng: 12.309327,
        name: "Ai Campi Sportivi",
        numreviews: 8,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3849298-Reviews-Ai_Campi_Sportivi-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.30933, 45.42696] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435211,
        lng: 12.336858,
        name: "Ristorante Venezia Felice",
        numreviews: 299,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3898105-Reviews-Ristorante_Venezia_Felice-Venice_Veneto.html",
        percent_ital: 0.15050167,
        diversity_index_2: 0.3666054,
        diversity_index_3: -0.6333946,
        composite_ital_3: 2.8972504,
      },
      geometry: { type: "Point", coordinates: [12.33686, 45.43521] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.436619,
        lng: 12.32,
        name: "Pizzeria Coccinelle",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3941138-Reviews-Pizzeria_Coccinelle-Venice_Veneto.html",
        percent_ital: 0.53846157,
        diversity_index_2: 0.2,
        diversity_index_3: -0.80000000999999998,
        composite_ital_3: 2.228477,
      },
      geometry: { type: "Point", coordinates: [12.32, 45.43662] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.445992,
        lng: 12.326735,
        name: "Dodo Caffe",
        numreviews: 197,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3962359-Reviews-Dodo_Caffe-Venice_Veneto.html",
        percent_ital: 0.17766498,
        diversity_index_2: 0.43315914,
        diversity_index_3: -0.56684089,
        composite_ital_3: 2.5645058,
      },
      geometry: { type: "Point", coordinates: [12.32673, 45.44599] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.440586,
        lng: 12.3364,
        name: "Cannaregio",
        numreviews: 16,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d3964131-Reviews-Cannaregio-Venice_Veneto.html",
        percent_ital: 0.25,
        diversity_index_2: 0.47435898,
        diversity_index_3: -0.52564102,
        composite_ital_3: 2.1320853,
      },
      geometry: { type: "Point", coordinates: [12.3364, 45.44059] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.441444,
        lng: 12.33372,
        name: "L'ingordo",
        numreviews: 19,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4008222-Reviews-L_ingordo-Venice_Veneto.html",
        percent_ital: 0.7368421,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.30538166,
      },
      geometry: { type: "Point", coordinates: [12.33372, 45.44144] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.439095,
        lng: 12.334407,
        name: "Bar Rialto da Lollo",
        numreviews: 206,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4022447-Reviews-Bar_Rialto_da_Lollo-Venice_Veneto.html",
        percent_ital: 0.69417477,
        diversity_index_2: 0.27692309,
        diversity_index_3: -0.72307694,
        composite_ital_3: 1.649047,
      },
      geometry: { type: "Point", coordinates: [12.33441, 45.4391] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.430428,
        lng: 12.32987,
        name: "Ristorante Cantinone Storico",
        numreviews: 796,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4040683-Reviews-Ristorante_Cantinone_Storico-Venice_Veneto.html",
        percent_ital: 0.21984924,
        diversity_index_2: 0.45547554,
        diversity_index_3: -0.54452443,
        composite_ital_3: 2.3012264,
      },
      geometry: { type: "Point", coordinates: [12.32987, 45.43043] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.441181,
        lng: 12.328062,
        name: "Bar Puppa",
        numreviews: 857,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4044077-Reviews-Bar_Puppa-Venice_Veneto.html",
        percent_ital: 0.21236873,
        diversity_index_2: 0.33081046,
        diversity_index_3: -0.66918957,
        composite_ital_3: 2.6556408,
      },
      geometry: { type: "Point", coordinates: [12.32806, 45.44118] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444035,
        lng: 12.326765,
        name: "Pizzeria Vesuvio",
        numreviews: 562,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4047009-Reviews-Pizzeria_Vesuvio-Venice_Veneto.html",
        percent_ital: 0.30960855,
        diversity_index_2: 0.42525706,
        diversity_index_3: -0.57474291,
        composite_ital_3: 2.027508,
      },
      geometry: { type: "Point", coordinates: [12.32676, 45.44403] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443409,
        lng: 12.32501,
        name: "Trattoria Vittoria da Aldo",
        numreviews: 240,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4059211-Reviews-Trattoria_Vittoria_da_Aldo-Venice_Veneto.html",
        percent_ital: 0.36250001,
        diversity_index_2: 0.32779157,
        diversity_index_3: -0.67220843,
        composite_ital_3: 2.1301081,
      },
      geometry: { type: "Point", coordinates: [12.32501, 45.44341] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "Italian",
        lat: 45.434574,
        lng: 12.325892,
        name: "Bi-Locale",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4059881-Reviews-Bi_Locale-Venice_Veneto.html",
        percent_ital: 0.5,
        diversity_index_2: 0.40000001000000002,
        diversity_index_3: -0.60000001999999997,
        composite_ital_3: 1.6094379,
      },
      geometry: { type: "Point", coordinates: [12.32589, 45.43457] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.43285,
        lng: 12.31737,
        name: "Cambusa",
        numreviews: 52,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4061771-Reviews-Cambusa-Venice_Veneto.html",
        percent_ital: 0.75,
        diversity_index_2: 0.25833333,
        diversity_index_3: -0.74166667,
        composite_ital_3: 1.6411866,
      },
      geometry: { type: "Point", coordinates: [12.31737, 45.43285] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.43964,
        lng: 12.329278,
        name: "Osteria Vittoria",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4098060-Reviews-Osteria_Vittoria-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32928, 45.43964] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$",
        lat: 45.444008,
        lng: 12.326428,
        name: "Tappa Obbligatoria",
        numreviews: 67,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4108680-Reviews-Tappa_Obbligatoria-Venice_Veneto.html",
        percent_ital: 0.74626863,
        diversity_index_2: 0.35672516,
        diversity_index_3: -0.64327484,
        composite_ital_3: 1.3234593,
      },
      geometry: { type: "Point", coordinates: [12.32643, 45.44401] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436558,
        lng: 12.337533,
        name: "La Brasiliana SNC",
        numreviews: 62,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4133692-Reviews-La_Brasiliana_SNC-Venice_Veneto.html",
        percent_ital: 0.29032257,
        diversity_index_2: 0.6111111,
        diversity_index_3: -0.3888889,
        composite_ital_3: 1.7292391,
      },
      geometry: { type: "Point", coordinates: [12.33753, 45.43656] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.442844,
        lng: 12.331994,
        name: "Pizza E Poi Snc",
        numreviews: 15,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4136140-Reviews-Pizza_E_Poi_Snc-Venice_Veneto.html",
        percent_ital: 0.26666668,
        diversity_index_2: 0.32051283,
        diversity_index_3: -0.67948717,
        composite_ital_3: 2.4595888,
      },
      geometry: { type: "Point", coordinates: [12.33199, 45.44284] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.43996,
        lng: 12.327188,
        name: "Osteria da Filo",
        numreviews: 138,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4139331-Reviews-Osteria_da_Filo-Venice_Veneto.html",
        percent_ital: 0.63768119,
        diversity_index_2: 0.77803922,
        diversity_index_3: -0.22196078,
        composite_ital_3: 0.70089519,
      },
      geometry: { type: "Point", coordinates: [12.32719, 45.43996] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.439831,
        lng: 12.339167,
        name: "Caffe Molinari",
        numreviews: 54,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4148755-Reviews-Caffe_Molinari-Venice_Veneto.html",
        percent_ital: 0.037037037,
        diversity_index_2: 0.4927431,
        diversity_index_3: -0.50725687,
        composite_ital_3: 4.0036044,
      },
      geometry: { type: "Point", coordinates: [12.33917, 45.43983] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433937,
        lng: 12.346324,
        name: "Osteria Al Schiavoni",
        numreviews: 155,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4148888-Reviews-Osteria_Al_Schiavoni-Venice_Veneto.html",
        percent_ital: 0.30322582,
        diversity_index_2: 0.41317764,
        diversity_index_3: -0.58682239,
        composite_ital_3: 2.0771551,
      },
      geometry: { type: "Point", coordinates: [12.34632, 45.43394] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444771,
        lng: 12.322553,
        name: "Bar al parlamento",
        numreviews: 518,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4154838-Reviews-Bar_al_parlamento-Venice_Veneto.html",
        percent_ital: 0.23359074,
        diversity_index_2: 0.40315789,
        diversity_index_3: -0.59684211,
        composite_ital_3: 2.3626118,
      },
      geometry: { type: "Point", coordinates: [12.32255, 45.44477] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.443592,
        lng: 12.330111,
        name: "Serenissima Pizzeria",
        numreviews: 195,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4168509-Reviews-Serenissima_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.18461539,
        diversity_index_2: 0.38333333,
        diversity_index_3: -0.61666667,
        composite_ital_3: 2.6483309,
      },
      geometry: { type: "Point", coordinates: [12.33011, 45.44359] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: null,
        lat: 45.43187,
        lng: 12.351375,
        name: "Melgrano Bar",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4215643-Reviews-Melgrano_Bar-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41666666,
        diversity_index_3: -0.58333337,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.35138, 45.43187] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.433514,
        lng: 12.317167,
        name: "Pizzeria Geko",
        numreviews: 64,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4221808-Reviews-Pizzeria_Geko-Venice_Veneto.html",
        percent_ital: 0.59375,
        diversity_index_2: 0.46723646,
        diversity_index_3: -0.53276354,
        composite_ital_3: 1.2822167,
      },
      geometry: { type: "Point", coordinates: [12.31717, 45.43351] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.431648,
        lng: 12.326572,
        name: "Bar ae Maravegie",
        numreviews: 120,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4234644-Reviews-Bar_ae_Maravegie-Venice_Veneto.html",
        percent_ital: 0.30000000999999998,
        diversity_index_2: 0.42829132,
        diversity_index_3: -0.57170868,
        composite_ital_3: 2.0519245,
      },
      geometry: { type: "Point", coordinates: [12.32657, 45.43165] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438187,
        lng: 12.333369,
        name: "Bacaro al Ravano",
        numreviews: 380,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4242498-Reviews-Bacaro_al_Ravano-Venice_Veneto.html",
        percent_ital: 0.45789474,
        diversity_index_2: 0.35660535,
        diversity_index_3: -0.64339465,
        composite_ital_3: 1.8122416,
      },
      geometry: { type: "Point", coordinates: [12.33337, 45.43819] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434444,
        lng: 12.336944,
        name: "Al Teatro Coldoni",
        numreviews: 26,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4260355-Reviews-Al_Teatro_Coldoni-Venice_Veneto.html",
        percent_ital: 0.11538462,
        diversity_index_2: 0.24110672,
        diversity_index_3: -0.75889325,
        composite_ital_3: 3.5819998,
      },
      geometry: { type: "Point", coordinates: [12.33694, 45.43444] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436646,
        lng: 12.32285,
        name: "Al 133",
        numreviews: 144,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4282164-Reviews-Al_133-Venice_Veneto.html",
        percent_ital: 0.27083334,
        diversity_index_2: 0.42713386,
        diversity_index_3: -0.57286614,
        composite_ital_3: 2.1569095,
      },
      geometry: { type: "Point", coordinates: [12.32285, 45.43665] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.435081,
        lng: 12.321698,
        name: "Do Draghi",
        numreviews: 192,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4284108-Reviews-Do_Draghi-Venice_Veneto.html",
        percent_ital: 0.55729169,
        diversity_index_2: 0.53214777,
        diversity_index_3: -0.46785223,
        composite_ital_3: 1.2155005,
      },
      geometry: { type: "Point", coordinates: [12.3217, 45.43508] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.425549,
        lng: 12.331119,
        name: "Al Pontil Dea Giudecca",
        numreviews: 71,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4290090-Reviews-Al_Pontil_Dea_Giudecca-Venice_Veneto.html",
        percent_ital: 0.53521127,
        diversity_index_2: 0.36666667,
        diversity_index_3: -0.63333333,
        composite_ital_3: 1.6283958,
      },
      geometry: { type: "Point", coordinates: [12.33112, 45.42555] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.437153,
        lng: 12.321109,
        name: "bArCollo",
        numreviews: 177,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4297795-Reviews-BArCollo-Venice_Veneto.html",
        percent_ital: 0.20903955,
        diversity_index_2: 0.3775076,
        diversity_index_3: -0.62249243,
        composite_ital_3: 2.5393965,
      },
      geometry: { type: "Point", coordinates: [12.32111, 45.43715] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435085,
        lng: 12.333201,
        name: "Movie Bistro",
        numreviews: 39,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4298844-Reviews-Movie_Bistro-Venice_Veneto.html",
        percent_ital: 0.35897437,
        diversity_index_2: 0.27384615,
        diversity_index_3: -0.72615385,
        composite_ital_3: 2.3196931,
      },
      geometry: { type: "Point", coordinates: [12.3332, 45.43509] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435726,
        lng: 12.336028,
        name: "Bar e Restaurante Casanova",
        numreviews: 132,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4304660-Reviews-Bar_e_Restaurante_Casanova-Venice_Veneto.html",
        percent_ital: 0.090909094,
        diversity_index_2: 0.29738292,
        diversity_index_3: -0.70261705,
        composite_ital_3: 3.61063,
      },
      geometry: { type: "Point", coordinates: [12.33603, 45.43573] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.432331,
        lng: 12.336944,
        name: "Grand Canal Restaurant",
        numreviews: 187,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4326729-Reviews-Grand_Canal_Restaurant-Venice_Veneto.html",
        percent_ital: 0.080213904,
        diversity_index_2: 0.40947446,
        diversity_index_3: -0.59052551,
        composite_ital_3: 3.4159391,
      },
      geometry: { type: "Point", coordinates: [12.33694, 45.43233] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436447,
        lng: 12.339624,
        name: "A Le Bande",
        numreviews: 288,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4328448-Reviews-A_Le_Bande-Venice_Veneto.html",
        percent_ital: 0.30208334,
        diversity_index_2: 0.34390089,
        diversity_index_3: -0.65609908,
        composite_ital_3: 2.2644541,
      },
      geometry: { type: "Point", coordinates: [12.33962, 45.43645] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437927,
        lng: 12.327058,
        name: "Il vizietto",
        numreviews: 90,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4363319-Reviews-Il_vizietto-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.42693603,
        diversity_index_3: -0.57306397,
        composite_ital_3: 1.7674118,
      },
      geometry: { type: "Point", coordinates: [12.32706, 45.43793] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43668,
        lng: 12.339968,
        name: "Ristorante Cometa",
        numreviews: 101,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4366301-Reviews-Ristorante_Cometa-Venice_Veneto.html",
        percent_ital: 0.25742576,
        diversity_index_2: 0.30631578,
        diversity_index_3: -0.69368422,
        composite_ital_3: 2.5401628,
      },
      geometry: { type: "Point", coordinates: [12.33997, 45.43668] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.442879,
        lng: 12.340874,
        name: "Pizzeria Bar Al Cupido",
        numreviews: 123,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4371845-Reviews-Pizzeria_Bar_Al_Cupido-Venice_Veneto.html",
        percent_ital: 0.30081302,
        diversity_index_2: 0.36246994,
        diversity_index_3: -0.63753009,
        composite_ital_3: 2.2160802,
      },
      geometry: { type: "Point", coordinates: [12.34087, 45.44288] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436638,
        lng: 12.320011,
        name: "Ristorante Pizzeria Rio Novo",
        numreviews: 742,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4401469-Reviews-Ristorante_Pizzeria_Rio_Novo-Venice_Veneto.html",
        percent_ital: 0.23584905,
        diversity_index_2: 0.54027528,
        diversity_index_3: -0.45972472,
        composite_ital_3: 2.0602398,
      },
      geometry: { type: "Point", coordinates: [12.32001, 45.43664] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436939,
        lng: 12.346926,
        name: "Bar al Canton",
        numreviews: 57,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4404604-Reviews-Bar_al_Canton-Venice_Veneto.html",
        percent_ital: 0.3508772,
        diversity_index_2: 0.34743589,
        diversity_index_3: -0.65256411,
        composite_ital_3: 2.1044941,
      },
      geometry: { type: "Point", coordinates: [12.34693, 45.43694] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.425808,
        lng: 12.335685,
        name: "Bar 93 in Riva",
        numreviews: 49,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4411651-Reviews-Bar_93_in_Riva-Venice_Veneto.html",
        percent_ital: 0.081632651,
        diversity_index_2: 0.39500463,
        diversity_index_3: -0.60499537,
        composite_ital_3: 3.4343839,
      },
      geometry: { type: "Point", coordinates: [12.33568, 45.42581] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440178,
        lng: 12.330564,
        name: "I Rusteghi Osteria Enoteca",
        numreviews: 407,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4412529-Reviews-I_Rusteghi_Osteria_Enoteca-Venice_Veneto.html",
        percent_ital: 0.55528253,
        diversity_index_2: 0.46804467,
        diversity_index_3: -0.53195536,
        composite_ital_3: 1.3474698,
      },
      geometry: { type: "Point", coordinates: [12.33056, 45.44018] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433868,
        lng: 12.321478,
        name: "Dallo Zio",
        numreviews: 299,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4419336-Reviews-Dallo_Zio-Venice_Veneto.html",
        percent_ital: 0.14381272,
        diversity_index_2: 0.38286129,
        diversity_index_3: -0.61713874,
        composite_ital_3: 2.8993261,
      },
      geometry: { type: "Point", coordinates: [12.32148, 45.43387] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.435017,
        lng: 12.341668,
        name: "Magna Bevi Tasi",
        numreviews: 439,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4427190-Reviews-Magna_Bevi_Tasi-Venice_Veneto.html",
        percent_ital: 0.48519361,
        diversity_index_2: 0.36741635,
        diversity_index_3: -0.63258362,
        composite_ital_3: 1.7244669,
      },
      geometry: { type: "Point", coordinates: [12.34167, 45.43502] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.432549,
        lng: 12.355194,
        name: "Bar Mio",
        numreviews: 55,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4444589-Reviews-Bar_Mio-Venice_Veneto.html",
        percent_ital: 0.34545454,
        diversity_index_2: 0.43693694,
        diversity_index_3: -0.56306303,
        composite_ital_3: 1.8908607,
      },
      geometry: { type: "Point", coordinates: [12.35519, 45.43255] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.446465,
        lng: 12.328397,
        name: "Quaranta Ladroni",
        numreviews: 68,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4450752-Reviews-Quaranta_Ladroni-Venice_Veneto.html",
        percent_ital: 0.75,
        diversity_index_2: 0.40935671,
        diversity_index_3: -0.59064329,
        composite_ital_3: 1.1808504,
      },
      geometry: { type: "Point", coordinates: [12.3284, 45.44647] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434711,
        lng: 12.347768,
        name: "CoVino",
        numreviews: 719,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4455527-Reviews-CoVino-Venice_Veneto.html",
        percent_ital: 0.25730181,
        diversity_index_2: 0.59252405,
        diversity_index_3: -0.40747595,
        composite_ital_3: 1.8808694,
      },
      geometry: { type: "Point", coordinates: [12.34777, 45.43471] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44133,
        lng: 12.336821,
        name: 'Trattoria Pizzeria "',
        numreviews: 73,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4458216-Reviews-Trattoria_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.1780822,
        diversity_index_2: 0.5065574,
        diversity_index_3: -0.4934426,
        composite_ital_3: 2.4056277,
      },
      geometry: { type: "Point", coordinates: [12.33682, 45.44133] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432186,
        lng: 12.330971,
        name: "Ristorante degli Artisti",
        numreviews: 20,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4462966-Reviews-Ristorante_degli_Artisti-Venice_Veneto.html",
        percent_ital: 0.69999999000000002,
        diversity_index_2: 0.41666666,
        diversity_index_3: -0.58333337,
        composite_ital_3: 1.2321438,
      },
      geometry: { type: "Point", coordinates: [12.33097, 45.43219] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.435699,
        lng: 12.335114,
        name: "BlackJack",
        numreviews: 213,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4473320-Reviews-BlackJack-Venice_Veneto.html",
        percent_ital: 0.22065727,
        diversity_index_2: 0.55594832,
        diversity_index_3: -0.44405168,
        composite_ital_3: 2.0982244,
      },
      geometry: { type: "Point", coordinates: [12.33511, 45.4357] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43895,
        lng: 12.34179,
        name: "Osteria Da Nico",
        numreviews: 301,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4495484-Reviews-Osteria_Da_Nico-Venice_Veneto.html",
        percent_ital: 0.096345514,
        diversity_index_2: 0.37165228,
        diversity_index_3: -0.62834775,
        composite_ital_3: 3.3296111,
      },
      geometry: { type: "Point", coordinates: [12.34179, 45.43895] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: null,
        lat: 45.433056,
        lng: 12.335503,
        name: "Snack GI. Bar",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4501857-Reviews-Snack_GI_Bar-Venice_Veneto.html",
        percent_ital: 0.2857143,
        diversity_index_2: 0.2,
        diversity_index_3: -0.80000000999999998,
        composite_ital_3: 2.8622007,
      },
      geometry: { type: "Point", coordinates: [12.3355, 45.43306] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442177,
        lng: 12.334539,
        name: "Osteria Antica Adelaide",
        numreviews: 673,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4507218-Reviews-Osteria_Antica_Adelaide-Venice_Veneto.html",
        percent_ital: 0.57503712,
        diversity_index_2: 0.43613669,
        diversity_index_3: -0.56386328,
        composite_ital_3: 1.3831202,
      },
      geometry: { type: "Point", coordinates: [12.33454, 45.44218] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.437157,
        lng: 12.340601,
        name: "Bar Gelateria Zanzibar",
        numreviews: 62,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4551762-Reviews-Bar_Gelateria_Zanzibar-Venice_Veneto.html",
        percent_ital: 0.37096775,
        diversity_index_2: 0.21794872,
        diversity_index_3: -0.78205127,
        composite_ital_3: 2.5151358,
      },
      geometry: { type: "Point", coordinates: [12.3406, 45.43716] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440151,
        lng: 12.321857,
        name: "Trattoria Vinatier",
        numreviews: 32,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4552947-Reviews-Trattoria_Vinatier-Venice_Veneto.html",
        percent_ital: 0.46875,
        diversity_index_2: 0.28104576,
        diversity_index_3: -0.71895421,
        composite_ital_3: 2.0269234,
      },
      geometry: { type: "Point", coordinates: [12.32186, 45.44015] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.430359,
        lng: 12.33137,
        name: "Museum Cafe. Penny Guggenheim Collection",
        numreviews: 197,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4554226-Reviews-Museum_Cafe_Penny_Guggenheim_Collection-Venice_Veneto.html",
        percent_ital: 0.24365482,
        diversity_index_2: 0.46800894,
        diversity_index_3: -0.53199106,
        composite_ital_3: 2.1712706,
      },
      geometry: { type: "Point", coordinates: [12.33137, 45.43036] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.436069,
        lng: 12.339156,
        name: "Trattoria e pizzeria lanternina Venezia",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4561251-Reviews-Trattoria_e_pizzeria_lanternina_Venezia-Venice_Veneto.html",
        percent_ital: 0.53846157,
        diversity_index_2: 0.75,
        diversity_index_3: -0.25,
        composite_ital_3: 0.90672123,
      },
      geometry: { type: "Point", coordinates: [12.33916, 45.43607] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.432037,
        lng: 12.32576,
        name: "Pizza Kebab Toletta(halal)",
        numreviews: 44,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4563637-Reviews-Pizza_Kebab_Toletta_halal-Venice_Veneto.html",
        percent_ital: 0.29545453,
        diversity_index_2: 0.42803031,
        diversity_index_3: -0.57196969,
        composite_ital_3: 2.0678015,
      },
      geometry: { type: "Point", coordinates: [12.32576, 45.43204] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435673,
        lng: 12.322914,
        name: "El Sbarlefo San Pantalon",
        numreviews: 197,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4570794-Reviews-El_Sbarlefo_San_Pantalon-Venice_Veneto.html",
        percent_ital: 0.49238577,
        diversity_index_2: 0.3308911,
        diversity_index_3: -0.66910887,
        composite_ital_3: 1.8144587,
      },
      geometry: { type: "Point", coordinates: [12.32291, 45.43567] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.440266,
        lng: 12.336841,
        name: "Osteria dal Riccio Peoco",
        numreviews: 498,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4593761-Reviews-Osteria_dal_Riccio_Peoco-Venice_Veneto.html",
        percent_ital: 0.66867471,
        diversity_index_2: 0.39326167,
        diversity_index_3: -0.60673833,
        composite_ital_3: 1.3357377,
      },
      geometry: { type: "Point", coordinates: [12.33684, 45.44027] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437271,
        lng: 12.327278,
        name: "Bar L'Archivio",
        numreviews: 104,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4684635-Reviews-Bar_L_Archivio-Venice_Veneto.html",
        percent_ital: 0.40384614,
        diversity_index_2: 0.39272913,
        diversity_index_3: -0.60727084,
        composite_ital_3: 1.8413564,
      },
      geometry: { type: "Point", coordinates: [12.32728, 45.43727] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.439613,
        lng: 12.340833,
        name: "MarMi's Cafe",
        numreviews: 28,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4714989-Reviews-MarMi_s_Cafe-Venice_Veneto.html",
        percent_ital: 0.25,
        diversity_index_2: 0.32380953,
        diversity_index_3: -0.6761905,
        composite_ital_3: 2.5138941,
      },
      geometry: { type: "Point", coordinates: [12.34083, 45.43961] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$",
        lat: 45.433868,
        lng: 12.323545,
        name: "Listino. Prezzi bar pizzeria",
        numreviews: 27,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4748929-Reviews-Listino_Prezzi_bar_pizzeria-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.43874645,
        diversity_index_3: -0.56125355,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32354, 45.43387] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.430477,
        lng: 12.322737,
        name: "Oke",
        numreviews: 1367,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4758750-Reviews-Oke-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.36546373,
        diversity_index_3: -0.63453627,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32274, 45.43048] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.433384,
        lng: 12.328068,
        name: "Palazzo Grassi Cafe",
        numreviews: 30,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4758942-Reviews-Palazzo_Grassi_Cafe-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.30476192,
        diversity_index_3: -0.69523811,
        composite_ital_3: 2.2868366,
      },
      geometry: { type: "Point", coordinates: [12.32807, 45.43338] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43438,
        lng: 12.325857,
        name: "Hostaria Osottoosopra",
        numreviews: 1311,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4759512-Reviews-Hostaria_Osottoosopra-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.32547536,
        diversity_index_3: -0.67452466,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32586, 45.43438] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.427029,
        lng: 12.3603,
        name: "Vincent Bar SNC",
        numreviews: 40,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4765359-Reviews-Vincent_Bar_SNC-Venice_Veneto.html",
        percent_ital: 0.125,
        diversity_index_2: 0.32582584,
        diversity_index_3: -0.67417419,
        composite_ital_3: 3.2008338,
      },
      geometry: { type: "Point", coordinates: [12.3603, 45.42703] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.437794,
        lng: 12.337207,
        name: "Ristorante San Bartolomeo",
        numreviews: 407,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4795194-Reviews-Ristorante_San_Bartolomeo-Venice_Veneto.html",
        percent_ital: 0.68796068,
        diversity_index_2: 0.2456768,
        diversity_index_3: -0.75432318,
        composite_ital_3: 1.7777621,
      },
      geometry: { type: "Point", coordinates: [12.33721, 45.43779] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: null,
        lat: 45.439243,
        lng: 12.333934,
        name: "Oro Argento Pietre Dure",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4802848-Reviews-Oro_Argento_Pietre_Dure-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33393, 45.43924] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "Italian",
        lat: 45.437313,
        lng: 12.319622,
        name: "Da Giosia chiosco bar",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4823837-Reviews-Da_Giosia_chiosco_bar-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.39285713,
        diversity_index_3: -0.60714287,
        composite_ital_3: 2.0329216,
      },
      geometry: { type: "Point", coordinates: [12.31962, 45.43731] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445572,
        lng: 12.327067,
        name: "Kosher Garden Bar",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4884776-Reviews-Kosher_Garden_Bar-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.1,
        diversity_index_3: -0.89999998000000003,
        composite_ital_3: 3.4011974,
      },
      geometry: { type: "Point", coordinates: [12.32707, 45.44557] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.434315,
        lng: 12.323534,
        name: "DG snack bar",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4886182-Reviews-DG_snack_bar-Venice_Veneto.html",
        percent_ital: 0.2857143,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 1.2527629,
      },
      geometry: { type: "Point", coordinates: [12.32353, 45.43431] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43824,
        lng: 12.318116,
        name: "Bar Restaurant Autorimessa",
        numreviews: 165,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4889987-Reviews-Bar_Restaurant_Autorimessa-Venice_Veneto.html",
        percent_ital: 0.46666667,
        diversity_index_2: 0.41853932,
        diversity_index_3: -0.58146071,
        composite_ital_3: 1.6331246,
      },
      geometry: { type: "Point", coordinates: [12.31812, 45.43824] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436226,
        lng: 12.339215,
        name: "Barba Nera",
        numreviews: 17,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4914953-Reviews-Barba_Nera-Venice_Veneto.html",
        percent_ital: 0.35294119,
        diversity_index_2: 0.36363637,
        diversity_index_3: -0.63636363,
        composite_ital_3: 2.0530548,
      },
      geometry: { type: "Point", coordinates: [12.33921, 45.43623] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.439827,
        lng: 12.338573,
        name: "Milan Bar",
        numreviews: 56,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4923050-Reviews-Milan_Bar-Venice_Veneto.html",
        percent_ital: 0.23214285,
        diversity_index_2: 0.44714588,
        diversity_index_3: -0.55285412,
        composite_ital_3: 2.2652729,
      },
      geometry: { type: "Point", coordinates: [12.33857, 45.43983] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.434776,
        lng: 12.349661,
        name: "Bar Arsenale",
        numreviews: 75,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4930770-Reviews-Bar_Arsenale-Venice_Veneto.html",
        percent_ital: 0.46666667,
        diversity_index_2: 0.38780487,
        diversity_index_3: -0.61219513,
        composite_ital_3: 1.709393,
      },
      geometry: { type: "Point", coordinates: [12.34966, 45.43478] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.44376,
        lng: 12.330828,
        name: "Maddelena",
        numreviews: 160,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d4945172-Reviews-Maddelena-Venice_Veneto.html",
        percent_ital: 0.125,
        diversity_index_2: 0.40618035,
        diversity_index_3: -0.59381962,
        composite_ital_3: 2.9803996,
      },
      geometry: { type: "Point", coordinates: [12.33083, 45.44376] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438004,
        lng: 12.33741,
        name: "Bacarando in Corte dell'Orso",
        numreviews: 67,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5234072-Reviews-Bacarando_in_Corte_dell_Orso-Venice_Veneto.html",
        percent_ital: 0.49253732,
        diversity_index_2: 0.4302521,
        diversity_index_3: -0.56974792,
        composite_ital_3: 1.551569,
      },
      geometry: { type: "Point", coordinates: [12.33741, 45.438] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.434902,
        lng: 12.342621,
        name: "Al Vecio Calice",
        numreviews: 199,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5263610-Reviews-Al_Vecio_Calice-Venice_Veneto.html",
        percent_ital: 0.22110553,
        diversity_index_2: 0.41455749,
        diversity_index_3: -0.58544254,
        composite_ital_3: 2.3896587,
      },
      geometry: { type: "Point", coordinates: [12.34262, 45.4349] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Pizza",
        lat: 45.436749,
        lng: 12.325344,
        name: "Cai Diohau",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5267749-Reviews-Cai_Diohau-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.26666668,
        diversity_index_3: -0.73333335,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32534, 45.43675] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.432175,
        lng: 12.35127,
        name: "Snack Bar Castello",
        numreviews: 293,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5292769-Reviews-Snack_Bar_Castello-Venice_Veneto.html",
        percent_ital: 0.10238907,
        diversity_index_2: 0.32624358,
        diversity_index_3: -0.67375642,
        composite_ital_3: 3.3990862,
      },
      geometry: { type: "Point", coordinates: [12.35127, 45.43218] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440342,
        lng: 12.336757,
        name: "Sberlefo",
        numreviews: 20,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5430189-Reviews-Sberlefo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.2,
        diversity_index_3: -0.80000000999999998,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33676, 45.44034] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.43663,
        lng: 12.339505,
        name: "Bar Lucano",
        numreviews: 48,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5449635-Reviews-Bar_Lucano-Venice_Veneto.html",
        percent_ital: 0.25,
        diversity_index_2: 0.3003003,
        diversity_index_3: -0.6996997,
        composite_ital_3: 2.5892668,
      },
      geometry: { type: "Point", coordinates: [12.33951, 45.43663] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.433987,
        lng: 12.323051,
        name: "Orient Experience II",
        numreviews: 189,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5500831-Reviews-Orient_Experience_II-Venice_Veneto.html",
        percent_ital: 0.73015875,
        diversity_index_2: 0.34615386,
        diversity_index_3: -0.65384614,
        composite_ital_3: 1.3753653,
      },
      geometry: { type: "Point", coordinates: [12.32305, 45.43399] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: null,
        lat: 45.440559,
        lng: 12.327384,
        name: "Bar Al Tronchetto",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5533435-Reviews-Bar_Al_Tronchetto-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32738, 45.44056] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.437595,
        lng: 12.336756,
        name: "Al Ponte Di Rialto",
        numreviews: 162,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5539386-Reviews-Al_Ponte_Di_Rialto-Venice_Veneto.html",
        percent_ital: 0.22839506,
        diversity_index_2: 0.22755556,
        diversity_index_3: -0.77244443,
        composite_ital_3: 2.9570394,
      },
      geometry: { type: "Point", coordinates: [12.33676, 45.4376] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.445705,
        lng: 12.328044,
        name: "TRATTORIA ANTICA MOLA",
        numreviews: 106,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5561820-Reviews-TRATTORIA_ANTICA_MOLA-Venice_Veneto.html",
        percent_ital: 0.44339624,
        diversity_index_2: 0.38531074,
        diversity_index_3: -0.61468923,
        composite_ital_3: 1.7669966,
      },
      geometry: { type: "Point", coordinates: [12.32804, 45.4457] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.441551,
        lng: 12.324462,
        name: "Bar- Pizzeria-Trattoria ai bari",
        numreviews: 297,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5770282-Reviews-Bar_Pizzeria_Trattoria_ai_bari-Venice_Veneto.html",
        percent_ital: 0.28619528,
        diversity_index_2: 0.27515247,
        diversity_index_3: -0.72484756,
        composite_ital_3: 2.5415108,
      },
      geometry: { type: "Point", coordinates: [12.32446, 45.44155] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.441261,
        lng: 12.337389,
        name: "Pizzeria La Perla",
        numreviews: 147,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5813987-Reviews-Pizzeria_La_Perla-Venice_Veneto.html",
        percent_ital: 0.27891156,
        diversity_index_2: 0.26027155,
        diversity_index_3: -0.73972845,
        composite_ital_3: 2.6228902,
      },
      geometry: { type: "Point", coordinates: [12.33739, 45.44126] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.44389,
        lng: 12.327476,
        name: "L' Angolo Della Pizza",
        numreviews: 65,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5858739-Reviews-L_Angolo_Della_Pizza-Venice_Veneto.html",
        percent_ital: 0.2923077,
        diversity_index_2: 0.32192415,
        diversity_index_3: -0.67807585,
        composite_ital_3: 2.3633876,
      },
      geometry: { type: "Point", coordinates: [12.32748, 45.44389] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.431152,
        lng: 12.326501,
        name: "El Borrachero",
        numreviews: 18,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5859841-Reviews-El_Borrachero-Venice_Veneto.html",
        percent_ital: 0.5,
        diversity_index_2: 0.31818181,
        diversity_index_3: -0.68181819,
        composite_ital_3: 1.8382795,
      },
      geometry: { type: "Point", coordinates: [12.3265, 45.43115] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.434795,
        lng: 12.347963,
        name: "Corte Sconta",
        numreviews: 69,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5878050-Reviews-Corte_Sconta-Venice_Veneto.html",
        percent_ital: 0.23188406,
        diversity_index_2: 0.42837176,
        diversity_index_3: -0.57162821,
        composite_ital_3: 2.3092816,
      },
      geometry: { type: "Point", coordinates: [12.34796, 45.4348] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43335,
        lng: 12.353986,
        name: "Osteria alla Tana",
        numreviews: 62,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5960652-Reviews-Osteria_alla_Tana-Venice_Veneto.html",
        percent_ital: 0.45161289,
        diversity_index_2: 0.34285715,
        diversity_index_3: -0.65714288,
        composite_ital_3: 1.8653712,
      },
      geometry: { type: "Point", coordinates: [12.35399, 45.43335] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "Italian",
        lat: 45.438381,
        lng: 12.339603,
        name: "Ristorante Sappori Venexia",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5964578-Reviews-Ristorante_Sappori_Venexia-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3396, 45.43838] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437237,
        lng: 12.318753,
        name: "Ristorantino Le Bistrot",
        numreviews: 23,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5967634-Reviews-Ristorantino_Le_Bistrot-Venice_Veneto.html",
        percent_ital: 0.56521738,
        diversity_index_2: 0.27272728,
        diversity_index_3: -0.72727275,
        composite_ital_3: 1.8698279,
      },
      geometry: { type: "Point", coordinates: [12.31875, 45.43724] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441811,
        lng: 12.322221,
        name: "Trattoria alle lance",
        numreviews: 471,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5971496-Reviews-Trattoria_alle_lance-Venice_Veneto.html",
        percent_ital: 0.49469215,
        diversity_index_2: 0.22255927,
        diversity_index_3: -0.77744073,
        composite_ital_3: 2.2063816,
      },
      geometry: { type: "Point", coordinates: [12.32222, 45.44181] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.435619,
        lng: 12.32619,
        name: "Bar Ca' Foscari",
        numreviews: 20,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d5978948-Reviews-Bar_Ca_Foscari-Venice_Veneto.html",
        percent_ital: 0.44999999000000002,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.89712,
      },
      geometry: { type: "Point", coordinates: [12.32619, 45.43562] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438793,
        lng: 12.342372,
        name: "Spaghetteria 6342 A Le Tole Pizzeria",
        numreviews: 2535,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6000264-Reviews-Spaghetteria_6342_A_Le_Tole_Pizzeria-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.29752412,
        diversity_index_3: -0.70247591,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34237, 45.43879] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440922,
        lng: 12.32835,
        name: "Lazzarin Giuliano & Giovanni S.N.C",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6214140-Reviews-Lazzarin_Giuliano_Giovanni_S_N_C-Venice_Veneto.html",
        percent_ital: 0.2857143,
        diversity_index_2: 0.26666668,
        diversity_index_3: -0.73333335,
        composite_ital_3: 2.5745187,
      },
      geometry: { type: "Point", coordinates: [12.32835, 45.44092] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.435089,
        lng: 12.327201,
        name: "Ristorante Terrazza",
        numreviews: 12,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6216753-Reviews-Ristorante_Terrazza-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.54545456,
        diversity_index_3: -0.45454544,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3272, 45.43509] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444706,
        lng: 12.331541,
        name: "Ristorante Tintoretto",
        numreviews: 649,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6280706-Reviews-Ristorante_Tintoretto-Venice_Veneto.html",
        percent_ital: 0.23574731,
        diversity_index_2: 0.42312789,
        diversity_index_3: -0.57687211,
        composite_ital_3: 2.3050756,
      },
      geometry: { type: "Point", coordinates: [12.33154, 45.44471] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.43927,
        lng: 12.321175,
        name: "Bar Duo Rote",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6294154-Reviews-Bar_Duo_Rote-Venice_Veneto.html",
        percent_ital: 0.44444445,
        diversity_index_2: 0.19047619,
        diversity_index_3: -0.80952382,
        composite_ital_3: 2.4691582,
      },
      geometry: { type: "Point", coordinates: [12.32118, 45.43927] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.436474,
        lng: 12.342095,
        name: "Trattoria Agli Artisti Pizzeria",
        numreviews: 554,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6371611-Reviews-Trattoria_Agli_Artisti_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.29061371,
        diversity_index_2: 0.41318807,
        diversity_index_3: -0.5868119,
        composite_ital_3: 2.1196127,
      },
      geometry: { type: "Point", coordinates: [12.3421, 45.43647] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.440353,
        lng: 12.328043,
        name: "Majer- S. Giacomo dell'Orio",
        numreviews: 152,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6376731-Reviews-Majer_S_Giacomo_dell_Orio-Venice_Veneto.html",
        percent_ital: 0.31578946,
        diversity_index_2: 0.4361186,
        diversity_index_3: -0.5638814,
        composite_ital_3: 1.9825206,
      },
      geometry: { type: "Point", coordinates: [12.32804, 45.44035] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.442318,
        lng: 12.332808,
        name: "A Beccafico Arte",
        numreviews: 779,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6378872-Reviews-A_Beccafico_Arte-Venice_Veneto.html",
        percent_ital: 0.36970475,
        diversity_index_2: 0.4335053,
        diversity_index_3: -0.5664947,
        composite_ital_3: 1.8309019,
      },
      geometry: { type: "Point", coordinates: [12.33281, 45.44232] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436237,
        lng: 12.323986,
        name: "Ristorante Pizzeria Dolfin",
        numreviews: 1165,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6404241-Reviews-Ristorante_Pizzeria_Dolfin-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.36224365,
        diversity_index_3: -0.63775635,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32399, 45.43624] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.431614,
        lng: 12.333168,
        name: "Bar Longhi",
        numreviews: 142,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6413387-Reviews-Bar_Longhi-Venice_Veneto.html",
        percent_ital: 0.091549292,
        diversity_index_2: 0.62349433,
        diversity_index_3: -0.37650567,
        composite_ital_3: 2.8632934,
      },
      geometry: { type: "Point", coordinates: [12.33317, 45.43161] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Italian",
        lat: 45.435631,
        lng: 12.344258,
        name: "Crazy Bar",
        numreviews: 14,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6418056-Reviews-Crazy_Bar-Venice_Veneto.html",
        percent_ital: 0.21428572,
        diversity_index_2: 0.5272727,
        diversity_index_3: -0.4727273,
        composite_ital_3: 2.1804824,
      },
      geometry: { type: "Point", coordinates: [12.34426, 45.43563] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.444061,
        lng: 12.333083,
        name: "VinoVero",
        numreviews: 665,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6419992-Reviews-VinoVero-Venice_Veneto.html",
        percent_ital: 0.36090225,
        diversity_index_2: 0.42099833,
        diversity_index_3: -0.57900167,
        composite_ital_3: 1.8842746,
      },
      geometry: { type: "Point", coordinates: [12.33308, 45.44406] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443153,
        lng: 12.333533,
        name: "Al 56 Zerootto",
        numreviews: 601,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6420090-Reviews-Al_56_Zerootto-Venice_Veneto.html",
        percent_ital: 0.28286189,
        diversity_index_2: 0.35150754,
        diversity_index_3: -0.64849246,
        composite_ital_3: 2.3083205,
      },
      geometry: { type: "Point", coordinates: [12.33353, 45.44315] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.441978,
        lng: 12.333041,
        name: "Old Wild West",
        numreviews: 832,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6425828-Reviews-Old_Wild_West-Venice_Veneto.html",
        percent_ital: 0.61658657,
        diversity_index_2: 0.36915147,
        diversity_index_3: -0.63084853,
        composite_ital_3: 1.4801048,
      },
      geometry: { type: "Point", coordinates: [12.33304, 45.44198] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.44075,
        lng: 12.33603,
        name: "La Panocia D'Oro",
        numreviews: 310,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6439462-Reviews-La_Panocia_D_Oro-Venice_Veneto.html",
        percent_ital: 0.24516129,
        diversity_index_2: 0.38644066,
        diversity_index_3: -0.61355937,
        composite_ital_3: 2.3566158,
      },
      geometry: { type: "Point", coordinates: [12.33603, 45.44075] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.435555,
        lng: 12.345349,
        name: "Crazy Bar2",
        numreviews: 30,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6451015-Reviews-Crazy_Bar2-Venice_Veneto.html",
        percent_ital: 0.23333333,
        diversity_index_2: 0.34782609,
        diversity_index_3: -0.65217388,
        composite_ital_3: 2.5113399,
      },
      geometry: { type: "Point", coordinates: [12.34535, 45.43556] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$",
        lat: 45.439812,
        lng: 12.320527,
        name: "Spizzico - Tentazioni Cafe",
        numreviews: 80,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6456368-Reviews-Spizzico_Tentazioni_Cafe-Venice_Veneto.html",
        percent_ital: 0.72500002,
        diversity_index_2: 0.42753622,
        diversity_index_3: -0.57246375,
        composite_ital_3: 1.1712999,
      },
      geometry: { type: "Point", coordinates: [12.32053, 45.43981] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "Italian",
        lat: 45.438744,
        lng: 12.334691,
        name: "Ai 10 Savi Bar - VENEZIA",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6486993-Reviews-Ai_10_Savi_Bar_VENEZIA-Venice_Veneto.html",
        percent_ital: 0.60000001999999997,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.6094378,
      },
      geometry: { type: "Point", coordinates: [12.33469, 45.43874] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.445438,
        lng: 12.32902,
        name: "Campalto Aldo & C S.a.S",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6499276-Reviews-Campalto_Aldo_C_S_a_S-Venice_Veneto.html",
        percent_ital: 0.66666669,
        diversity_index_2: 0.33333334,
        diversity_index_3: -0.66666663,
        composite_ital_3: 1.5040773,
      },
      geometry: { type: "Point", coordinates: [12.32902, 45.44544] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439785,
        lng: 12.324977,
        name: "Osteria Trefanti",
        numreviews: 886,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6501822-Reviews-Osteria_Trefanti-Venice_Veneto.html",
        percent_ital: 0.44808125,
        diversity_index_2: 0.48594427,
        diversity_index_3: -0.51405573,
        composite_ital_3: 1.5244421,
      },
      geometry: { type: "Point", coordinates: [12.32498, 45.43979] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435757,
        lng: 12.344428,
        name: "Liassidi Bar",
        numreviews: 65,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6513328-Reviews-Liassidi_Bar-Venice_Veneto.html",
        percent_ital: 0.07692308,
        diversity_index_2: 0.31092897,
        diversity_index_3: -0.68907106,
        composite_ital_3: 3.7331402,
      },
      geometry: { type: "Point", coordinates: [12.34443, 45.43576] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.426418,
        lng: 12.341292,
        name: "Oro Restaurant",
        numreviews: 348,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6533922-Reviews-Oro_Restaurant-Venice_Veneto.html",
        percent_ital: 0.18965517,
        diversity_index_2: 0.52356541,
        diversity_index_3: -0.47643459,
        composite_ital_3: 2.3096411,
      },
      geometry: { type: "Point", coordinates: [12.34129, 45.42642] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.431599,
        lng: 12.330444,
        name: "Pisanino Restaurant",
        numreviews: 60,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6541840-Reviews-Pisanino_Restaurant-Venice_Veneto.html",
        percent_ital: 0.34999998999999998,
        diversity_index_2: 0.39358974,
        diversity_index_3: -0.60641026,
        composite_ital_3: 1.9822683,
      },
      geometry: { type: "Point", coordinates: [12.33044, 45.4316] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$",
        lat: 45.437458,
        lng: 12.341211,
        name: "Bar All'Orologio",
        numreviews: 122,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6553019-Reviews-Bar_All_Orologio-Venice_Veneto.html",
        percent_ital: 0.4180328,
        diversity_index_2: 0.33020344,
        diversity_index_3: -0.66979659,
        composite_ital_3: 1.9802418,
      },
      geometry: { type: "Point", coordinates: [12.34121, 45.43746] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434353,
        lng: 12.336108,
        name: "Ristorante Trattoria Venezia",
        numreviews: 21,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6556321-Reviews-Ristorante_Trattoria_Venezia-Venice_Veneto.html",
        percent_ital: 0.23809524,
        diversity_index_2: 0.65833336,
        diversity_index_3: -0.34166664,
        composite_ital_3: 1.8531283,
      },
      geometry: { type: "Point", coordinates: [12.33611, 45.43435] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445446,
        lng: 12.326716,
        name: "Upupa Ghetto Venezia",
        numreviews: 467,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6577433-Reviews-Upupa_Ghetto_Venezia-Venice_Veneto.html",
        percent_ital: 0.36616701,
        diversity_index_2: 0.39301026,
        diversity_index_3: -0.60698974,
        composite_ital_3: 1.9385853,
      },
      geometry: { type: "Point", coordinates: [12.32672, 45.44545] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.444363,
        lng: 12.329453,
        name: "Iguana",
        numreviews: 261,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6591001-Reviews-Iguana-Venice_Veneto.html",
        percent_ital: 0.66666669,
        diversity_index_2: 0.52771676,
        diversity_index_3: -0.47228324,
        composite_ital_3: 1.0446607,
      },
      geometry: { type: "Point", coordinates: [12.32945, 45.44436] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435246,
        lng: 12.341473,
        name: "Bar Trattoria San Giacomo",
        numreviews: 25,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6596348-Reviews-Bar_Trattoria_San_Giacomo-Venice_Veneto.html",
        percent_ital: 0.039999999000000001,
        diversity_index_2: 0.36956522,
        diversity_index_3: -0.63043475,
        composite_ital_3: 4.214304,
      },
      geometry: { type: "Point", coordinates: [12.34147, 45.43525] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.441887,
        lng: 12.325581,
        name: "Bar da Fiore",
        numreviews: 50,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6673873-Reviews-Bar_da_Fiore-Venice_Veneto.html",
        percent_ital: 0.36000001,
        diversity_index_2: 0.19507575,
        diversity_index_3: -0.80492425,
        composite_ital_3: 2.6560185,
      },
      geometry: { type: "Point", coordinates: [12.32558, 45.44189] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434418,
        lng: 12.33588,
        name: "Ristorante Trattoria Cherubino",
        numreviews: 1875,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6688186-Reviews-Ristorante_Trattoria_Cherubino-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.34584755,
        diversity_index_3: -0.65415245,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33588, 45.43442] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436516,
        lng: 12.339658,
        name: "Osteria Ae Forcoe",
        numreviews: 425,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6691486-Reviews-Osteria_Ae_Forcoe-Venice_Veneto.html",
        percent_ital: 0.5411765,
        diversity_index_2: 0.33005178,
        diversity_index_3: -0.66994822,
        composite_ital_3: 1.7225155,
      },
      geometry: { type: "Point", coordinates: [12.33966, 45.43652] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.445255,
        lng: 12.329542,
        name: "A la Virtu",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6698339-Reviews-A_la_Virtu-Venice_Veneto.html",
        percent_ital: 0.5714286,
        diversity_index_2: 0.60000001999999997,
        diversity_index_3: -0.39999997999999998,
        composite_ital_3: 1.0704412,
      },
      geometry: { type: "Point", coordinates: [12.32954, 45.44526] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.434261,
        lng: 12.316836,
        name: "Bar Al Canton",
        numreviews: 39,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6776628-Reviews-Bar_Al_Canton-Venice_Veneto.html",
        percent_ital: 0.48717949,
        diversity_index_2: 0.50952381,
        diversity_index_3: -0.49047619,
        composite_ital_3: 1.3934014,
      },
      geometry: { type: "Point", coordinates: [12.31684, 45.43426] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434311,
        lng: 12.342889,
        name: "Sestante Bar & Restaurant",
        numreviews: 200,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6834417-Reviews-Sestante_Bar_Restaurant-Venice_Veneto.html",
        percent_ital: 0.38999999000000002,
        diversity_index_2: 0.35989228,
        diversity_index_3: -0.64010775,
        composite_ital_3: 1.963559,
      },
      geometry: { type: "Point", coordinates: [12.34289, 45.43431] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443649,
        lng: 12.326492,
        name: "Ristorante Speranza",
        numreviews: 454,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6857601-Reviews-Ristorante_Speranza-Venice_Veneto.html",
        percent_ital: 0.33480176,
        diversity_index_2: 0.3117075,
        diversity_index_3: -0.6882925,
        composite_ital_3: 2.2599068,
      },
      geometry: { type: "Point", coordinates: [12.32649, 45.44365] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43911,
        lng: 12.34119,
        name: "Ristorante E Bar Al Cavallo",
        numreviews: 163,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6867177-Reviews-Ristorante_E_Bar_Al_Cavallo-Venice_Veneto.html",
        percent_ital: 0.1411043,
        diversity_index_2: 0.30151975,
        diversity_index_3: -0.69848025,
        composite_ital_3: 3.1571758,
      },
      geometry: { type: "Point", coordinates: [12.34119, 45.43911] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.442104,
        lng: 12.32129,
        name: "Ristorante Sivoli",
        numreviews: 89,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6873668-Reviews-Ristorante_Sivoli-Venice_Veneto.html",
        percent_ital: 0.43820226,
        diversity_index_2: 0.26117647,
        diversity_index_3: -0.73882353,
        composite_ital_3: 2.1676338,
      },
      geometry: { type: "Point", coordinates: [12.32129, 45.4421] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436085,
        lng: 12.325079,
        name: "Estro",
        numreviews: 736,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6885060-Reviews-Estro-Venice_Veneto.html",
        percent_ital: 0.39538044,
        diversity_index_2: 0.42299497,
        diversity_index_3: -0.57700503,
        composite_ital_3: 1.7883018,
      },
      geometry: { type: "Point", coordinates: [12.32508, 45.43608] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433857,
        lng: 12.347743,
        name: "Ristorante Gabrielli",
        numreviews: 408,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6893204-Reviews-Ristorante_Gabrielli-Venice_Veneto.html",
        percent_ital: 0.6102941,
        diversity_index_2: 0.32849377,
        diversity_index_3: -0.67150623,
        composite_ital_3: 1.6070517,
      },
      geometry: { type: "Point", coordinates: [12.34774, 45.43386] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.431534,
        lng: 12.328008,
        name: "Beccafico Bar & Snack",
        numreviews: 106,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6912498-Reviews-Beccafico_Bar_Snack-Venice_Veneto.html",
        percent_ital: 0.16981132,
        diversity_index_2: 0.38636363,
        diversity_index_3: -0.61363637,
        composite_ital_3: 2.7240436,
      },
      geometry: { type: "Point", coordinates: [12.32801, 45.43153] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.435432,
        lng: 12.335289,
        name: "El Gobo de Rialto Cafe",
        numreviews: 10,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6924934-Reviews-El_Gobo_de_Rialto_Cafe-Venice_Veneto.html",
        percent_ital: 0.89999998000000003,
        diversity_index_2: 0.0,
        diversity_index_3: -1.0,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33529, 45.43543] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439671,
        lng: 12.32493,
        name: "Ai Garzoti",
        numreviews: 643,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6956204-Reviews-Ai_Garzoti-Venice_Veneto.html",
        percent_ital: 0.28926906,
        diversity_index_2: 0.31081757,
        diversity_index_3: -0.6891824,
        composite_ital_3: 2.4089472,
      },
      geometry: { type: "Point", coordinates: [12.32493, 45.43967] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.434589,
        lng: 12.332332,
        name: "Ristorante Acqua Pazza",
        numreviews: 881,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696425-Reviews-Ristorante_Acqua_Pazza-Venice_Veneto.html",
        percent_ital: 0.3598184,
        diversity_index_2: 0.49385202,
        diversity_index_3: -0.50614798,
        composite_ital_3: 1.7276752,
      },
      geometry: { type: "Point", coordinates: [12.33233, 45.43459] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.439392,
        lng: 12.327843,
        name: "Ae Oche",
        numreviews: 676,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696426-Reviews-Ae_Oche-Venice_Veneto.html",
        percent_ital: 0.37278107,
        diversity_index_2: 0.29464403,
        diversity_index_3: -0.705356,
        composite_ital_3: 2.2087512,
      },
      geometry: { type: "Point", coordinates: [12.32784, 45.43939] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.434166,
        lng: 12.3475,
        name: "Al Covo",
        numreviews: 1030,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696435-Reviews-Al_Covo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.6113497,
        diversity_index_3: -0.3886503,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3475, 45.43417] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437721,
        lng: 12.336349,
        name: "Al Graspo de Ua",
        numreviews: 326,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696439-Reviews-Al_Graspo_de_Ua-Venice_Veneto.html",
        percent_ital: 0.47852761,
        diversity_index_2: 0.38276893,
        diversity_index_3: -0.61723107,
        composite_ital_3: 1.6973652,
      },
      geometry: { type: "Point", coordinates: [12.33635, 45.43772] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.425594,
        lng: 12.328579,
        name: "Altanella",
        numreviews: 343,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696441-Reviews-Altanella-Venice_Veneto.html",
        percent_ital: 0.28862974,
        diversity_index_2: 0.38851833,
        diversity_index_3: -0.61148167,
        composite_ital_3: 2.1880255,
      },
      geometry: { type: "Point", coordinates: [12.32858, 45.42559] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.433605,
        lng: 12.334138,
        name: "Ristorante Antico Martini",
        numreviews: 915,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696450-Reviews-Ristorante_Antico_Martini-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41448978,
        diversity_index_3: -0.58551025,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33414, 45.43361] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.435482,
        lng: 12.339292,
        name: "Antico Pignolo",
        numreviews: 590,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696451-Reviews-Antico_Pignolo-Venice_Veneto.html",
        percent_ital: 0.29152542,
        diversity_index_2: 0.36374688,
        diversity_index_3: -0.63625312,
        composite_ital_3: 2.2439251,
      },
      geometry: { type: "Point", coordinates: [12.33929, 45.43548] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.426556,
        lng: 12.340992,
        name: "Cip's Club Belmond Hotel Cipriani",
        numreviews: 520,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696513-Reviews-Cip_s_Club_Belmond_Hotel_Cipriani-Venice_Veneto.html",
        percent_ital: 0.13076924,
        diversity_index_2: 0.70240492,
        diversity_index_3: -0.29759508,
        composite_ital_3: 2.3875663,
      },
      geometry: { type: "Point", coordinates: [12.34099, 45.42656] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.434757,
        lng: 12.347958,
        name: "Trattoria Corte Sconta",
        numreviews: 1072,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696518-Reviews-Trattoria_Corte_Sconta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.44750315,
        diversity_index_3: -0.55249685,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34796, 45.43476] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.429516,
        lng: 12.327309,
        name: "Pizzeria Da Gianni",
        numreviews: 332,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696524-Reviews-Pizzeria_Da_Gianni-Venice_Veneto.html",
        percent_ital: 0.20481928,
        diversity_index_2: 0.34538594,
        diversity_index_3: -0.65461409,
        composite_ital_3: 2.64872,
      },
      geometry: { type: "Point", coordinates: [12.32731, 45.42952] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440521,
        lng: 12.335704,
        name: "Trattoria Da Gianni",
        numreviews: 440,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696525-Reviews-Trattoria_Da_Gianni-Venice_Veneto.html",
        percent_ital: 0.22727273,
        diversity_index_2: 0.42782664,
        diversity_index_3: -0.57217336,
        composite_ital_3: 2.3306417,
      },
      geometry: { type: "Point", coordinates: [12.3357, 45.44052] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.434616,
        lng: 12.335418,
        name: "Ristorante Da Ivo",
        numreviews: 570,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696526-Reviews-Ristorante_Da_Ivo-Venice_Veneto.html",
        percent_ital: 0.1631579,
        diversity_index_2: 0.57178152,
        diversity_index_3: -0.42821848,
        composite_ital_3: 2.3720353,
      },
      geometry: { type: "Point", coordinates: [12.33542, 45.43462] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437347,
        lng: 12.331361,
        name: "Da Sandro",
        numreviews: 167,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696529-Reviews-Da_Sandro-Venice_Veneto.html",
        percent_ital: 0.37125748,
        diversity_index_2: 0.38221025,
        diversity_index_3: -0.61778975,
        composite_ital_3: 1.9526438,
      },
      geometry: { type: "Point", coordinates: [12.33136, 45.43735] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.432137,
        lng: 12.336314,
        name: "De Pisis",
        numreviews: 237,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696536-Reviews-De_Pisis-Venice_Veneto.html",
        percent_ital: 0.19831224,
        diversity_index_2: 0.39425173,
        diversity_index_3: -0.6057483,
        composite_ital_3: 2.5486782,
      },
      geometry: { type: "Point", coordinates: [12.33631, 45.43214] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.444115,
        lng: 12.325035,
        name: "Gam Gam Kosher Restaurant",
        numreviews: 2298,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696559-Reviews-Gam_Gam_Kosher_Restaurant-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.54117596,
        diversity_index_3: -0.45882404,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32503, 45.44411] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.432396,
        lng: 12.33706,
        name: "Ristorante Grand Canal",
        numreviews: 432,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696568-Reviews-Ristorante_Grand_Canal-Venice_Veneto.html",
        percent_ital: 0.18287037,
        diversity_index_2: 0.41295457,
        diversity_index_3: -0.58704543,
        composite_ital_3: 2.5833955,
      },
      geometry: { type: "Point", coordinates: [12.33706, 45.4324] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$$$",
        lat: 45.43243,
        lng: 12.337205,
        name: "Harry's Bar",
        numreviews: 898,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696570-Reviews-Harry_s_Bar-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.15883067,
        diversity_index_3: -0.84116936,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33721, 45.43243] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.427143,
        lng: 12.323081,
        name: "Harry's Dolci",
        numreviews: 380,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696573-Reviews-Harry_s_Dolci-Venice_Veneto.html",
        percent_ital: 0.29736841,
        diversity_index_2: 0.60963768,
        diversity_index_3: -0.39036232,
        composite_ital_3: 1.7076739,
      },
      geometry: { type: "Point", coordinates: [12.32308, 45.42714] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.435501,
        lng: 12.346795,
        name: "Hostaria da Franz",
        numreviews: 530,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696580-Reviews-Hostaria_da_Franz-Venice_Veneto.html",
        percent_ital: 0.24339622,
        diversity_index_2: 0.52072144,
        diversity_index_3: -0.47927856,
        composite_ital_3: 2.0656047,
      },
      geometry: { type: "Point", coordinates: [12.3468, 45.4355] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437687,
        lng: 12.341783,
        name: "Osteria Al Mascaron",
        numreviews: 1224,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696612-Reviews-Osteria_Al_Mascaron-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.33088437,
        diversity_index_3: -0.66911566,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34178, 45.43769] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439545,
        lng: 12.331253,
        name: "Osteria Nono Risorto",
        numreviews: 1641,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696615-Reviews-Osteria_Nono_Risorto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.32231191,
        diversity_index_3: -0.67768812,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33125, 45.43955] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43494,
        lng: 12.342127,
        name: "Trattoria Alla Rivetta",
        numreviews: 1784,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696626-Reviews-Trattoria_Alla_Rivetta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.36611718,
        diversity_index_3: -0.63388282,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34213, 45.43494] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.437035,
        lng: 12.340206,
        name: "Osteria alle Testiere",
        numreviews: 1514,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d696631-Reviews-Osteria_alle_Testiere-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.53010774,
        diversity_index_3: -0.46989226,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34021, 45.43704] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433998,
        lng: 12.344525,
        name: "Luna S.N.C Di Orlando Rizzo & C",
        numreviews: 25,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6989537-Reviews-Luna_S_N_C_Di_Orlando_Rizzo_C-Venice_Veneto.html",
        percent_ital: 0.16,
        diversity_index_2: 0.16883117,
        diversity_index_3: -0.83116883,
        composite_ital_3: 3.6114376,
      },
      geometry: { type: "Point", coordinates: [12.34453, 45.434] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433926,
        lng: 12.332414,
        name: "L'Opera",
        numreviews: 443,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d6997990-Reviews-L_Opera-Venice_Veneto.html",
        percent_ital: 0.248307,
        diversity_index_2: 0.38720173,
        diversity_index_3: -0.61279827,
        composite_ital_3: 2.3418989,
      },
      geometry: { type: "Point", coordinates: [12.33241, 45.43393] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.439434,
        lng: 12.333753,
        name: "Pescaria",
        numreviews: 63,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7018992-Reviews-Pescaria-Venice_Veneto.html",
        percent_ital: 0.2857143,
        diversity_index_2: 0.39323673,
        diversity_index_3: -0.60676324,
        composite_ital_3: 2.1861064,
      },
      geometry: { type: "Point", coordinates: [12.33375, 45.43943] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434795,
        lng: 12.33735,
        name: "Marco Polo",
        numreviews: 188,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7028288-Reviews-Marco_Polo-Venice_Veneto.html",
        percent_ital: 0.13297872,
        diversity_index_2: 0.39458328,
        diversity_index_3: -0.60541672,
        composite_ital_3: 2.9474912,
      },
      geometry: { type: "Point", coordinates: [12.33735, 45.4348] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.440414,
        lng: 12.325147,
        name: "Bacaro Quebrado",
        numreviews: 1499,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7039245-Reviews-Bacaro_Quebrado-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.29398504,
        diversity_index_3: -0.70601499,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32515, 45.44041] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43697,
        lng: 12.327697,
        name: "Murovenezia",
        numreviews: 145,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7088708-Reviews-Murovenezia-Venice_Veneto.html",
        percent_ital: 0.13103448,
        diversity_index_2: 0.41344833,
        diversity_index_3: -0.58655167,
        composite_ital_3: 2.9155176,
      },
      geometry: { type: "Point", coordinates: [12.3277, 45.43697] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445148,
        lng: 12.323046,
        name: "Ogio",
        numreviews: 332,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7147203-Reviews-Ogio-Venice_Veneto.html",
        percent_ital: 0.76807231,
        diversity_index_2: 0.45277777,
        diversity_index_3: -0.54722226,
        composite_ital_3: 1.0562252,
      },
      geometry: { type: "Point", coordinates: [12.32305, 45.44515] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$",
        lat: 45.43985,
        lng: 12.339347,
        name: "Bar ai Miracoli",
        numreviews: 55,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7153137-Reviews-Bar_ai_Miracoli-Venice_Veneto.html",
        percent_ital: 0.34545454,
        diversity_index_2: 0.4054054,
        diversity_index_3: -0.5945946,
        composite_ital_3: 1.9657619,
      },
      geometry: { type: "Point", coordinates: [12.33935, 45.43985] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.438293,
        lng: 12.339173,
        name: "L'Osteria di Santa Marina",
        numreviews: 1407,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716271-Reviews-L_Osteria_di_Santa_Marina-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.48277959,
        diversity_index_3: -0.51722038,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33917, 45.43829] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.430531,
        lng: 12.328032,
        name: "La Rivista Restaurant Bar",
        numreviews: 153,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716290-Reviews-La_Rivista_Restaurant_Bar-Venice_Veneto.html",
        percent_ital: 0.17647059,
        diversity_index_2: 0.46181726,
        diversity_index_3: -0.53818274,
        composite_ital_3: 2.5071869,
      },
      geometry: { type: "Point", coordinates: [12.32803, 45.43053] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.43391,
        lng: 12.342221,
        name: "Restaurant Terrazza Danieli",
        numreviews: 1589,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716294-Reviews-Restaurant_Terrazza_Danieli-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40515175,
        diversity_index_3: -0.59484828,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34222, 45.43391] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.435551,
        lng: 12.336512,
        name: "Bistrot de Venise",
        numreviews: 1912,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716300-Reviews-Bistrot_de_Venise-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.30638406,
        diversity_index_3: -0.69361591,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33651, 45.43555] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.43206,
        lng: 12.324761,
        name: "Locanda Montin",
        numreviews: 489,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716311-Reviews-Locanda_Montin-Venice_Veneto.html",
        percent_ital: 0.21472393,
        diversity_index_2: 0.52676129,
        diversity_index_3: -0.47323871,
        composite_ital_3: 2.17941,
      },
      geometry: { type: "Point", coordinates: [12.32476, 45.43206] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.43383,
        lng: 12.3216,
        name: "Orange Bar",
        numreviews: 306,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716335-Reviews-Orange_Bar-Venice_Veneto.html",
        percent_ital: 0.39215687,
        diversity_index_2: 0.3395153,
        diversity_index_3: -0.66048467,
        composite_ital_3: 2.0163295,
      },
      geometry: { type: "Point", coordinates: [12.3216, 45.43383] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.438648,
        lng: 12.329276,
        name: "Osteria Da Fiore",
        numreviews: 760,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716340-Reviews-Osteria_Da_Fiore-Venice_Veneto.html",
        percent_ital: 0.36973685,
        diversity_index_2: 0.47559395,
        diversity_index_3: -0.52440608,
        composite_ital_3: 1.7381545,
      },
      geometry: { type: "Point", coordinates: [12.32928, 45.43865] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.43293,
        lng: 12.33414,
        name: "La Caravella",
        numreviews: 1114,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716372-Reviews-La_Caravella-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.25184345,
        diversity_index_3: -0.74815655,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33414, 45.43293] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437778,
        lng: 12.332222,
        name: "S. Aponal - Restorante 1251 Pizzeria",
        numreviews: 421,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716391-Reviews-S_Aponal_Restorante_1251_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.33729216,
        diversity_index_2: 0.43873921,
        diversity_index_3: -0.56126082,
        composite_ital_3: 1.9106559,
      },
      geometry: { type: "Point", coordinates: [12.33222, 45.43778] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "Mediterranean",
        lat: 45.444229,
        lng: 12.332738,
        name: "Sahara",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716396-Reviews-Sahara-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33274, 45.44423] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.431229,
        lng: 12.357215,
        name: "Trattoria Dai Tosi",
        numreviews: 508,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716421-Reviews-Trattoria_Dai_Tosi-Venice_Veneto.html",
        percent_ital: 0.43307087,
        diversity_index_2: 0.34186515,
        diversity_index_3: -0.65813482,
        composite_ital_3: 1.9101927,
      },
      geometry: { type: "Point", coordinates: [12.35722, 45.43123] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.441986,
        lng: 12.333755,
        name: "Vini da Gigio",
        numreviews: 893,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d716437-Reviews-Vini_da_Gigio-Venice_Veneto.html",
        percent_ital: 0.47368422,
        diversity_index_2: 0.43323809,
        diversity_index_3: -0.56676191,
        composite_ital_3: 1.5836822,
      },
      geometry: { type: "Point", coordinates: [12.33376, 45.44199] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439919,
        lng: 12.32177,
        name: "Ristorante Da Nino",
        numreviews: 167,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7193522-Reviews-Ristorante_Da_Nino-Venice_Veneto.html",
        percent_ital: 0.1257485,
        diversity_index_2: 0.43863574,
        diversity_index_3: -0.56136429,
        composite_ital_3: 2.8975575,
      },
      geometry: { type: "Point", coordinates: [12.32177, 45.43992] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.441051,
        lng: 12.320217,
        name: "VyTA",
        numreviews: 94,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7205543-Reviews-VyTA-Venice_Veneto.html",
        percent_ital: 0.55319148,
        diversity_index_2: 0.40697673,
        diversity_index_3: -0.5930233,
        composite_ital_3: 1.4910504,
      },
      geometry: { type: "Point", coordinates: [12.32022, 45.44105] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.443832,
        lng: 12.329653,
        name: "Queen Restaurant",
        numreviews: 252,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7224577-Reviews-Queen_Restaurant-Venice_Veneto.html",
        percent_ital: 0.3531746,
        diversity_index_2: 0.32254249,
        diversity_index_3: -0.67745751,
        composite_ital_3: 2.1723132,
      },
      geometry: { type: "Point", coordinates: [12.32965, 45.44383] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436142,
        lng: 12.323883,
        name: "La Lanterna Da Gas",
        numreviews: 1052,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7225453-Reviews-La_Lanterna_Da_Gas-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.35059294,
        diversity_index_3: -0.64940703,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32388, 45.43614] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.0,
        dollarsigns: null,
        lat: 45.438816,
        lng: 12.33434,
        name: "Bar Tris DI Mancin Luigina & C. S.A.S",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7233236-Reviews-Bar_Tris_DI_Mancin_Luigina_C_S_A_S-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40000001000000002,
        diversity_index_3: -0.60000001999999997,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33434, 45.43882] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.441898,
        lng: 12.322018,
        name: "Trattoria Il Vagone",
        numreviews: 1473,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7249332-Reviews-Trattoria_Il_Vagone-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.2881037,
        diversity_index_3: -0.7118963,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32202, 45.4419] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "Italian",
        lat: 45.438496,
        lng: 12.326605,
        name: "Venice Veneto Gourmet",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7251070-Reviews-Venice_Veneto_Gourmet-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32661, 45.4385] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.442204,
        lng: 12.323293,
        name: "Gino's",
        numreviews: 957,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7254051-Reviews-Gino_s-Venice_Veneto.html",
        percent_ital: 0.26018807,
        diversity_index_2: 0.38393262,
        diversity_index_3: -0.61606741,
        composite_ital_3: 2.3036387,
      },
      geometry: { type: "Point", coordinates: [12.32329, 45.4422] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437725,
        lng: 12.336092,
        name: "Hotel Rialto",
        numreviews: 149,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7254720-Reviews-Hotel_Rialto-Venice_Veneto.html",
        percent_ital: 0.13422818,
        diversity_index_2: 0.41109124,
        diversity_index_3: -0.58890879,
        composite_ital_3: 2.8971541,
      },
      geometry: { type: "Point", coordinates: [12.33609, 45.43773] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.434063,
        lng: 12.343452,
        name: "Hotel Londra Place",
        numreviews: 55,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7255826-Reviews-Hotel_Londra_Place-Venice_Veneto.html",
        percent_ital: 0.12727273,
        diversity_index_2: 0.5,
        diversity_index_3: -0.5,
        composite_ital_3: 2.7545702,
      },
      geometry: { type: "Point", coordinates: [12.34345, 45.43406] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.439259,
        lng: 12.321157,
        name: "Bar Da Mattia",
        numreviews: 68,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7267479-Reviews-Bar_Da_Mattia-Venice_Veneto.html",
        percent_ital: 0.10294118,
        diversity_index_2: 0.29825488,
        diversity_index_3: -0.70174515,
        composite_ital_3: 3.4834044,
      },
      geometry: { type: "Point", coordinates: [12.32116, 45.43926] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.436665,
        lng: 12.331669,
        name: "Aman Canal Grande Venice Resort Restaurant",
        numreviews: 76,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7300107-Reviews-Aman_Canal_Grande_Venice_Resort_Restaurant-Venice_Veneto.html",
        percent_ital: 0.30263159,
        diversity_index_2: 0.56094277,
        diversity_index_3: -0.43905723,
        composite_ital_3: 1.7733755,
      },
      geometry: { type: "Point", coordinates: [12.33167, 45.43666] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435158,
        lng: 12.339385,
        name: "Altrove S.R.L",
        numreviews: 18,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7321061-Reviews-Altrove_S_R_L-Venice_Veneto.html",
        percent_ital: 0.16666667,
        diversity_index_2: 0.2857143,
        diversity_index_3: -0.71428573,
        composite_ital_3: 3.0445223,
      },
      geometry: { type: "Point", coordinates: [12.33939, 45.43516] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438,
        lng: 12.321316,
        name: "Caffetteria Cicchetteria Ai Do Scaini",
        numreviews: 114,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7355716-Reviews-Caffetteria_Cicchetteria_Ai_Do_Scaini-Venice_Veneto.html",
        percent_ital: 0.44736841,
        diversity_index_2: 0.29423076,
        diversity_index_3: -0.70576924,
        composite_ital_3: 2.0277638,
      },
      geometry: { type: "Point", coordinates: [12.32132, 45.438] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434025,
        lng: 12.335373,
        name: "Il Calice",
        numreviews: 343,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d743765-Reviews-Il_Calice-Venice_Veneto.html",
        percent_ital: 0.32653061,
        diversity_index_2: 0.39070466,
        diversity_index_3: -0.60929537,
        composite_ital_3: 2.0590348,
      },
      geometry: { type: "Point", coordinates: [12.33537, 45.43402] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438194,
        lng: 12.335691,
        name: "Riva Rialto",
        numreviews: 520,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7617189-Reviews-Riva_Rialto-Venice_Veneto.html",
        percent_ital: 0.32307693,
        diversity_index_2: 0.31057441,
        diversity_index_3: -0.68942559,
        composite_ital_3: 2.2991965,
      },
      geometry: { type: "Point", coordinates: [12.33569, 45.43819] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.445526,
        lng: 12.328668,
        name: "Tutto A Posto da Nicolino",
        numreviews: 31,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7622007-Reviews-Tutto_A_Posto_da_Nicolino-Venice_Veneto.html",
        percent_ital: 0.74193549,
        diversity_index_2: 0.32051283,
        diversity_index_3: -0.67948717,
        composite_ital_3: 1.436326,
      },
      geometry: { type: "Point", coordinates: [12.32867, 45.44553] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.443401,
        lng: 12.327709,
        name: "Alla Corte Ostinati",
        numreviews: 47,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7649610-Reviews-Alla_Corte_Ostinati-Venice_Veneto.html",
        percent_ital: 0.76595747,
        diversity_index_2: 0.30769232,
        diversity_index_3: -0.69230771,
        composite_ital_3: 1.4452835,
      },
      geometry: { type: "Point", coordinates: [12.32771, 45.4434] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434376,
        lng: 12.346951,
        name: "Bacarandino",
        numreviews: 1160,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7652004-Reviews-Bacarandino-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.30949724,
        diversity_index_3: -0.69050276,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34695, 45.43438] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.432751,
        lng: 12.332187,
        name: "Redentore",
        numreviews: 43,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7660663-Reviews-Redentore-Venice_Veneto.html",
        percent_ital: 0.18604651,
        diversity_index_2: 0.30634922,
        diversity_index_3: -0.69365078,
        composite_ital_3: 2.8647883,
      },
      geometry: { type: "Point", coordinates: [12.33219, 45.43275] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43523,
        lng: 12.33726,
        name: "Silfer",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7719969-Reviews-Silfer-Venice_Veneto.html",
        percent_ital: 0.22222222,
        diversity_index_2: 0.2857143,
        diversity_index_3: -0.71428573,
        composite_ital_3: 2.7568402,
      },
      geometry: { type: "Point", coordinates: [12.33726, 45.43523] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.446453,
        lng: 12.319799,
        name: "Snack Bar Tre Archi",
        numreviews: 22,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7724880-Reviews-Snack_Bar_Tre_Archi-Venice_Veneto.html",
        percent_ital: 0.13636364,
        diversity_index_2: 0.25146198,
        diversity_index_3: -0.74853802,
        composite_ital_3: 3.3728936,
      },
      geometry: { type: "Point", coordinates: [12.3198, 45.44645] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.437248,
        lng: 12.337135,
        name: "Ai Stagneri",
        numreviews: 100,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7727921-Reviews-Ai_Stagneri-Venice_Veneto.html",
        percent_ital: 0.18000001,
        diversity_index_2: 0.39700264,
        diversity_index_3: -0.60299736,
        composite_ital_3: 2.6386108,
      },
      geometry: { type: "Point", coordinates: [12.33713, 45.43725] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: null,
        lat: 45.433655,
        lng: 12.349066,
        name: "Occhi Di Gatto",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7733417-Reviews-Occhi_Di_Gatto-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34907, 45.43366] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438694,
        lng: 12.321404,
        name: "Hostaria Vecio Biavarol",
        numreviews: 667,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7744066-Reviews-Hostaria_Vecio_Biavarol-Venice_Veneto.html",
        percent_ital: 0.68515742,
        diversity_index_2: 0.32386583,
        diversity_index_3: -0.67613417,
        composite_ital_3: 1.5055326,
      },
      geometry: { type: "Point", coordinates: [12.3214, 45.43869] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435188,
        lng: 12.337897,
        name: "Anima Bella",
        numreviews: 267,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d776495-Reviews-Anima_Bella-Venice_Veneto.html",
        percent_ital: 0.078651689,
        diversity_index_2: 0.51821864,
        diversity_index_3: -0.48178136,
        composite_ital_3: 3.2000842,
      },
      geometry: { type: "Point", coordinates: [12.3379, 45.43519] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440754,
        lng: 12.329816,
        name: "Osteria Mocenigo",
        numreviews: 1693,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d780766-Reviews-Osteria_Mocenigo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.4236857,
        diversity_index_3: -0.57631433,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32982, 45.44075] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435303,
        lng: 12.341603,
        name: "Antica osteria ai tre leoni",
        numreviews: 665,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7808793-Reviews-Antica_osteria_ai_tre_leoni-Venice_Veneto.html",
        percent_ital: 0.20902255,
        diversity_index_2: 0.27025783,
        diversity_index_3: -0.72974217,
        composite_ital_3: 2.873692,
      },
      geometry: { type: "Point", coordinates: [12.3416, 45.4353] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.446072,
        lng: 12.32635,
        name: "Bagatela",
        numreviews: 63,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7810347-Reviews-Bagatela-Venice_Veneto.html",
        percent_ital: 0.63492066,
        diversity_index_2: 0.42666668,
        diversity_index_3: -0.57333332,
        composite_ital_3: 1.3060075,
      },
      geometry: { type: "Point", coordinates: [12.32635, 45.44607] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.443916,
        lng: 12.326472,
        name: "Mina Snc",
        numreviews: 3,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7810652-Reviews-Mina_Snc-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32647, 45.44392] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437428,
        lng: 12.33979,
        name: "Ai Barbacani",
        numreviews: 1471,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d783432-Reviews-Ai_Barbacani-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.37788656,
        diversity_index_3: -0.62211347,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33979, 45.43743] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "Italian",
        lat: 45.434723,
        lng: 12.321253,
        name: "Marina Kebab",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7899130-Reviews-Marina_Kebab-Venice_Veneto.html",
        percent_ital: 0.66666669,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.40546507,
      },
      geometry: { type: "Point", coordinates: [12.32125, 45.43472] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436085,
        lng: 12.342514,
        name: "Osteria Ruga di Jaffa",
        numreviews: 415,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7912634-Reviews-Osteria_Ruga_di_Jaffa-Venice_Veneto.html",
        percent_ital: 0.42891565,
        diversity_index_2: 0.41134277,
        diversity_index_3: -0.58865726,
        composite_ital_3: 1.7348233,
      },
      geometry: { type: "Point", coordinates: [12.34251, 45.43608] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438046,
        lng: 12.329856,
        name: "Birraria La Corte",
        numreviews: 1631,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d793024-Reviews-Birraria_La_Corte-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.42048177,
        diversity_index_3: -0.5795182,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32986, 45.43805] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436943,
        lng: 12.318089,
        name: "Caffetteria 3 Ponti",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7952056-Reviews-Caffetteria_3_Ponti-Venice_Veneto.html",
        percent_ital: 0.46153846,
        diversity_index_2: 0.30555555,
        diversity_index_3: -0.69444442,
        composite_ital_3: 1.9588135,
      },
      geometry: { type: "Point", coordinates: [12.31809, 45.43694] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.428158,
        lng: 12.317316,
        name: "Aromi Restaurant",
        numreviews: 196,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d795275-Reviews-Aromi_Restaurant-Venice_Veneto.html",
        percent_ital: 0.18877551,
        diversity_index_2: 0.6100629,
        diversity_index_3: -0.3899371,
        composite_ital_3: 2.1613901,
      },
      geometry: { type: "Point", coordinates: [12.31732, 45.42816] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.426792,
        lng: 12.319449,
        name: "Molino Restaurant",
        numreviews: 56,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d795279-Reviews-Molino_Restaurant-Venice_Veneto.html",
        percent_ital: 0.17857143,
        diversity_index_2: 0.53191489,
        diversity_index_3: -0.46808511,
        composite_ital_3: 2.3540382,
      },
      geometry: { type: "Point", coordinates: [12.31945, 45.42679] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.434574,
        lng: 12.332327,
        name: "Ristorante Masaniello",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d795284-Reviews-Ristorante_Masaniello-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.66666669,
        diversity_index_3: -0.33333331,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33233, 45.43457] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436409,
        lng: 12.342198,
        name: "Bacarando Street Food",
        numreviews: 55,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7953092-Reviews-Bacarando_Street_Food-Venice_Veneto.html",
        percent_ital: 0.72727275,
        diversity_index_2: 0.77205884,
        diversity_index_3: -0.22794116,
        composite_ital_3: 0.57714826,
      },
      geometry: { type: "Point", coordinates: [12.3422, 45.43641] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434086,
        lng: 12.343841,
        name: "Ristorante Wildner",
        numreviews: 603,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d797501-Reviews-Ristorante_Wildner-Venice_Veneto.html",
        percent_ital: 0.31177446,
        diversity_index_2: 0.47299576,
        diversity_index_3: -0.52700424,
        composite_ital_3: 1.914144,
      },
      geometry: { type: "Point", coordinates: [12.34384, 45.43409] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$$$",
        lat: 45.426113,
        lng: 12.336937,
        name: "i figli delle stelle",
        numreviews: 380,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d798905-Reviews-I_figli_delle_stelle-Venice_Veneto.html",
        percent_ital: 0.27894738,
        diversity_index_2: 0.37710145,
        diversity_index_3: -0.62289858,
        composite_ital_3: 2.2519732,
      },
      geometry: { type: "Point", coordinates: [12.33694, 45.42611] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.434677,
        lng: 12.325985,
        name: "Veniceat c/o Ca' Foscari",
        numreviews: 48,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d7996039-Reviews-Veniceat_c_o_Ca_Foscari-Venice_Veneto.html",
        percent_ital: 0.625,
        diversity_index_2: 0.34736842,
        diversity_index_3: -0.65263158,
        composite_ital_3: 1.527373,
      },
      geometry: { type: "Point", coordinates: [12.32598, 45.43468] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.439728,
        lng: 12.337812,
        name: "Bar Royal",
        numreviews: 51,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8000913-Reviews-Bar_Royal-Venice_Veneto.html",
        percent_ital: 0.078431375,
        diversity_index_2: 0.43439716,
        diversity_index_3: -0.56560284,
        composite_ital_3: 3.3793273,
      },
      geometry: { type: "Point", coordinates: [12.33781, 45.43973] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.438698,
        lng: 12.318683,
        name: "Filovia",
        numreviews: 16,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8020032-Reviews-Filovia-Venice_Veneto.html",
        percent_ital: 0.9375,
        diversity_index_2: 0.66666669,
        diversity_index_3: -0.33333331,
        composite_ital_3: 0.47000363,
      },
      geometry: { type: "Point", coordinates: [12.31868, 45.4387] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.433884,
        lng: 12.322946,
        name: "Bone Robe",
        numreviews: 120,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8023734-Reviews-Bone_Robe-Venice_Veneto.html",
        percent_ital: 0.60833335,
        diversity_index_2: 0.49404761,
        diversity_index_3: -0.50595236,
        composite_ital_3: 1.2021557,
      },
      geometry: { type: "Point", coordinates: [12.32295, 45.43388] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434338,
        lng: 12.337929,
        name: "Bravin",
        numreviews: 30,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8039402-Reviews-Bravin-Venice_Veneto.html",
        percent_ital: 0.1,
        diversity_index_2: 0.17948718,
        diversity_index_3: -0.82051283,
        composite_ital_3: 4.0202365,
      },
      geometry: { type: "Point", coordinates: [12.33793, 45.43434] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.442841,
        lng: 12.340918,
        name: "Il Caffe Gelato e l' Atelier della Pizza",
        numreviews: 97,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8091242-Reviews-Il_Caffe_Gelato_e_l_Atelier_della_Pizza-Venice_Veneto.html",
        percent_ital: 0.17525773,
        diversity_index_2: 0.43691659,
        diversity_index_3: -0.56308341,
        composite_ital_3: 2.5695107,
      },
      geometry: { type: "Point", coordinates: [12.34092, 45.44284] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438713,
        lng: 12.34267,
        name: "OSTERIA AI DO ARCHI",
        numreviews: 1277,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8095421-Reviews-OSTERIA_AI_DO_ARCHI-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.29420331,
        diversity_index_3: -0.70579672,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34267, 45.43871] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: null,
        lat: 45.425438,
        lng: 12.330375,
        name: "Mistra Di Zucchetta Roberta",
        numreviews: 1,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8119891-Reviews-Mistra_Di_Zucchetta_Roberta-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33038, 45.42544] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.437778,
        lng: 12.34215,
        name: "Enoiteca Mascareta",
        numreviews: 926,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d812417-Reviews-Enoiteca_Mascareta-Venice_Veneto.html",
        percent_ital: 0.55723542,
        diversity_index_2: 0.43810979,
        diversity_index_3: -0.56189024,
        composite_ital_3: 1.4100533,
      },
      geometry: { type: "Point", coordinates: [12.34215, 45.43778] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.425987,
        lng: 12.338215,
        name: "Ristorante Pizzeria ai Tre Scaini",
        numreviews: 165,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d815916-Reviews-Ristorante_Pizzeria_ai_Tre_Scaini-Venice_Veneto.html",
        percent_ital: 0.36969697,
        diversity_index_2: 0.44432235,
        diversity_index_3: -0.55567765,
        composite_ital_3: 1.8062766,
      },
      geometry: { type: "Point", coordinates: [12.33821, 45.42599] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439953,
        lng: 12.327855,
        name: "La Patatina",
        numreviews: 1893,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d817173-Reviews-La_Patatina-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.34984395,
        diversity_index_3: -0.65015602,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32785, 45.43995] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43219,
        lng: 12.325345,
        name: "osteria enoteca ai artisti",
        numreviews: 1386,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d817179-Reviews-Osteria_enoteca_ai_artisti-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.46890521,
        diversity_index_3: -0.53109479,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32535, 45.43219] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440113,
        lng: 12.327496,
        name: "La Patatina a San Giacomo",
        numreviews: 667,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8259899-Reviews-La_Patatina_a_San_Giacomo-Venice_Veneto.html",
        percent_ital: 0.40029985,
        diversity_index_2: 0.41943479,
        diversity_index_3: -0.58056521,
        composite_ital_3: 1.7843887,
      },
      geometry: { type: "Point", coordinates: [12.3275, 45.44011] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.438057,
        lng: 12.336111,
        name: "Al Buso",
        numreviews: 84,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8261563-Reviews-Al_Buso-Venice_Veneto.html",
        percent_ital: 0.095238097,
        diversity_index_2: 0.38345864,
        diversity_index_3: -0.61654139,
        composite_ital_3: 3.3098989,
      },
      geometry: { type: "Point", coordinates: [12.33611, 45.43806] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.438755,
        lng: 12.337036,
        name: "Giacomo Rizzo",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8321946-Reviews-Giacomo_Rizzo-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.16666667,
        diversity_index_3: -0.83333331,
        composite_ital_3: 2.7080503,
      },
      geometry: { type: "Point", coordinates: [12.33704, 45.43876] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.430386,
        lng: 12.331727,
        name: "Enoteca Al Gondolieri",
        numreviews: 65,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8326997-Reviews-Enoteca_Al_Gondolieri-Venice_Veneto.html",
        percent_ital: 0.07692308,
        diversity_index_2: 0.31584701,
        diversity_index_3: -0.68415296,
        composite_ital_3: 3.7174466,
      },
      geometry: { type: "Point", coordinates: [12.33173, 45.43039] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.436974,
        lng: 12.319798,
        name: "Grecia E Oriente",
        numreviews: 19,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8338897-Reviews-Grecia_E_Oriente-Venice_Veneto.html",
        percent_ital: 0.10526316,
        diversity_index_2: 0.66911763,
        diversity_index_3: -0.33088237,
        composite_ital_3: 2.6530871,
      },
      geometry: { type: "Point", coordinates: [12.3198, 45.43697] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: null,
        lat: 45.431999,
        lng: 12.320625,
        name: "Blu",
        numreviews: 4,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8340339-Reviews-Blu-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.16666667,
        diversity_index_3: -0.83333331,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32062, 45.432] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.428028,
        lng: 12.320638,
        name: "Il Cerchio",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8340344-Reviews-Il_Cerchio-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32064, 45.42803] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.437347,
        lng: 12.328026,
        name: "Osteria Al Ponte",
        numreviews: 96,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8340358-Reviews-Osteria_Al_Ponte-Venice_Veneto.html",
        percent_ital: 0.28125,
        diversity_index_2: 0.33871636,
        diversity_index_3: -0.66128361,
        composite_ital_3: 2.3511035,
      },
      geometry: { type: "Point", coordinates: [12.32803, 45.43735] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.434669,
        lng: 12.336514,
        name: "Olimpia Sprint",
        numreviews: 29,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8340360-Reviews-Olimpia_Sprint-Venice_Veneto.html",
        percent_ital: 0.24137931,
        diversity_index_2: 0.40692639,
        diversity_index_3: -0.59307361,
        composite_ital_3: 2.3205087,
      },
      geometry: { type: "Point", coordinates: [12.33651, 45.43467] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.433472,
        lng: 12.317715,
        name: "Snack Bar Ai Ragusei",
        numreviews: 15,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8341133-Reviews-Snack_Bar_Ai_Ragusei-Venice_Veneto.html",
        percent_ital: 0.66666669,
        diversity_index_2: 0.25,
        diversity_index_3: -0.75,
        composite_ital_3: 1.7917595,
      },
      geometry: { type: "Point", coordinates: [12.31771, 45.43347] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.43581,
        lng: 12.325634,
        name: "Idea Pizza",
        numreviews: 13,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8341214-Reviews-Idea_Pizza-Venice_Veneto.html",
        percent_ital: 0.61538464,
        diversity_index_2: 0.21428572,
        diversity_index_3: -0.78571427,
        composite_ital_3: 2.0259528,
      },
      geometry: { type: "Point", coordinates: [12.32563, 45.43581] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: null,
        lat: 45.443142,
        lng: 12.307499,
        name: "Ai Fioi",
        numreviews: 2,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8341272-Reviews-Ai_Fioi-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: null,
        diversity_index_3: null,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3075, 45.44314] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.437778,
        lng: 12.317902,
        name: "Due Ruote",
        numreviews: 22,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8341400-Reviews-Due_Ruote-Venice_Veneto.html",
        percent_ital: 0.31818181,
        diversity_index_2: 0.29523811,
        diversity_index_3: -0.70476186,
        composite_ital_3: 2.3651054,
      },
      geometry: { type: "Point", coordinates: [12.3179, 45.43778] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.445694,
        lng: 12.320057,
        name: "Trattoria Dalla Marisa",
        numreviews: 1032,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8360870-Reviews-Trattoria_Dalla_Marisa-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.37474334,
        diversity_index_3: -0.62525666,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32006, 45.44569] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.436176,
        lng: 12.324611,
        name: "Adriatico Mar",
        numreviews: 144,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8363261-Reviews-Adriatico_Mar-Venice_Veneto.html",
        percent_ital: 0.41666666,
        diversity_index_2: 0.36662108,
        diversity_index_3: -0.63337892,
        composite_ital_3: 1.8788952,
      },
      geometry: { type: "Point", coordinates: [12.32461, 45.43618] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.442516,
        lng: 12.323963,
        name: "Osteria Nova Bar Pizzeria",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8380973-Reviews-Osteria_Nova_Bar_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.47619048,
        diversity_index_3: -0.52380955,
        composite_ital_3: 1.8405496,
      },
      geometry: { type: "Point", coordinates: [12.32396, 45.44252] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.435658,
        lng: 12.343845,
        name: "Trattoria Ali d'Oro Pizzeria",
        numreviews: 580,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8388376-Reviews-Trattoria_Ali_d_Oro_Pizzeria-Venice_Veneto.html",
        percent_ital: 0.24137931,
        diversity_index_2: 0.39131591,
        diversity_index_3: -0.60868406,
        composite_ital_3: 2.3596258,
      },
      geometry: { type: "Point", coordinates: [12.34384, 45.43566] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.441471,
        lng: 12.327938,
        name: "Piccolo Bar",
        numreviews: 7,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8396129-Reviews-Piccolo_Bar-Venice_Veneto.html",
        percent_ital: 0.42857143,
        diversity_index_2: 0.60000001999999997,
        diversity_index_3: -0.39999997999999998,
        composite_ital_3: 1.3581234,
      },
      geometry: { type: "Point", coordinates: [12.32794, 45.44147] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.439808,
        lng: 12.339174,
        name: "Antichita",
        numreviews: 17,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8440830-Reviews-Antichita-Venice_Veneto.html",
        percent_ital: 0.05882353,
        diversity_index_2: 0.30833334,
        diversity_index_3: -0.69166666,
        composite_ital_3: 4.0097871,
      },
      geometry: { type: "Point", coordinates: [12.33917, 45.43981] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.43277,
        lng: 12.324265,
        name: "Pane Vino E San Daniele Sanbarnaba",
        numreviews: 286,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8445839-Reviews-Pane_Vino_E_San_Daniele_Sanbarnaba-Venice_Veneto.html",
        percent_ital: 0.23776224,
        diversity_index_2: 0.43017849,
        diversity_index_3: -0.56982148,
        composite_ital_3: 2.2800391,
      },
      geometry: { type: "Point", coordinates: [12.32427, 45.43277] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440025,
        lng: 12.330575,
        name: "Bacarretto Bistrot. Il Siciliano",
        numreviews: 483,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8452770-Reviews-Bacarretto_Bistrot_Il_Siciliano-Venice_Veneto.html",
        percent_ital: 0.36853004,
        diversity_index_2: 0.38945305,
        diversity_index_3: -0.61054695,
        composite_ital_3: 1.941245,
      },
      geometry: { type: "Point", coordinates: [12.33057, 45.44002] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.435627,
        lng: 12.34596,
        name: "Local",
        numreviews: 655,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8491173-Reviews-Local-Venice_Veneto.html",
        percent_ital: 0.32366413,
        diversity_index_2: 0.45839599,
        diversity_index_3: -0.54160404,
        composite_ital_3: 1.9080708,
      },
      geometry: { type: "Point", coordinates: [12.34596, 45.43563] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.426525,
        lng: 12.341653,
        name: "Ristorante Porticciolo",
        numreviews: 9,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8495102-Reviews-Ristorante_Porticciolo-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.77777779,
        diversity_index_3: -0.22222221,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34165, 45.42652] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.433235,
        lng: 12.326994,
        name: "Niki Bar",
        numreviews: 70,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8537545-Reviews-Niki_Bar-Venice_Veneto.html",
        percent_ital: 0.25714287,
        diversity_index_2: 0.54934686,
        diversity_index_3: -0.45065314,
        composite_ital_3: 1.9571487,
      },
      geometry: { type: "Point", coordinates: [12.32699, 45.43324] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.432613,
        lng: 12.323915,
        name: "Basara - Sushi Pasticceria",
        numreviews: 373,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8558172-Reviews-Basara_Sushi_Pasticceria-Venice_Veneto.html",
        percent_ital: 0.67292225,
        diversity_index_2: 0.32782584,
        diversity_index_3: -0.67217416,
        composite_ital_3: 1.5113982,
      },
      geometry: { type: "Point", coordinates: [12.32391, 45.43261] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.437782,
        lng: 12.335093,
        name: "Ristorante Terrazza Sommariva",
        numreviews: 834,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d858460-Reviews-Ristorante_Terrazza_Sommariva-Venice_Veneto.html",
        percent_ital: 0.22781774,
        diversity_index_2: 0.37201586,
        diversity_index_3: -0.62798417,
        composite_ital_3: 2.4680281,
      },
      geometry: { type: "Point", coordinates: [12.33509, 45.43778] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.44532,
        lng: 12.332135,
        name: "Il Giardino Segreto",
        numreviews: 29,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8599906-Reviews-Il_Giardino_Segreto-Venice_Veneto.html",
        percent_ital: 0.31034482,
        diversity_index_2: 0.55789477,
        diversity_index_3: -0.44210523,
        composite_ital_3: 1.7536561,
      },
      geometry: { type: "Point", coordinates: [12.33213, 45.44532] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434566,
        lng: 12.345832,
        name: "Cantina Schiavoni",
        numreviews: 81,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8672561-Reviews-Cantina_Schiavoni-Venice_Veneto.html",
        percent_ital: 0.41975307,
        diversity_index_2: 0.28163266,
        diversity_index_3: -0.71836734,
        composite_ital_3: 2.1352403,
      },
      geometry: { type: "Point", coordinates: [12.34583, 45.43457] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.441219,
        lng: 12.337564,
        name: "Bar Stella Polare",
        numreviews: 41,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8706895-Reviews-Bar_Stella_Polare-Venice_Veneto.html",
        percent_ital: 0.29268292,
        diversity_index_2: 0.49885058,
        diversity_index_3: -0.50114942,
        composite_ital_3: 1.9241141,
      },
      geometry: { type: "Point", coordinates: [12.33756, 45.44122] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$",
        lat: 45.432381,
        lng: 12.355504,
        name: "Da Valentino",
        numreviews: 57,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8779179-Reviews-Da_Valentino-Venice_Veneto.html",
        percent_ital: 0.24561404,
        diversity_index_2: 0.33298096,
        diversity_index_3: -0.66701901,
        composite_ital_3: 2.5036638,
      },
      geometry: { type: "Point", coordinates: [12.3555, 45.43238] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$ - $$$",
        lat: 45.434586,
        lng: 12.346984,
        name: "Osteria Alla Bandiera",
        numreviews: 267,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8779534-Reviews-Osteria_Alla_Bandiera-Venice_Veneto.html",
        percent_ital: 0.19101124,
        diversity_index_2: 0.35403544,
        diversity_index_3: -0.64596456,
        composite_ital_3: 2.6937814,
      },
      geometry: { type: "Point", coordinates: [12.34698, 45.43459] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.435902,
        lng: 12.325164,
        name: "La Bottega del Gusto",
        numreviews: 15,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8812719-Reviews-La_Bottega_del_Gusto-Venice_Veneto.html",
        percent_ital: 0.33333334,
        diversity_index_2: 0.23636363,
        diversity_index_3: -0.76363635,
        composite_ital_3: 2.5409961,
      },
      geometry: { type: "Point", coordinates: [12.32516, 45.4359] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 1.5,
        dollarsigns: "$$ - $$$",
        lat: 45.434658,
        lng: 12.337745,
        name: "Mobiliare Veneta",
        numreviews: 25,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8817360-Reviews-Mobiliare_Veneta-Venice_Veneto.html",
        percent_ital: 0.16,
        diversity_index_2: 0.48095238,
        diversity_index_3: -0.51904762,
        composite_ital_3: 2.5645685,
      },
      geometry: { type: "Point", coordinates: [12.33774, 45.43466] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.433331,
        lng: 12.325235,
        name: "Doge Morosini",
        numreviews: 31,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d8867480-Reviews-Doge_Morosini-Venice_Veneto.html",
        percent_ital: 0.38709676,
        diversity_index_2: 0.25789472,
        diversity_index_3: -0.74210525,
        composite_ital_3: 2.3042843,
      },
      geometry: { type: "Point", coordinates: [12.32523, 45.43333] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439411,
        lng: 12.336488,
        name: "Taverna Al Remer",
        numreviews: 1625,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d911605-Reviews-Taverna_Al_Remer-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.41596559,
        diversity_index_3: -0.58403444,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33649, 45.43941] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: null,
        lat: 45.436214,
        lng: 12.338239,
        name: "Punto Pizza Di Khokom Kazi",
        numreviews: 5,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9150153-Reviews-Punto_Pizza_Di_Khokom_Kazi-Venice_Veneto.html",
        percent_ital: 0.40000001000000002,
        diversity_index_2: 0.5,
        diversity_index_3: -0.5,
        composite_ital_3: 1.6094379,
      },
      geometry: { type: "Point", coordinates: [12.33824, 45.43621] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.439651,
        lng: 12.337384,
        name: "Trattoria Tre Spiedi",
        numreviews: 732,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d939666-Reviews-Trattoria_Tre_Spiedi-Venice_Veneto.html",
        percent_ital: 0.29644808,
        diversity_index_2: 0.3340961,
        diversity_index_3: -0.66590393,
        composite_ital_3: 2.3122098,
      },
      geometry: { type: "Point", coordinates: [12.33738, 45.43965] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$$$",
        lat: 45.436317,
        lng: 12.3354,
        name: "Al Colombo",
        numreviews: 742,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d942395-Reviews-Al_Colombo-Venice_Veneto.html",
        percent_ital: 0.30458221,
        diversity_index_2: 0.39252493,
        diversity_index_3: -0.60747504,
        composite_ital_3: 2.1239696,
      },
      geometry: { type: "Point", coordinates: [12.3354, 45.43632] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$$$",
        lat: 45.434162,
        lng: 12.345276,
        name: "Met Restaurant",
        numreviews: 391,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d943624-Reviews-Met_Restaurant-Venice_Veneto.html",
        percent_ital: 0.22762148,
        diversity_index_2: 0.43707937,
        diversity_index_3: -0.56292063,
        composite_ital_3: 2.3077116,
      },
      geometry: { type: "Point", coordinates: [12.34528, 45.43416] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$$$$",
        lat: 45.435493,
        lng: 12.339252,
        name: "Ristorante Do Forni",
        numreviews: 1763,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d945325-Reviews-Ristorante_Do_Forni-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.4293853,
        diversity_index_3: -0.5706147,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.33925, 45.43549] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$$ - $$$",
        lat: 45.433723,
        lng: 12.3253,
        name: "Trattoria Da Fiore",
        numreviews: 1070,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d945326-Reviews-Trattoria_Da_Fiore-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.40790206,
        diversity_index_3: -0.59209794,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.3253, 45.43372] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$$$",
        lat: 45.435585,
        lng: 12.345493,
        name: "Osteria Oliva Nera",
        numreviews: 1419,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d945327-Reviews-Osteria_Oliva_Nera-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.59491044,
        diversity_index_3: -0.40508956,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.34549, 45.43559] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.437931,
        lng: 12.327066,
        name: "La Bottiglia - Local Street Food",
        numreviews: 1104,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9457625-Reviews-La_Bottiglia_Local_Street_Food-Venice_Veneto.html",
        percent_ital: null,
        diversity_index_2: 0.34387219,
        diversity_index_3: -0.65612781,
        composite_ital_3: null,
      },
      geometry: { type: "Point", coordinates: [12.32707, 45.43793] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.438522,
        lng: 12.335703,
        name: "Al Pesador",
        numreviews: 591,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d945774-Reviews-Al_Pesador-Venice_Veneto.html",
        percent_ital: 0.43147209,
        diversity_index_2: 0.40152904,
        diversity_index_3: -0.59847093,
        composite_ital_3: 1.7530279,
      },
      geometry: { type: "Point", coordinates: [12.3357, 45.43852] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.0,
        dollarsigns: "$$ - $$$",
        lat: 45.440872,
        lng: 12.334941,
        name: "Osteria al Bomba",
        numreviews: 167,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d946634-Reviews-Osteria_al_Bomba-Venice_Veneto.html",
        percent_ital: 0.62275451,
        diversity_index_2: 0.50644839,
        diversity_index_3: -0.49355161,
        composite_ital_3: 1.1539357,
      },
      geometry: { type: "Point", coordinates: [12.33494, 45.44087] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.0,
        dollarsigns: "$",
        lat: 45.437542,
        lng: 12.333038,
        name: "H2 NO",
        numreviews: 73,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9570674-Reviews-H2_NO-Venice_Veneto.html",
        percent_ital: 0.60273975,
        diversity_index_2: 0.35698923,
        diversity_index_3: -0.64301074,
        composite_ital_3: 1.5363194,
      },
      geometry: { type: "Point", coordinates: [12.33304, 45.43754] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.5,
        dollarsigns: "$$ - $$$",
        lat: 45.440491,
        lng: 12.335934,
        name: "Zikiya",
        numreviews: 628,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9597062-Reviews-Zikiya-Venice_Veneto.html",
        percent_ital: 0.36146498,
        diversity_index_2: 0.40130791,
        diversity_index_3: -0.59869206,
        composite_ital_3: 1.9306165,
      },
      geometry: { type: "Point", coordinates: [12.33593, 45.44049] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 2.5,
        dollarsigns: "$$ - $$$",
        lat: 45.441654,
        lng: 12.323259,
        name: "Caffe Ristorante Roma",
        numreviews: 342,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9709710-Reviews-Caffe_Ristorante_Roma-Venice_Veneto.html",
        percent_ital: 0.14619882,
        diversity_index_2: 0.38195074,
        diversity_index_3: -0.61804926,
        composite_ital_3: 2.8852513,
      },
      geometry: { type: "Point", coordinates: [12.32326, 45.44165] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 5.0,
        dollarsigns: "$",
        lat: 45.445663,
        lng: 12.328211,
        name: "Baccaretto Dai Morosi",
        numreviews: 6,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9731853-Reviews-Baccaretto_Dai_Morosi-Venice_Veneto.html",
        percent_ital: 0.83333331,
        diversity_index_2: 1.0,
        diversity_index_3: 0.0,
        composite_ital_3: 0.18232158,
      },
      geometry: { type: "Point", coordinates: [12.32821, 45.44566] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.441257,
        lng: 12.321356,
        name: "Autogrill",
        numreviews: 30,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9739344-Reviews-Autogrill-Venice_Veneto.html",
        percent_ital: 0.69999999000000002,
        diversity_index_2: 0.17948718,
        diversity_index_3: -0.82051283,
        composite_ital_3: 2.0743263,
      },
      geometry: { type: "Point", coordinates: [12.32136, 45.44126] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$",
        lat: 45.426018,
        lng: 12.336363,
        name: "Bar da Monica",
        numreviews: 72,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9792625-Reviews-Bar_da_Monica-Venice_Veneto.html",
        percent_ital: 0.55555558,
        diversity_index_2: 0.33143941,
        diversity_index_3: -0.66856062,
        composite_ital_3: 1.6920969,
      },
      geometry: { type: "Point", coordinates: [12.33636, 45.42602] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 4.5,
        dollarsigns: "$$ - $$$",
        lat: 45.426422,
        lng: 12.32623,
        name: "Majer",
        numreviews: 332,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9873176-Reviews-Majer-Venice_Veneto.html",
        percent_ital: 0.28915662,
        diversity_index_2: 0.4390313,
        diversity_index_3: -0.5609687,
        composite_ital_3: 2.0639713,
      },
      geometry: { type: "Point", coordinates: [12.32623, 45.42642] },
    },
    {
      type: "Feature",
      properties: {
        averagerating: 3.0,
        dollarsigns: "$",
        lat: 45.432323,
        lng: 12.329741,
        name: "Snack Bar San Vidal",
        numreviews: 71,
        url:
          "https://www.tripadvisor.com/Restaurant_Review-g187870-d9879369-Reviews-Snack_Bar_San_Vidal-Venice_Veneto.html",
        percent_ital: 0.1971831,
        diversity_index_2: 0.32437173,
        diversity_index_3: -0.6756283,
        composite_ital_3: 2.7494876,
      },
      geometry: { type: "Point", coordinates: [12.32974, 45.43232] },
    },
  ],
};
